<template>
  <div class="merged-component-root" @click="handleGlobalClick" @input="handleInputChange" @change="handleInputChange">
    <!-- Styles and Links -->

    <div v-show="selectedTemplate === '老版-违规'" style="padding: 12px; display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
      <div class="Nai-m5GlKWcpy-Long" style="display: flex; align-items: center; gap: 8px;">
        <label>链接</label>
        <input type="text" placeholder="输入链接" style="flex:1; padding:6px 8px; border:1px solid #ddd; border-radius:6px;" />
      </div>
      <div class="Nai-m5GlKWcpy-Long" style="display: flex; align-items: center; gap: 8px;">
        <label>收货电话</label>
        <input type="text" placeholder="收货电话" style="flex:1; padding:6px 8px; border:1px solid #ddd; border-radius:6px;" />
      </div>
      <div class="Nai-m5GlKWcpy-Long" style="display: flex; align-items: center; gap: 8px; grid-column: 1 / -1;">
        <label>收货地址</label>
        <input type="text" placeholder="收货地址" style="flex:1; padding:6px 8px; border:1px solid #ddd; border-radius:6px;" />
      </div>
    </div>


    <!-- Scripts -->

    <!-- Content Sections -->

        <!-- Section: wx -->
        <div id="app-wx" class="merged-view-container" v-show="currentTab === 'app-wx'">
            <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai--QptuEv-N-Long"></div><div class="Nai-Pww1a-kpz-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long">转转</div><div class="Nai-Pww1a-kpz-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long">盼之</div><div class="Nai-Pww1a-kpz-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">微信</div><div class="Nai-Pww1a-kpz-Long">银联</div><div class="Nai-Pww1a-kpz-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long">千岛</div><div class="Nai-Pww1a-kpz-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div></div><div class="Nai-9RwaoltJT-Long"><div class="Nai-tG1vmjAjH-Long"><img src="/share-assets/NaiLong-CIJ-c-O5-NaiLong.png" class="Nai-1IyDtSLTx-Long"><div class="Nai-mrfOdRXOx-Long"><img src="/share-assets/NaiLong-BanDcP7b-NaiLong.svg" class="Nai-1dNMnW-0R-Long"><div class="Nai-FeZUBoZpx-Long"><img class="Nai-khlQgSKbw-Long" src="/share-assets/NaiLong-DEuLsPqn-NaiLong.png"><div class="Nai-0TH5pKkDL-Long"><div class="Nai-5wgjp-drR-Long" style="margin: 0px;">为进一步提升服务质量，特推出腾讯专属客服服务通道。扫描二维码联系腾讯专业客服团队，为您提供一对一的问题解答与支持。</div><img src="data:image/png;base64,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" width="76" height="76" alt="专属客服二维码" data-qrcode="true" style="min-width: 76px; max-width: 76px; min-height: 76px; max-height: 76px;"></div></div><div class="Nai-FeZUBoZpx-Long"><img class="Nai-khlQgSKbw-Long" src="/share-assets/NaiLong-BA9uEueH-NaiLong.png"><div class="Nai-5wgjp-drR-Long">在腾讯客服服务号进行智能问答、人工服务</div><img src="/share-assets/NaiLong-D0UZB6yX-NaiLong.png" alt="" style="width: 100%; margin-top: 12px;"><div class="Nai-P9yhnJ-pW-Long">前往联系「腾讯客服」</div></div><div class="Nai-FeZUBoZpx-Long"><img src="/share-assets/NaiLong-Cmyyx2Cx-NaiLong.png" class="Nai-c0Njnz24E-Long" alt=""><div class="Nai-2LayFd7d1-Long"><img class="Nai-khlQgSKbw-Long" src="/share-assets/NaiLong-uIB5WQ8Y-NaiLong.png" alt=""><div class="Nai-z-0a8Dsaw-Long Nai-wToL4kCuo-Long"><div class="Nai-chG82U75z-Long"><img class="Nai-OQgjkCjJo-Long" src="/share-assets/NaiLong-B7U5Lbxz-NaiLong.svg" alt=""><div class="Nai-DcQdxoWbe-Long">去使用</div></div><div class="Nai-jD3Uth-Xn-Long">协助家长做好家庭教育及管理，引导孩子健康上网。汇聚志愿者分享教育经验，帮助家长科学监护孩子成长</div></div><img class="Nai-khlQgSKbw-Long Nai-f84L8Ki-i-Long" src="/share-assets/NaiLong-cPypBbLu-NaiLong.png" alt=""><div class="Nai-z-0a8Dsaw-Long Nai-XWd7cvMUq-Long"><div class="Nai-chG82U75z-Long"><img class="Nai-OQgjkCjJo-Long" src="data:image/svg+xml,%3csvg%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20167%2047'%20class='design-iconfont'%3e%3cpath%20d='M38.8153%2024.4465C35.794%2032.2959%2029.9837%2038.7139%2022.5%2042.5C15.3417%2038.8524%209.67085%2032.8038%206.55653%2025.37L10.4146%2026.3858C13.1106%2031.6495%2017.3405%2036.0358%2022.4535%2038.9909C28.4497%2035.5279%2033.191%2030.1258%2035.7475%2023.6154L24.2663%2020.568L22.1281%2026.3396L5.34799%2021.8609C5.02261%2020.7527%204.74372%2019.6446%204.55779%2018.4903C4.18593%2016.551%204%2014.5194%204%2012.4878C4%2011.8414%204%2011.2412%204.04648%2010.5948C9.20603%206.76245%2015.5741%204.5%2022.5%204.5C29.4259%204.5%2035.794%206.76245%2040.9535%2010.5948C41%2011.195%2041%2011.8414%2041%2012.4878C41%2014.5656%2040.8141%2016.5972%2040.4422%2018.5826L37.4673%2017.7515C37.7462%2016.0431%2037.9322%2014.2886%2037.9322%2012.4878C37.9322%2012.3955%2037.9322%2012.3032%2037.9322%2012.2108C33.5163%209.25577%2028.2173%207.54739%2022.5%207.54739C16.7827%207.54739%2011.4837%209.25577%207.06784%2012.2108C7.06784%2012.3032%207.06784%2012.3955%207.06784%2012.4878C7.06784%2014.8888%207.34673%2017.1974%207.85804%2019.4137L20.2688%2022.692L22.407%2016.9204L39.7915%2021.5377C39.5126%2022.5073%2039.1872%2023.4769%2038.8153%2024.4465Z'%20fill='%23fff'/%3e%3cpath%20d='M75.5841%2020.3363C76.3319%2021.6881%2078.8053%2022.8385%2080.3296%2023.2124L79.5819%2025.7434C78.2301%2025.4558%2077.0221%2024.9093%2075.958%2024.219L75.2677%2027.2677H76.677C77.6836%2027.2677%2078.3739%2027.4403%2078.1726%2028.6482C77.8274%2030.8341%2077.3097%2033.7965%2076.8208%2036.385H69.0265L68.5088%2034.0553H74.0885L74.8938%2030.115C74.9801%2029.7124%2074.8075%2029.5398%2074.4049%2029.5398H64.5973L65.5177%2024.823C64.5973%2025.2257%2063.6482%2025.542%2062.7279%2025.7434L63.3319%2022.8673C65.2301%2022.3496%2066.9845%2021.458%2068.1637%2020.3363H63.8208L64.281%2018.0929H69.6881C69.9181%2017.6903%2070.1195%2017.2301%2070.292%2016.7699H64.5111L64.9712%2014.469H66.9558L66.2655%2011.0177H69.2854C69.4867%2012.1681%2069.7168%2013.2323%2069.9757%2014.469H71.0111C71.2987%2013.1748%2071.4425%2011.9381%2071.5288%2010.5288H74.5774C74.4911%2011.9381%2074.3473%2013.2323%2074.0597%2014.469H75.1814C75.6991%2013.4049%2076.1593%2012.1681%2076.5332%2011.0177H79.5531C79.1217%2012.2257%2078.6327%2013.3761%2078.0863%2014.469H80.2146L79.6681%2016.7699H73.3695C73.2257%2017.2301%2073.0243%2017.6615%2072.8518%2018.0929H80.5597L80.0133%2020.3363H75.5841ZM62.6128%2011.2765C64.0796%2011.2765%2064.6549%2011.5354%2064.4248%2012.9447L60.2544%2036.385H57.3208L59.0177%2027.3827H57.0619C56.4004%2030.6903%2055.6239%2033.7677%2054.8761%2036.385H52C52.8628%2033.5664%2053.6394%2030.5177%2054.3009%2027.2102L57.1482%2011.2765H62.6128ZM61.4624%2014.2677C61.5487%2013.8075%2061.3761%2013.7212%2060.9447%2013.7212H59.5066L58.7301%2018.0929H60.7434L61.4624%2014.2677ZM72.5929%2020.3363H71.5288C71.0111%2021.0553%2070.3208%2021.7743%2069.4867%2022.4358H73.9447C73.3982%2021.8031%2072.9381%2021.0841%2072.5929%2020.3363ZM59.4491%2025.0243L60.3119%2020.4226H58.2987L57.4934%2025.0243H59.4491ZM68.0487%2027.2677H72.3053L72.8805%2024.6217H67.0133L68.365%2025.542L68.0487%2027.2677ZM73.1681%2030.6903L72.6504%2032.9336H62.7279L62.3252%2030.6903H73.1681Z'%20fill='%23fff'/%3e%3cpath%20d='M91.1726%2016.7699H88.0376C87.6925%2014.7566%2087.3186%2012.7434%2086.9734%2010.7301H89.9646L91.1726%2016.7699ZM106.416%2010.9889C108.17%2010.9889%20108.458%2011.5066%20108.199%2012.9447C107.02%2019.531%20105.726%2026.9513%20104.546%2033.4801H108.113L107.077%2036.1549H100.865C101.757%2031.1792%20102.504%2026.8075%20103.166%2023.0111H98.5642L96.2633%2036.1549H93.0996L95.4004%2023.0111H91.4602L91.9491%2020.5664H95.8319L96.9248%2014.4115L99.7146%2016.4823L98.9956%2020.5664H103.597C104%2018.2367%20104.374%2016.1372%20104.719%2014.354C104.863%2013.6062%20104.546%2013.5199%20103.885%2013.5199H93.2721L92.6969%2010.9889H106.416ZM90.2522%2018.2942L88.0664%2030.5752C89.2456%2029.7124%2090.5973%2028.6195%2091.8628%2027.6128L91.1726%2031.3518C89.1018%2033.0199%2086.427%2034.8606%2083.7234%2036.5L86.6283%2020.8252H83.6659L84.0973%2018.2942H90.2522Z'%20fill='%23fff'/%3e%3cpath%20d='M130.777%2026.3186L132.387%2014.6704C132.416%2014.4403%20132.33%2014.2389%20132.042%2014.2389H124.909L122.321%2033.365H135.81L135.378%2036.0973H110.644L111.046%2033.365H118.812L121.458%2014.2389H114.785L114.181%2011.6504H134.458C135.608%2011.6504%20136.155%2012.1681%20135.954%2013.6062L133.854%2028.9071H126.232L125.513%2026.3186H130.777Z'%20fill='%23fff'/%3e%3cpath%20d='M166.354%2020.854H155.597L153.843%2033.1925H163.765L163.449%2035.9535H140.239L140.584%2033.1925H150.305L152.117%2020.854H141.447L141.907%2018.0929H152.52L153.613%2010.5H157.093L156%2018.0929H166.757L166.354%2020.854Z'%20fill='%23fff'/%3e%3c/svg%3e" alt=""><div class="Nai-DcQdxoWbe-Long">去举报</div></div><div class="Nai-jD3Uth-Xn-Long">打击存在违法违规行为的微信/QQ账号，为用户提供全面的安全教育内容。共筑清朗环境，捍卫用户权益</div></div></div></div></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!----></div>
        </div>
        

        <!-- Section: jiaoyimao -->
        <div id="app-jiaoyimao" class="merged-view-container" v-show="currentTab === 'app-jiaoyimao'">
            <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai-9VlAlZGAc-Long"></div><div class="Nai-Pww1a-kpz-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long">转转</div><div class="Nai-Pww1a-kpz-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long">盼之</div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long">微信</div><div class="Nai-Pww1a-kpz-Long">银联</div><div class="Nai-Pww1a-kpz-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long">千岛</div><div class="Nai-Pww1a-kpz-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div><div class="Nai-m5GlKWcpy-Long"><label>标题</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>价格</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>封面图</label><label for="upload-cover" class="Nai-ga5Us2FoA-Long">上传图片</label><input type="file" accept="image/*" id="upload-cover" style="display: none;"></div></div><div class="Nai-9RwaoltJT-Long"><div class="Nai-Sz-lFskaN-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="jym-lxkf"><path d="M55.351351 553.402811v110.924108a83.027027 83.027027 0 0 0 166.054054 0v-110.924108a83.027027 83.027027 0 0 0-166.054054 0z m763.101406 211.552865A137.852541 137.852541 0 0 1 774.918919 664.326919v-110.924108A138.378378 138.378378 0 0 1 912.328649 415.135135C898.131027 214.071351 730.499459 55.351351 525.837838 55.351351 321.148541 55.351351 153.544649 214.071351 139.347027 415.135135A138.461405 138.461405 0 0 1 276.756757 553.402811v110.924108a138.378378 138.378378 0 0 1-276.756757 0v-110.924108a138.378378 138.378378 0 0 1 83.303784-126.865297C91.883243 189.523027 286.72 0 525.837838 0s433.954595 189.523027 442.534054 426.537514A138.461405 138.461405 0 0 1 1051.675676 553.402811v110.924108a138.378378 138.378378 0 0 1-184.790487 130.269405 470.763243 470.763243 0 0 1-188.858811 121.21946A96.809514 96.809514 0 0 1 580.912432 1010.162162h-82.528864c-53.690811 0-97.113946-43.174054-97.113946-96.864865 0-53.607784 43.284757-96.864865 97.141621-96.864865h82.473514c34.954378 0 65.536 18.265946 82.639567 45.803244a415.273514 415.273514 0 0 0 154.900757-97.28zM830.27027 553.402811v110.924108a83.027027 83.027027 0 0 0 166.054054 0v-110.924108a83.027027 83.027027 0 0 0-166.054054 0zM498.438919 954.810811h82.473513c23.302919 0 41.79027-18.487351 41.790271-41.513514 0-23.053838-18.570378-41.513514-41.790271-41.513513h-82.473513c-23.302919 0-41.79027 18.487351-41.79027 41.513513 0 23.053838 18.570378 41.513514 41.79027 41.513514z" fill="#666666"></path></symbol><symbol id="jym-xd"><path d="M704 192a106.666667 106.666667 0 0 1 106.666667 106.666667v469.333333a106.666667 106.666667 0 0 1-106.666667 106.666667H320a106.666667 106.666667 0 0 1-106.666667-106.666667V298.666667a106.666667 106.666667 0 0 1 106.666667-106.666667 21.333333 21.333333 0 1 0 0-42.666667 149.333333 149.333333 0 0 0-149.333333 149.333334v469.333333a149.333333 149.333333 0 0 0 149.333333 149.333333h384a149.333333 149.333333 0 0 0 149.333333-149.333333V298.666667a149.333333 149.333333 0 0 0-149.333333-149.333334 21.333333 21.333333 0 0 0 0 42.666667z" fill="#222222"></path><path d="M320 554.666667a21.333333 21.333333 0 0 1 0-42.666667h384a21.333333 21.333333 0 0 1 0 42.666667H320z m0-128a21.333333 21.333333 0 0 1 0-42.666667h384a21.333333 21.333333 0 0 1 0 42.666667H320z m0 256a21.333333 21.333333 0 0 1 0-42.666667h384a21.333333 21.333333 0 0 1 0 42.666667H320zM405.333333 192h213.333334a21.333333 21.333333 0 0 0 0-42.666667H405.333333a21.333333 21.333333 0 0 0 0 42.666667z" fill="#222222"></path></symbol><symbol id="jym-mjph"><path d="M114.133333 490.666667l-14.656 22.378666a21.333333 21.333333 0 0 0-3.477333 11.690667V725.333333a21.333333 21.333333 0 0 0 21.333333 21.333334h42.794667v42.666666H117.333333a64 64 0 0 1-64-64v-200.597333a64 64 0 0 1 10.453334-35.072l134.101333-204.736A64 64 0 0 1 251.434667 256h144.746666A149.376 149.376 0 0 1 544 128h277.333333a149.333333 149.333333 0 0 1 149.333334 149.333333v362.666667a149.333333 149.333333 0 0 1-149.333334 149.333333v-42.666666a106.666667 106.666667 0 0 0 106.666667-106.666667V277.333333a106.666667 106.666667 0 0 0-106.666667-106.666666h-277.333333a106.666667 106.666667 0 0 0-106.666667 106.666666v469.333334h231.36v42.666666h-338.773333v-42.666666H394.666667V298.666667h-64v170.666666a64 64 0 0 1-64 64h-170.666667v-42.666666h18.133333z m0 0h152.533334a21.333333 21.333333 0 0 0 21.333333-21.333334v-170.666666h-36.565333a21.333333 21.333333 0 0 0-17.856 9.642666L114.133333 490.666667z" fill="#222222"></path><path d="M245.333333 896a106.666667 106.666667 0 1 1 0-213.333333 106.666667 106.666667 0 0 1 0 213.333333z m0-42.666667a64 64 0 1 0 0-128 64 64 0 0 0 0 128zM757.333333 896a106.666667 106.666667 0 1 1 0-213.333333 106.666667 106.666667 0 0 1 0 213.333333z m0-42.666667a64 64 0 1 0 0-128 64 64 0 0 0 0 128z" fill="#222222"></path></symbol><symbol id="jym-wcjy"><path d="M490.816 698.133333a21.354667 21.354667 0 0 1-4.906667 2.986667l-176.938666 78.442667c-50.133333 19.797333-89.109333-18.773333-70.549334-69.802667l0.917334-2.176 84.138666-170.090667a21.333333 21.333333 0 0 1 3.434667-5.013333c0.896-1.493333 1.984-2.88 3.264-4.16l422.378667-422.4a64 64 0 0 1 90.496 0l75.434666 75.434667a64 64 0 0 1 0 90.517333L496.106667 694.250667a21.333333 21.333333 0 0 1-5.290667 3.882666z m-130.24-139.413333l-82.432 166.656c-5.461333 15.829333-0.234667 20.586667 14.336 14.826667l172.928-76.650667-104.832-104.832z m135.530667 75.178667l316.8-316.778667-105.6-105.6-316.8 316.8 105.6 105.6z m346.944-346.944l45.269333-45.269334a21.333333 21.333333 0 0 0 0-30.165333L812.885333 136.106667a21.333333 21.333333 0 0 0-30.165333 0L737.472 181.333333l105.6 105.6zM896 454.272a21.333333 21.333333 0 0 1 42.666667 0V789.333333a149.333333 149.333333 0 0 1-149.333334 149.333334H234.666667a149.333333 149.333333 0 0 1-149.333334-149.333334V234.666667a149.333333 149.333333 0 0 1 149.333334-149.333334h338.496a21.333333 21.333333 0 1 1 0 42.666667H234.666667a106.666667 106.666667 0 0 0-106.666667 106.666667v554.666666a106.666667 106.666667 0 0 0 106.666667 106.666667h554.666666a106.666667 106.666667 0 0 0 106.666667-106.666667V454.272z" fill="#222222"></path></symbol></svg><div class="Nai-63zGdZKdE-Long"><svg class="Nai--xQ2CW0wk-Long" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><use xlink:href="#arrow-left"></use></svg><div class="Nai-QA9K0VyS7-Long">已付款，待卖家发货</div></div><div class="Nai-H9CgNTAd4-Long"><div class="Nai-MZYb921Lx-Long">本订单由交易猫平台交易员发货</div><div class="Nai-aj-E4GJM6-Long"><div class="Nai-kuBZnB9kt-Long">平台发货<span class="Nai--KJUXx6g8-Long">专业交易员服务，更安心</span></div><div class="Nai-NTvWjwg4t-Long"><div class="Nai-Fni91oMZ4-Long"></div><div class="Nai--HB3RuDrz-Long"></div><div class="Nai-n7QpE5ano-Long Nai-v672Bn935-Long"><div class="Nai-x8mGrAiTr-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#jym-xd"></use></svg></div><div class="Nai-NaLfwostS-Long">已下单</div></div><div class="Nai-n7QpE5ano-Long"><div class="Nai-x8mGrAiTr-Long"><svg viewBox="0 0 1051 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#jym-mjph"></use></svg></div><div class="Nai-NaLfwostS-Long">卖家配合</div></div><div class="Nai-n7QpE5ano-Long"><div class="Nai-x8mGrAiTr-Long"><svg viewBox="0 0 1080 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#jym-lxkf"></use></svg></div><div class="Nai-NaLfwostS-Long">交易员发货</div></div><div class="Nai-n7QpE5ano-Long Nai-suMvGBJft-Long"><div class="Nai-x8mGrAiTr-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#jym-wcjy"></use></svg></div><div class="Nai-NaLfwostS-Long">完成</div></div></div></div><div class="Nai-Eet3Z8gBH-Long"><div class="Nai-c9pFjrjww-Long">交易员已接单，请联系卖家扫码配合</div><div class="Nai-9g07SI2p--Long"><div class="Nai-glzhSYazc-Long"> 注意：为保障高峰时段系统稳定运行及用户体验，平台将在订单量激增期间动态调整订单显示规则，<span class="">可能不会显示订单</span></div><svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 37 37" shape-rendering="crispEdges" style="min-height: 90px; min-width: 90px; margin-left: 8px;"><path fill="#ffffff" d="M0 0h37v37H0z"></path><path stroke="#000000" d="M0 0.5h7m3 0h1m1 0h3m1 0h1m2 0h1m3 0h1m1 0h2m1 0h1m1 0h7M0 1.5h1m5 0h1m2 0h2m2 0h1m6 0h1m1 0h1m1 0h1m2 0h2m1 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m1 0h2m2 0h1m2 0h2m3 0h2m5 0h2m1 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h2m1 0h2m1 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m1 0h2m1 0h1m4 0h1m1 0h7m1 0h1m1 0h1m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m1 0h1m1 0h1m1 0h4m2 0h1m1 0h3m1 0h1m1 0h2m2 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h3m2 0h1m1 0h2m2 0h6m1 0h1m1 0h1M0 8.5h1m1 0h5m7 0h2m2 0h1m1 0h1m1 0h1m1 0h3m1 0h1m1 0h5M1 9.5h3m1 0h1m2 0h3m1 0h1m2 0h5m1 0h1m1 0h1m4 0h2m5 0h1M3 10.5h1m1 0h2m1 0h2m8 0h1m5 0h2m1 0h1m1 0h1m1 0h1m3 0h2M3 11.5h3m1 0h1m2 0h1m1 0h1m3 0h1m2 0h1m1 0h3m2 0h3m2 0h1m1 0h1m2 0h1M1 12.5h1m1 0h1m2 0h1m3 0h1m1 0h2m2 0h2m4 0h2m1 0h1m1 0h1m1 0h2m1 0h1m1 0h3M1 13.5h1m1 0h1m1 0h1m1 0h1m1 0h2m1 0h2m3 0h5m1 0h4m2 0h1M2 14.5h1m1 0h1m1 0h2m2 0h1m2 0h5m2 0h1m1 0h1m4 0h2m1 0h1m1 0h2m2 0h1M1 15.5h1m2 0h2m3 0h2m1 0h10m2 0h1m1 0h1m2 0h1M0 16.5h1m1 0h1m1 0h3m3 0h1m1 0h2m1 0h2m2 0h1m2 0h1m1 0h7m1 0h1m1 0h3M1 17.5h1m7 0h1m1 0h2m1 0h2m2 0h3m2 0h1m4 0h1m1 0h1m2 0h1m1 0h1M0 18.5h1m1 0h1m2 0h2m2 0h3m1 0h1m1 0h2m4 0h1m5 0h2m1 0h2m1 0h4M0 19.5h1m2 0h2m2 0h2m2 0h1m1 0h1m1 0h1m2 0h4m4 0h1m3 0h3m3 0h1M3 20.5h1m2 0h4m2 0h4m1 0h1m4 0h1m1 0h2m1 0h2m1 0h4M0 21.5h1m2 0h2m2 0h1m2 0h1m1 0h1m5 0h2m3 0h1m2 0h1m2 0h1m3 0h1M1 22.5h2m1 0h3m1 0h1m1 0h1m1 0h2m1 0h2m1 0h1m1 0h2m4 0h8m1 0h2M0 23.5h3m6 0h1m4 0h3m2 0h1m1 0h2m1 0h1m2 0h1m3 0h3M3 24.5h2m1 0h1m1 0h1m1 0h1m3 0h1m3 0h1m3 0h1m2 0h1m1 0h4m1 0h1m1 0h3M0 25.5h2m3 0h1m2 0h2m2 0h1m2 0h2m2 0h1m3 0h1m1 0h1m2 0h1m2 0h1M0 26.5h1m2 0h4m2 0h3m1 0h1m8 0h1m1 0h1m2 0h2m1 0h2m1 0h4M0 27.5h1m1 0h2m4 0h1m1 0h1m5 0h1m3 0h3m3 0h5m1 0h1m2 0h2M0 28.5h1m3 0h4m2 0h1m5 0h3m3 0h1m2 0h11M8 29.5h1m1 0h1m1 0h2m3 0h1m1 0h1m2 0h3m3 0h1m3 0h3m1 0h1M0 30.5h7m2 0h3m2 0h4m2 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h5M0 31.5h1m5 0h1m1 0h4m3 0h7m4 0h3m3 0h2M0 32.5h1m1 0h3m1 0h1m1 0h4m1 0h1m1 0h2m2 0h1m2 0h1m1 0h2m1 0h8m1 0h1M0 33.5h1m1 0h3m1 0h1m1 0h2m3 0h3m1 0h5m4 0h1m3 0h1m1 0h3m1 0h1M0 34.5h1m1 0h3m1 0h1m1 0h1m1 0h1m1 0h1m2 0h3m2 0h2m3 0h1m1 0h1m1 0h1m3 0h4M0 35.5h1m5 0h1m5 0h1m2 0h1m4 0h2m1 0h2m1 0h1m1 0h1m1 0h3m3 0h1M0 36.5h7m1 0h1m4 0h5m6 0h3m2 0h1m1 0h2m1 0h3"></path></svg></div><div class="Nai-50J68dhU9-Long">联系交易员</div></div></div><div class="Nai-H9CgNTAd4-Long Nai-Lkqcq3-b4-Long"><div class="Nai-joEQTrJYz-Long" style="display: none;"><img class="Nai-Pf7hyjnY3-Long" alt="" src=""><div class="Nai-f1Tbm-xu1-Long">豌豆htkn5m</div></div><div class="Nai-VMVMLbfOt-Long"><div class="Nai-o13VEKml1-Long"><img src=""></div><div class="Nai-Ud8I4LZTi-Long"><div class=""><div class="Nai-ch04utIdF-Long"></div></div><div class="Nai-yghFUQ1na-Long"><div class="Nai-3I43KlH2z-Long"><span class="Nai-dx6pHc-fI-Long"><span class="Nai-hQV1ZUjnm-Long">¥</span><span class="Nai-sVquzbW-o-Long">NaN</span><span class="Nai-DbXUZyLMj-Long">.</span></span></div><div class="Nai-HX6i1LzKs-Long">x 1</div></div></div></div><div class="Nai-ZeyNKSHrE-Long Nai-bGVZJvlL--Long"><div class="Nai-ZZhUqmO1X-Long">实付款</div><div class="Nai-enTGN910e-Long"><div class="Nai-OMQXrDSCg-Long"><span class="Nai-hQV1ZUjnm-Long">￥</span><span class="Nai-sVquzbW-o-Long">NaN</span><span class="Nai-DbXUZyLMj-Long">.</span></div></div></div><div class="Nai-ZeyNKSHrE-Long"><div class="Nai--IyDWDFbF-Long">订单号</div><div class="Nai-s1kVxZyNv-Long">7111483904604293</div></div><div class="Nai-ZeyNKSHrE-Long Nai-btTm2KeQq-Long">查看更多</div></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!----></div>
        </div>
        

        <!-- Section: panzhi -->
        <div id="app-panzhi" class="merged-view-container" v-show="currentTab === 'app-panzhi'">
            <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai-vKPJR1emC-Long"></div><div class="Nai-Pww1a-kpz-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long">转转</div><div class="Nai-Pww1a-kpz-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">盼之</div><div class="Nai-Pww1a-kpz-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long">微信</div><div class="Nai-Pww1a-kpz-Long">银联</div><div class="Nai-Pww1a-kpz-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long">千岛</div><div class="Nai-Pww1a-kpz-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div><div class="Nai-m5GlKWcpy-Long"><label>标题</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>价格</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>封面图</label><label for="upload-cover" class="Nai-ga5Us2FoA-Long">上传图片</label><input type="file" accept="image/*" id="upload-cover" style="display: none;"></div><div class="Nai-m5GlKWcpy-Long"><label>聊天室</label><select><option value="false" selected>关闭</option><option value="true">开启</option></select></div></div><div class="Nai-9RwaoltJT-Long"><div class="Nai-CTYwrw4Rl-Long"><div class="Nai-LAI0eSr7R-Long"><div class="Nai-Lf4w0B-PJ-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1024 1024"><use xlink:href="#arrow-left"></use></svg></div></div><div class="Nai-DK-6BPwJj-Long"><div class="Nai-orb0qVI1n-Long"><div class="Nai-b3irY81ax-Long">已下单，等待卖家联系客服</div><div class="Nai-v2HuE5fGV-Long"><div class="Nai-EPA3VXyRD-Long"></div><div class="Nai-EPA3VXyRD-Long Nai-T5-2zAvGV-Long"></div><div class="Nai-MbjJRMFkR-Long Nai-WPNhboD4I-Long"><div class="Nai-gY1j5zIKC-Long"><div class="Nai-FOn4HzSSJ-Long"></div></div><div class="">已付款</div></div><div class="Nai-MbjJRMFkR-Long"><div class="Nai-gY1j5zIKC-Long"><div class="Nai-FOn4HzSSJ-Long Nai-T5-2zAvGV-Long"></div></div><div class="">联系客服</div></div><div class="Nai-MbjJRMFkR-Long"><div class="Nai-gY1j5zIKC-Long"><div class="Nai-FOn4HzSSJ-Long Nai-T5-2zAvGV-Long"></div></div><div class="">客服验号</div></div><div class="Nai-MbjJRMFkR-Long"><div class="Nai-gY1j5zIKC-Long"><div class="Nai-FOn4HzSSJ-Long Nai-T5-2zAvGV-Long"></div></div><div class="">换绑账号</div></div><div class="Nai-MbjJRMFkR-Long Nai-KUmtMT-My-Long"><div class="Nai-gY1j5zIKC-Long"><div class="Nai-FOn4HzSSJ-Long Nai-T5-2zAvGV-Long"></div></div><div class="">完成交易</div></div></div></div><div class="Nai-orb0qVI1n-Long"><div class="Nai-b3irY81ax-Long">联系客服</div><div class="Nai-ZrVpnDUIg-Long"><div><div class="Nai-m3oGX5gUT-Long">请提醒卖家<span class="Nai-Z86r7vpTu-Long">扫码发货</span>。为保障您的交易安全，请勿将此二维码泄露给他人</div></div><div class="Nai-ALitSynzU-Long"><div class="Nai-kNTg1OFCn-Long">注意：为保障高峰时段系统稳定运行及用户体验，平台将在订单量激增期间动态调整订单显示规则，<span class="Nai-Z86r7vpTu-Long">可能不会显示订单</span></div><div class="Nai-Va1uFVzGN-Long"><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 37 37" shape-rendering="crispEdges"><path fill="#ffffff" d="M0 0h37v37H0z"></path><path stroke="#000000" d="M0 0.5h7m1 0h1m2 0h3m2 0h1m1 0h4m1 0h1m2 0h3m1 0h7M0 1.5h1m5 0h1m4 0h4m1 0h1m2 0h1m1 0h2m2 0h2m1 0h1m1 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m2 0h1m5 0h4m2 0h4m2 0h1m2 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h2m1 0h1m1 0h4m1 0h1m1 0h1m2 0h1m1 0h1m1 0h1m2 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m1 0h1m2 0h1m3 0h1m1 0h2m3 0h3m2 0h2m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m1 0h3m2 0h1m2 0h2m1 0h1m1 0h2m1 0h3m3 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h1m1 0h4m5 0h4m3 0h1M0 8.5h1m3 0h1m1 0h3m1 0h1m1 0h5m2 0h1m1 0h2m1 0h1m2 0h7m2 0h1M2 9.5h1m4 0h1m1 0h2m1 0h1m4 0h2m1 0h1m2 0h1m1 0h4m1 0h1m1 0h2m1 0h1M0 10.5h2m1 0h2m1 0h1m1 0h1m3 0h1m2 0h1m1 0h1m2 0h1m1 0h2m1 0h1m1 0h1m2 0h3m1 0h1M0 11.5h1m1 0h3m2 0h1m2 0h1m1 0h1m1 0h5m1 0h2m1 0h2m1 0h2m1 0h2m2 0h3M0 12.5h1m1 0h1m1 0h4m8 0h2m2 0h3m3 0h1m2 0h3m1 0h4M3 13.5h3m1 0h1m2 0h1m1 0h2m1 0h1m2 0h1m2 0h1m1 0h3m1 0h1m1 0h1m1 0h3M0 14.5h1m2 0h4m1 0h1m2 0h2m1 0h2m1 0h1m2 0h5m1 0h2m4 0h4M3 15.5h1m5 0h1m4 0h2m1 0h5m1 0h1m4 0h3m3 0h3M0 16.5h3m3 0h2m3 0h1m2 0h1m3 0h1m2 0h2m1 0h1m1 0h1m1 0h3m2 0h4M3 17.5h3m1 0h3m1 0h2m3 0h1m3 0h2m1 0h1m1 0h4m2 0h2m2 0h1M0 18.5h1m1 0h5m1 0h2m6 0h3m2 0h3m3 0h3m1 0h1m1 0h1M0 19.5h4m1 0h1m2 0h1m4 0h2m2 0h1m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h1m2 0h2M1 20.5h2m1 0h7m2 0h3m1 0h1m1 0h6m1 0h1m1 0h1m1 0h1M3 21.5h1m1 0h1m2 0h1m2 0h1m1 0h1m1 0h1m1 0h2m1 0h2m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2M1 22.5h2m3 0h1m1 0h1m2 0h5m2 0h1m1 0h1m2 0h2m1 0h2m1 0h1m1 0h4M0 23.5h6m1 0h2m1 0h2m1 0h1m1 0h1m3 0h1m1 0h3m2 0h3m1 0h7M2 24.5h2m2 0h3m2 0h3m1 0h2m2 0h4m1 0h1m1 0h1m1 0h4m1 0h4M0 25.5h1m2 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2m3 0h1m2 0h1m1 0h1m3 0h3m1 0h3M2 26.5h1m3 0h1m3 0h2m1 0h3m1 0h2m4 0h2m2 0h1m1 0h1m2 0h2M2 27.5h1m1 0h1m2 0h1m2 0h1m1 0h1m2 0h7m1 0h2m1 0h1m1 0h1m3 0h1m1 0h2M0 28.5h3m3 0h1m9 0h7m5 0h8M8 29.5h5m2 0h1m4 0h1m1 0h7m3 0h1m1 0h1m1 0h1M0 30.5h7m1 0h8m1 0h1m2 0h2m1 0h1m1 0h1m2 0h1m1 0h1m1 0h2M0 31.5h1m5 0h1m4 0h2m1 0h2m1 0h5m1 0h2m1 0h3m3 0h5M0 32.5h1m1 0h3m1 0h1m1 0h3m2 0h2m3 0h1m1 0h3m2 0h1m2 0h5m1 0h1m1 0h1M0 33.5h1m1 0h3m1 0h1m2 0h1m4 0h1m1 0h2m2 0h1m2 0h1m1 0h3m2 0h2m4 0h1M0 34.5h1m1 0h3m1 0h1m2 0h1m1 0h1m4 0h1m1 0h1m2 0h3m1 0h1m1 0h2m1 0h1m2 0h2M0 35.5h1m5 0h1m4 0h1m1 0h2m2 0h2m1 0h5m1 0h1m4 0h2m1 0h2M0 36.5h7m1 0h1m2 0h3m1 0h3m1 0h3m2 0h1m2 0h1m1 0h2m2 0h4"></path></svg></div></div></div></div><div class="Nai-m8Qduh6bJ-Long">订单详情</div><div class="Nai-orb0qVI1n-Long"><div class="Nai-mB3Kj2BKn-Long"><img class="Nai-vrxKkBYUP-Long" src="" alt=""><div class="Nai-552akq2Xs-Long"></div><div class="Nai-QmorFrK0t-Long" style="display: none;"> ￥<span class="Nai-EBAq3jLll-Long"></span></div></div><div class="Nai-n83v-P8up-Long"><div class="Nai-s8z0stgni-Long"><div>商品总价</div><div>￥<span class="Nai-EBAq3jLll-Long Nai-U5646mhd2-Long"></span></div></div><div class="Nai-s8z0stgni-Long"><div>实付款</div><div>￥<span class="Nai-EBAq3jLll-Long Nai-U5646mhd2-Long"></span></div></div><div class="Nai-s8z0stgni-Long"><div>订单状态</div><div>进行中</div></div><div class="Nai-s8z0stgni-Long"><div>订单编号</div><div>43289129932891343</div></div><div class="Nai-AXHApWL-X-Long">查看更多</div></div></div></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!----></div>
        </div>
        

        <!-- Section: pangxie -->
        <div id="app-pangxie" class="merged-view-container" v-show="currentTab === 'app-pangxie'">
            <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai-KJuVCciCC-Long"></div><div class="Nai-Pww1a-kpz-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long">转转</div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long">盼之</div><div class="Nai-Pww1a-kpz-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long">微信</div><div class="Nai-Pww1a-kpz-Long">银联</div><div class="Nai-Pww1a-kpz-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long">千岛</div><div class="Nai-Pww1a-kpz-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div><div class="Nai-m5GlKWcpy-Long"><label>标题</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>价格</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>封面图</label><label for="upload-cover" class="Nai-ga5Us2FoA-Long">上传图片</label><input type="file" accept="image/*" id="upload-cover" style="display: none;"></div><div class="Nai-m5GlKWcpy-Long"><label>聊天室</label><select><option value="false" selected>关闭</option><option value="true">开启</option></select></div></div><div class="Nai-9RwaoltJT-Long"><div class="Nai-xVhl-Hz3z-Long"><div class="Nai-ijAc8X8fD-Long"><div class="Nai-Jv5H9hKlr-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1024 1024"><use xlink:href="#arrow-left"></use></svg></div></div><div class="Nai-SDnOGu-P7-Long"><div class="Nai-2HDDswocy-Long"><div class="Nai-S5fxBVWHe-Long">已下单，等待卖家联系客服</div><div class="Nai-wRcECupJu-Long"><div class="Nai-Nj8ybdQ-Y-Long"></div><div class="Nai-Nj8ybdQ-Y-Long Nai-JMzpQZscX-Long"></div><div class="Nai-mCedYlUV3-Long Nai-IKM1nxBUv-Long"><div class="Nai-6DZhcb----Long"><div class="Nai-f-8-7Zr2E-Long"></div></div><div class="">已付款</div></div><div class="Nai-mCedYlUV3-Long"><div class="Nai-6DZhcb----Long"><div class="Nai-f-8-7Zr2E-Long Nai-JMzpQZscX-Long"></div></div><div class="">联系客服</div></div><div class="Nai-mCedYlUV3-Long"><div class="Nai-6DZhcb----Long"><div class="Nai-f-8-7Zr2E-Long Nai-JMzpQZscX-Long"></div></div><div class="">客服验号</div></div><div class="Nai-mCedYlUV3-Long"><div class="Nai-6DZhcb----Long"><div class="Nai-f-8-7Zr2E-Long Nai-JMzpQZscX-Long"></div></div><div class="">换绑账号</div></div><div class="Nai-mCedYlUV3-Long Nai-8P1VVB5yL-Long"><div class="Nai-6DZhcb----Long"><div class="Nai-f-8-7Zr2E-Long Nai-JMzpQZscX-Long"></div></div><div class="">完成交易</div></div></div></div><div class="Nai-2HDDswocy-Long"><div class="Nai-S5fxBVWHe-Long">联系客服</div><div class="Nai-7O4aa5DYn-Long"><div><div class="Nai-Si-Ajj0CX-Long">请提醒卖家<span class="Nai-tUNqhWZ6l-Long">扫码发货</span>。为保障您的交易安全，请勿将此二维码泄露给他人</div></div><div class="Nai-xH00LW7FC-Long"><div class="Nai-nKSlnS6lP-Long">注意：为保障高峰时段系统稳定运行及用户体验，平台将在订单量激增期间动态调整订单显示规则，<span class="">可能不会显示订单</span></div><div class=""><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 37 37" shape-rendering="crispEdges"><path fill="#ffffff" d="M0 0h37v37H0z"></path><path stroke="#000000" d="M0 0.5h7m1 0h1m1 0h2m1 0h2m3 0h4m1 0h1m2 0h3m1 0h7M0 1.5h1m5 0h1m5 0h4m3 0h1m1 0h2m2 0h2m1 0h1m1 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m2 0h1m5 0h1m1 0h2m2 0h4m2 0h1m2 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h2m3 0h4m1 0h1m1 0h1m2 0h1m1 0h1m1 0h1m2 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m1 0h2m1 0h1m3 0h1m1 0h2m3 0h3m2 0h2m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m1 0h3m2 0h2m1 0h2m1 0h1m1 0h2m1 0h3m3 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h5m1 0h1m4 0h4m3 0h1M0 8.5h1m3 0h1m1 0h3m5 0h3m2 0h1m1 0h2m1 0h1m2 0h7m2 0h1M2 9.5h2m4 0h5m4 0h2m1 0h1m2 0h1m1 0h4m1 0h1m1 0h2m1 0h1M0 10.5h2m2 0h1m1 0h2m4 0h1m2 0h1m1 0h1m2 0h1m1 0h2m1 0h1m1 0h1m2 0h3m1 0h1M0 11.5h1m2 0h2m5 0h3m1 0h5m1 0h2m1 0h2m1 0h2m1 0h2m2 0h3M0 12.5h1m3 0h3m4 0h1m4 0h2m2 0h3m3 0h1m2 0h3m1 0h4M0 13.5h1m2 0h3m1 0h1m1 0h2m1 0h2m1 0h1m2 0h1m2 0h1m1 0h3m1 0h1m1 0h1m1 0h3M1 14.5h1m1 0h1m1 0h2m1 0h2m1 0h5m1 0h1m2 0h5m1 0h2m4 0h4M0 15.5h2m1 0h3m3 0h1m3 0h1m1 0h1m1 0h5m1 0h1m4 0h3m3 0h3M2 16.5h3m1 0h7m1 0h1m3 0h1m2 0h2m1 0h1m1 0h1m1 0h3m2 0h4M2 17.5h3m2 0h4m5 0h1m3 0h2m1 0h1m1 0h4m2 0h2m2 0h1M0 18.5h1m3 0h6m2 0h1m3 0h3m2 0h3m3 0h3m1 0h1m1 0h1M0 19.5h4m1 0h1m5 0h4m2 0h1m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h1m2 0h2M1 20.5h2m1 0h8m1 0h3m1 0h1m1 0h6m1 0h1m1 0h1m1 0h1M0 21.5h1m2 0h1m1 0h1m2 0h2m1 0h1m1 0h1m1 0h1m1 0h2m1 0h2m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2M0 22.5h3m3 0h1m1 0h2m1 0h2m1 0h2m2 0h1m1 0h1m2 0h2m1 0h2m1 0h1m1 0h4M1 23.5h3m3 0h3m1 0h1m3 0h1m3 0h1m1 0h3m2 0h3m1 0h7M1 24.5h2m3 0h7m1 0h3m2 0h4m1 0h1m1 0h1m1 0h4m1 0h4M0 25.5h1m1 0h2m1 0h1m1 0h1m1 0h1m1 0h3m4 0h1m2 0h1m1 0h1m3 0h3m1 0h3M6 26.5h1m3 0h1m1 0h4m1 0h2m4 0h2m2 0h1m1 0h1m3 0h1M2 27.5h1m1 0h1m2 0h2m1 0h2m3 0h7m1 0h2m1 0h1m1 0h1m3 0h1m1 0h2M0 28.5h3m3 0h2m8 0h7m5 0h8M8 29.5h5m2 0h1m4 0h1m1 0h7m3 0h1m1 0h1m1 0h1M0 30.5h7m1 0h6m1 0h1m1 0h1m2 0h2m1 0h1m1 0h1m2 0h1m1 0h1m1 0h2M0 31.5h1m5 0h1m4 0h5m1 0h5m1 0h2m1 0h3m3 0h5M0 32.5h1m1 0h3m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m3 0h1m1 0h3m2 0h1m2 0h5m1 0h1m1 0h1M0 33.5h1m1 0h3m1 0h1m2 0h3m2 0h1m1 0h2m2 0h1m2 0h1m1 0h3m2 0h2m4 0h1M0 34.5h1m1 0h3m1 0h1m2 0h1m6 0h1m1 0h1m2 0h3m1 0h1m1 0h2m1 0h1m2 0h2M0 35.5h1m5 0h1m6 0h2m2 0h2m1 0h5m1 0h1m4 0h2m1 0h2M0 36.5h7m1 0h1m3 0h2m1 0h3m1 0h3m2 0h1m2 0h1m1 0h2m2 0h4"></path></svg></div></div></div></div><div class="Nai-4t-inyZCc-Long">订单详情</div><div class="Nai-2HDDswocy-Long"><div class="Nai-41VyDTYKk-Long"><img class="Nai-BsuNS49jX-Long" src="" alt=""><div class="Nai-TkSOUlFNZ-Long"></div><div class="Nai-GX0lBpEAY-Long" style="display: none;"> ￥<span class="Nai-ctB3NwMnY-Long"></span></div></div><div class="Nai-LO9nLObuZ-Long"><div class="Nai-gJzSwqIrm-Long"><div>商品总价</div><div>￥<span class="Nai-ctB3NwMnY-Long Nai-MRWLIwtEy-Long"></span></div></div><div class="Nai-gJzSwqIrm-Long"><div>实付款</div><div>￥<span class="Nai-ctB3NwMnY-Long Nai-MRWLIwtEy-Long"></span></div></div><div class="Nai-gJzSwqIrm-Long"><div>订单状态</div><div>进行中</div></div><div class="Nai-gJzSwqIrm-Long"><div>订单编号</div><div>43289129932891343</div></div><div class="Nai-Jiv0qzGE8-Long">查看更多</div></div></div></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!----></div>
        </div>
        

        <!-- Section: zhuanzhuan -->
        <div id="app-zhuanzhuan" class="merged-view-container" v-show="currentTab === 'app-zhuanzhuan'">
            <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai-boAe63TtU-Long"></div><div class="Nai-Pww1a-kpz-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">转转</div><div class="Nai-Pww1a-kpz-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long">盼之</div><div class="Nai-Pww1a-kpz-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long">微信</div><div class="Nai-Pww1a-kpz-Long">银联</div><div class="Nai-Pww1a-kpz-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long">千岛</div><div class="Nai-Pww1a-kpz-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div><div class="Nai-m5GlKWcpy-Long"><label>模板</label><select><option value="1">游戏鱼</option><option value="2">实物鱼</option></select></div><div class="Nai-m5GlKWcpy-Long"><label>标题</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>价格</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>封面图</label><label for="upload-cover" class="Nai-ga5Us2FoA-Long">上传图片</label><input type="file" accept="image/*" id="upload-cover" style="display: none;"></div><div class="Nai-m5GlKWcpy-Long"><label>订单</label><div class="Nai-ga5Us2FoA-Long">生成订单</div></div></div><div class="Nai-9RwaoltJT-Long"><div class="Nai-ld5GcXnQq-Long"><div class="Nai-6Jao2SZXW-Long"><div class="Nai-jIRHqIuOP-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1024 1024"><use xlink:href="#arrow-left"></use></svg></div></div><div class="Nai-dpPPlDQH4-Long"><div class="Nai-UulVCuhZu-Long"><div class="Nai-ObgUXD0Bg-Long">已下单，等待卖家联系客服</div><div class="Nai-VG1oDV9HD-Long"><div class="Nai-JPIuVeQ-u-Long"></div><div class="Nai-JPIuVeQ-u-Long Nai-m6Q-1-uMH-Long"></div><div class="Nai-UTVhEztii-Long Nai-m2v-gjSlS-Long"><div class="Nai-y9RfGsifG-Long"><div class="Nai-Vzqb1q5Kh-Long"></div></div><div>已付款</div><!----></div><div class="Nai-UTVhEztii-Long"><div class="Nai-y9RfGsifG-Long"><div class="Nai-Vzqb1q5Kh-Long Nai-m6Q-1-uMH-Long"></div></div><div>联系客服</div><!----></div><div class="Nai-UTVhEztii-Long"><div class="Nai-y9RfGsifG-Long"><div class="Nai-Vzqb1q5Kh-Long Nai-m6Q-1-uMH-Long"></div></div><div>客服验号</div><!----></div><div class="Nai-UTVhEztii-Long"><div class="Nai-y9RfGsifG-Long"><div class="Nai-Vzqb1q5Kh-Long Nai-m6Q-1-uMH-Long"></div></div><div>换绑账号</div><!----></div><div class="Nai-UTVhEztii-Long Nai-nTv6BrUCO-Long"><div class="Nai-y9RfGsifG-Long"><div class="Nai-Vzqb1q5Kh-Long Nai-m6Q-1-uMH-Long"></div></div><div>完成交易</div><!----></div></div></div><div class="Nai-UulVCuhZu-Long"><div class="Nai-ObgUXD0Bg-Long">联系客服</div><div class="Nai-gZspH8Yeg-Long"><div><div class="Nai-zIlBhNGT1-Long">请提醒卖家<span class="Nai-XDf6yi42A-Long">扫码发货</span></div><div class="Nai-zIlBhNGT1-Long">为保障您的交易安全，请勿将此二维码泄露给他人</div></div><div class="Nai-vsEU4Sha4-Long"><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 37 37" shape-rendering="crispEdges"><path fill="#ffffff" d="M0 0h37v37H0z"></path><path stroke="#000000" d="M0 0.5h7m1 0h1m4 0h1m1 0h2m1 0h4m1 0h1m2 0h3m1 0h7M0 1.5h1m5 0h1m4 0h4m4 0h1m1 0h2m2 0h2m1 0h1m1 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m2 0h1m2 0h1m2 0h1m1 0h2m2 0h4m2 0h1m2 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h1m1 0h1m2 0h1m1 0h1m1 0h1m2 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m1 0h2m1 0h1m3 0h1m1 0h2m3 0h3m2 0h2m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m1 0h1m1 0h1m2 0h2m1 0h2m1 0h1m1 0h2m1 0h3m3 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h1m2 0h2m6 0h4m3 0h1M0 8.5h1m3 0h1m1 0h3m4 0h4m2 0h1m1 0h2m1 0h1m2 0h7m2 0h1M1 9.5h2m4 0h3m1 0h1m5 0h2m1 0h1m2 0h1m1 0h4m1 0h1m1 0h2m1 0h1M0 10.5h2m2 0h1m1 0h3m6 0h1m1 0h1m2 0h1m1 0h2m1 0h1m1 0h1m2 0h3m1 0h1M0 11.5h1m1 0h1m1 0h1m2 0h2m1 0h2m2 0h5m1 0h2m1 0h2m1 0h2m1 0h2m2 0h3M0 12.5h1m1 0h1m1 0h4m3 0h1m4 0h2m2 0h3m3 0h1m2 0h3m1 0h4M3 13.5h3m1 0h1m2 0h1m1 0h1m2 0h1m2 0h1m2 0h1m1 0h3m1 0h1m1 0h1m1 0h3M0 14.5h2m1 0h2m1 0h1m1 0h5m2 0h1m1 0h1m2 0h5m1 0h2m4 0h4M0 15.5h2m1 0h2m4 0h2m2 0h3m1 0h5m1 0h1m4 0h3m3 0h3M2 16.5h2m1 0h4m1 0h2m1 0h2m3 0h1m2 0h2m1 0h1m1 0h1m1 0h3m2 0h4M2 17.5h1m1 0h2m2 0h2m2 0h1m1 0h1m1 0h1m3 0h2m1 0h1m1 0h4m2 0h2m2 0h1M0 18.5h1m1 0h5m2 0h1m6 0h3m2 0h3m3 0h3m1 0h1m1 0h1M0 19.5h3m2 0h1m5 0h4m2 0h1m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h1m2 0h2M1 20.5h2m1 0h8m1 0h3m1 0h1m1 0h6m1 0h1m1 0h1m1 0h1M0 21.5h1m2 0h1m1 0h1m2 0h1m2 0h1m1 0h1m1 0h1m1 0h2m1 0h2m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2M2 22.5h1m1 0h1m1 0h1m1 0h6m1 0h1m2 0h1m1 0h1m2 0h2m1 0h2m1 0h1m1 0h4M1 23.5h3m1 0h1m1 0h3m1 0h1m1 0h1m1 0h1m3 0h1m1 0h3m2 0h3m1 0h7M1 24.5h8m2 0h2m1 0h3m2 0h4m1 0h1m1 0h1m1 0h4m1 0h4M0 25.5h1m4 0h1m1 0h1m1 0h1m1 0h1m1 0h2m3 0h1m2 0h1m1 0h1m3 0h3m1 0h3M6 26.5h1m3 0h1m2 0h3m1 0h2m4 0h2m2 0h1m1 0h1m2 0h2M2 27.5h3m2 0h1m2 0h1m4 0h7m1 0h2m1 0h1m1 0h1m3 0h1m1 0h2M0 28.5h2m4 0h2m8 0h7m5 0h8M8 29.5h1m1 0h4m1 0h1m4 0h1m1 0h7m3 0h1m1 0h1m1 0h1M0 30.5h7m1 0h2m1 0h2m2 0h1m1 0h1m2 0h2m1 0h1m1 0h1m2 0h1m1 0h1m1 0h2M0 31.5h1m5 0h1m2 0h4m1 0h2m1 0h5m1 0h2m1 0h3m3 0h5M0 32.5h1m1 0h3m1 0h1m1 0h1m1 0h1m3 0h1m3 0h1m1 0h3m2 0h1m2 0h5m1 0h1m1 0h1M0 33.5h1m1 0h3m1 0h1m2 0h2m5 0h2m2 0h1m2 0h1m1 0h3m2 0h2m2 0h1m1 0h1M0 34.5h1m1 0h3m1 0h1m2 0h1m2 0h1m3 0h1m1 0h1m2 0h3m1 0h1m1 0h2m1 0h1m2 0h1M0 35.5h1m5 0h1m4 0h1m1 0h2m2 0h2m1 0h5m1 0h1m4 0h2m1 0h2M0 36.5h7m1 0h1m3 0h2m1 0h3m1 0h3m2 0h1m2 0h1m1 0h2m2 0h4"></path></svg></div></div></div><div class="Nai-MLuCoraR8-Long">订单详情</div><div class="Nai-UulVCuhZu-Long"><div class="Nai-VVPzF9khB-Long"><img class="Nai-LtPLPpEPC-Long" src=""><div class="Nai-HdeOJj6dP-Long"></div><div class="Nai-EG1HP9-3g-Long" style="display: none;"> ￥<span class="Nai-JmU557kqf-Long"></span></div></div><div class="Nai-hT9aVUnts-Long"><div class="Nai-xE-Rc4ABg-Long"><div>商品总价</div><div>￥<span class="Nai-JmU557kqf-Long Nai-BrxEVFKpz-Long"></span></div></div><div class="Nai-xE-Rc4ABg-Long"><div>实付款</div><div>￥<span class="Nai-JmU557kqf-Long Nai-BrxEVFKpz-Long"></span></div></div><div class="Nai-xE-Rc4ABg-Long"><div>订单状态</div><div>进行中</div></div><div class="Nai-xE-Rc4ABg-Long"><div>订单编号</div><div>43289129932891343</div></div><div class="Nai-NO8lQYQ0C-Long">查看更多</div></div></div></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!----></div>
        </div>
        

        <!-- Section: xianyu -->
        <div id="app-xianyu" class="merged-view-container" v-show="currentTab === 'app-xianyu'">
    <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol><symbol id="three-points"><path d="M512 256a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z m0 341.333333a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 0 0 0 170.666666z m0 341.333334a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z" fill="#272636"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai-3td5xqI7Q-Long"></div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long">转转</div><div class="Nai-Pww1a-kpz-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long">盼之</div><div class="Nai-Pww1a-kpz-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long">微信</div><div class="Nai-Pww1a-kpz-Long">银联</div><div class="Nai-Pww1a-kpz-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long">千岛</div><div class="Nai-Pww1a-kpz-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div><div class="Nai-m5GlKWcpy-Long"><label>模板</label><select><option value="1">游戏鱼</option><option value="2">实物鱼</option></select></div><div class="Nai-m5GlKWcpy-Long"><label>标题</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>价格</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>扫码</label><select><option value="微信">微信(推荐)</option><option value="支付宝">支付宝</option><option value="QQ">QQ</option></select></div><div class="Nai-m5GlKWcpy-Long"><label>封面图</label><label for="upload-cover" class="Nai-ga5Us2FoA-Long">上传图片</label><input type="file" accept="image/*" id="upload-cover" style="display: none;"></div><div class="Nai-m5GlKWcpy-Long"><label>订单</label><div class="Nai-ga5Us2FoA-Long">生成订单</div></div><div class="Nai-m5GlKWcpy-Long"><label>空订单</label><div class="Nai-ga5Us2FoA-Long">生成空订单</div></div></div><div class="Nai-9RwaoltJT-Long"><div class="Nai-hdC3SqpQW-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="bold-arrow-down"><path d="M52.335 261.072c-31.269 30.397-31.269 79.722 0 110.194l403.212 391.718c31.325 30.382 82.114 30.382 113.377 0l403.197-391.718c31.325-30.466 31.325-79.793 0-110.194-31.28-30.449-82.058-30.449-113.39 0l-346.497 336.64-346.457-336.64c-31.325-30.448-82.105-30.448-113.446 0l0 0z" fill="#272636"></path></symbol></svg><div class="Nai-q-EdWJmI0-Long"><svg class="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><use xlink:href="#arrow-left"></use></svg><svg class="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><use xlink:href="#three-points"></use></svg></div><div class="Nai-6Me-DVW15-Long"><div class="Nai-apCpgi6cf-Long"><div>已付款，等待卖家发货</div><div class="Nai-WZddb8hDo-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="12" height="12"><use xlink:href="#bold-arrow-down"></use></svg></div></div><div class="Nai-sGBa-fBDN-Long"><div class="Nai-lsRIkgxE0-Long"></div><div class="Nai-lsRIkgxE0-Long Nai-PnLWwZPdW-Long"></div><img src="/xy.png" alt="" class="Nai--Ivz1qvjH-Long"><div class="Nai-J0HH1b-as-Long Nai-kUPpmVc79-Long"><div class="Nai-6bbruLi9M-Long"><div class="Nai-vhksOV4pn-Long Nai-YN8UTrjhC-Long">✓</div></div><div>已下单</div><!----></div><div class="Nai-J0HH1b-as-Long"><div class="Nai-6bbruLi9M-Long"><div class="Nai-vhksOV4pn-Long"></div></div><div>联系客服</div><!----></div><div class="Nai-J0HH1b-as-Long"><div class="Nai-6bbruLi9M-Long"><div class="Nai-vhksOV4pn-Long"></div></div><div>客服换绑</div><!----></div><div class="Nai-J0HH1b-as-Long Nai-yJjTbc0Rs-Long"><div class="Nai-6bbruLi9M-Long"><div class="Nai-vhksOV4pn-Long"></div></div><div>确认收货</div><!----></div></div><div class="Nai-YriaGo2jK-Long"><div class="Nai-wRZTFeidK-Long">商品交易规则</div><div class=""> 卖家打开<span class="Nai-gWE971MRl-Long">微信</span>扫码联系客服配合完成交易账号的<span class="Nai-gWE971MRl-Long">换绑操作</span>，稍后等待买家<span class="Nai-gWE971MRl-Long">确认收货</span>完成交易 </div></div><div class="Nai-YriaGo2jK-Long"><div class="Nai-wRZTFeidK-Long">联系客服</div><div class="Nai-DNMvdrrgt-Long"><div class="Nai-ZGtC8muCJ-Long"><div>请提醒<span class="Nai-gWE971MRl-Long">卖家扫码发货</span></div><div>为保障您的交易安全，请勿将二维码泄露，避免引发资金损失、交易纠纷等风险。</div></div><div class="Nai-De6izQNb--Long"><svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 37 37" shape-rendering="crispEdges"><path fill="#ffffff" d="M0 0h37v37H0z"></path><path stroke="#000000" d="M0 0.5h7m1 0h1m3 0h1m1 0h2m2 0h3m4 0h2m1 0h1m1 0h7M0 1.5h1m5 0h1m1 0h2m3 0h1m1 0h1m1 0h2m2 0h4m1 0h1m1 0h1m1 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m3 0h2m3 0h1m2 0h3m1 0h2m1 0h1m1 0h2m1 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h6m1 0h3m2 0h1m1 0h1m1 0h2m1 0h2m1 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m3 0h1m1 0h2m1 0h1m1 0h1m1 0h1m2 0h1m4 0h2m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m2 0h3m2 0h1m3 0h3m4 0h2m1 0h1m1 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h1m3 0h6m1 0h1m7 0h2M0 8.5h1m1 0h2m1 0h3m1 0h1m1 0h1m3 0h3m1 0h1m1 0h1m2 0h1m1 0h3m1 0h1m2 0h1m1 0h2M1 9.5h2m5 0h1m3 0h1m2 0h10m1 0h1m1 0h1m2 0h1m3 0h1M0 10.5h1m3 0h1m1 0h2m2 0h6m1 0h1m2 0h2m1 0h4m3 0h1m2 0h1M0 11.5h1m1 0h1m1 0h1m3 0h1m1 0h1m2 0h1m1 0h1m2 0h1m1 0h1m3 0h4m2 0h1m3 0h1M0 12.5h1m3 0h1m1 0h2m1 0h3m1 0h1m2 0h2m1 0h1m2 0h1m2 0h1m1 0h1m1 0h2m1 0h1m1 0h3M0 13.5h1m1 0h1m1 0h1m2 0h1m1 0h1m1 0h1m3 0h1m1 0h1m1 0h1m7 0h1m2 0h1m1 0h2m1 0h2M3 14.5h1m2 0h2m1 0h2m1 0h1m4 0h4m3 0h1m5 0h3m1 0h1M1 15.5h1m1 0h1m1 0h1m1 0h1m1 0h4m1 0h3m1 0h5m1 0h1m1 0h1m2 0h2M0 16.5h1m1 0h1m3 0h1m1 0h1m2 0h1m1 0h2m1 0h1m1 0h6m1 0h1m7 0h2M0 17.5h5m6 0h1m1 0h1m2 0h1m3 0h4m1 0h2m2 0h2m3 0h3M1 18.5h3m1 0h3m1 0h3m1 0h4m3 0h2m2 0h1m2 0h2m1 0h7M0 19.5h2m2 0h1m5 0h3m4 0h1m2 0h1m2 0h2m2 0h1m1 0h1m1 0h1m1 0h1m1 0h1M1 20.5h1m4 0h4m1 0h3m2 0h3m2 0h1m10 0h1m1 0h1m1 0h1M0 21.5h3m1 0h2m1 0h1m1 0h2m2 0h1m4 0h2m3 0h1m2 0h1m2 0h1m3 0h1M1 22.5h3m2 0h1m1 0h2m1 0h2m1 0h1m1 0h1m4 0h4m3 0h2m1 0h1M1 23.5h1m2 0h2m2 0h4m1 0h1m8 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h1M2 24.5h3m1 0h2m4 0h1m4 0h2m3 0h1m1 0h7m1 0h1m1 0h3M3 25.5h1m3 0h3m1 0h1m4 0h4m1 0h1m2 0h2m1 0h1m1 0h5m1 0h2M1 26.5h1m1 0h1m1 0h2m1 0h1m1 0h7m1 0h2m1 0h1m2 0h2m6 0h1m2 0h1M0 27.5h1m4 0h1m1 0h2m3 0h2m2 0h1m2 0h4m1 0h1m1 0h7m2 0h2M2 28.5h1m1 0h1m1 0h1m3 0h1m3 0h3m3 0h3m1 0h2m2 0h5m1 0h2M8 29.5h2m4 0h5m4 0h1m1 0h1m1 0h2m3 0h1M0 30.5h7m1 0h3m1 0h2m1 0h2m3 0h3m1 0h1m1 0h1m1 0h1m1 0h1m1 0h5M0 31.5h1m5 0h1m1 0h1m5 0h1m1 0h4m3 0h2m3 0h1m3 0h1m2 0h2M0 32.5h1m1 0h3m1 0h1m2 0h1m1 0h2m3 0h2m3 0h1m4 0h1m1 0h5M0 33.5h1m1 0h3m1 0h1m1 0h2m4 0h2m1 0h1m1 0h3m1 0h1m2 0h1m3 0h1m1 0h1m2 0h2M0 34.5h1m1 0h3m1 0h1m1 0h1m1 0h2m1 0h1m2 0h1m1 0h1m4 0h4m3 0h1m1 0h3M0 35.5h1m5 0h1m2 0h3m1 0h2m1 0h1m1 0h3m1 0h1m1 0h3m3 0h1m1 0h3M0 36.5h7m1 0h2m3 0h5m6 0h4m2 0h7"></path></svg></div></div></div><div class="Nai-YriaGo2jK-Long"><div class="Nai-T69P0L6jH-Long"><img class="Nai-a1Xs9rsU--Long" src="" alt=""><div class="Nai-WbmI6tkBT-Long"></div><div class="Nai--nOga457k-Long"><span class="Nai-HQOau663r-Long">￥</span><span class=""></span></div></div><div class="Nai-yBXbtTDUx-Long"><div>成交价<span class="Nai-TmyVRV5Jr-Long">（在支付宝担保账户中）</span></div><div><span class="Nai-HQOau663r-Long">￥</span><span class=""></span></div></div><div class="Nai-wGxH1uerh-Long"><div>支付宝交易号</div><div style="font-weight: normal; letter-spacing: 0.2px;">2032492483240948927298</div></div><div class="Nai-LY1ATs5JA-Long">查看更多</div></div><!----></div><div class="Nai-Quv7KQ8nk-Long"><div class="Nai-vOrj7PTg3-Long Nai-in2cgKltS-Long">提醒发货</div><div class="Nai-vOrj7PTg3-Long">更多</div></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!----></div>
</div>
        

        <!-- Section: yinlian -->
        <div id="app-yinlian" class="merged-view-container" v-show="currentTab === 'app-yinlian'">
            <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai-gnFvgb5N3-Long"></div><div class="Nai-Pww1a-kpz-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long">转转</div><div class="Nai-Pww1a-kpz-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long">盼之</div><div class="Nai-Pww1a-kpz-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long">微信</div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">银联</div><div class="Nai-Pww1a-kpz-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long">千岛</div><div class="Nai-Pww1a-kpz-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div><!----></div><div class="Nai-9RwaoltJT-Long"><div class="Nai-lK4owCY2D-Long"><div class="Nai-jXZ2OdZjY-Long"><img class="Nai-vOcBjaRof-Long" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAAYZJREFUeAHt2kFKw1AQxvEmWVR0YXKDkiOYUwi6EcGdN+gFui6ewBO4FjcWeoocwE3IEeKiYjeJ36NZdwYKklf+D8JbvOkw86NvM7zZjIUAAggggAACCCCAAAIIIIAAAgiclUDi6aaqqsuu61bDMDwmSbLQPvf8bmoxqn2v2lvt73mev9R1/WPV6AIqy/JTie6sZJGdb5qmubdqTq2A8bxyxkUTpn/RjadYF1CWZUsl23kSRhKz01ULPZnLdcVCFl2za6nfKvEiTdMLM/MEA/q+/1UPrXrY6np9T7BESkIAAQQQQAABBBBAAAEEEEAAgZMFGHcYhC4gzYIelOdN35WRL5bjMPx71kzowyrYNVFUkld954ITTEIvoSdzeYFqM1N8Aa6eXEBFUTxpVLmWwZf2fXwWh4rH2kMP69BTrH1QNwIIIIAAAggggAACCCCAAAIIIHCCgGvkyjNgQ5hnwAaQjnkGfMyIZ8DHdMYzngE7kAhBAAEEEEAAAQQQQAABBBBA4D8E/gA1NX0fA/1EoQAAAABJRU5ErkJggg==" alt=""><img class="Nai-vOcBjaRof-Long" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA5VJREFUaAXtWDtrVEEYzT5gLfwFEhD2BZsmlaZIxO0CahmwsRCxiLBpjP4KtTJgCgkWNoKlCCmDsdjExibLPkGQ9Q+kWdiH51xmLpPrzt47M3ezAe+FZR53vnPmfPPNzHd3aSl5Eg8kHkg8sEgPpFzJi8ViLp1O3x4Oh8upVOoG8SaTST+bzf4ej8cnnU5n4Moxy95aQKlUejAajR5j0puY8PVpJHh3jneHmUzmQ7vd/jJtjGufsYByuUxvvwHxhiH5MVbleavVOjW0mzncSEA+n9+GV9/Cq1kVFX1naP/Ery/6GUqrGLci2l6BcUP07fR6vX2136UeWUChUHgF8heSDJNhbO/ht9/tdjuyXy1hU0R7G78abHPyHWxfw+albLuUkQTQ8yB5pxDVc7ncw0aj8Uvp01YrlcrNwWDwCQPWlEHP4liJUAGMeWzW7/CgDJvPOHUemZ4uPK1wKn2EgC2KYDhhc69jT5woooyr6TALblhl8nWbyZODgmmLap1tYorDgE3rZ6YAHpVA9k4bxjzDxtTz6sxoSwyxf/hqQ3Cow4zqMwXwnFfQ9qLGvGLzT1VgcPN7T4BDdkcutQIYs/DUpoIU29EHTB+LHORSeIyqWgFMDxCn3g0LkjPdUWnEJgYTi5hskoNcNji00QrABltWQHlJxf34mAEuIx6tAHjIS8wEmrxhjcBDBvuYAa4Qs4uvtQIuDptvCwImtgxaAYhN30MAV1fDlito52PigvsTfBm1rRXAfF4BWVXqcVV9zACXEb5WAD9GsLTnRMNqrIjEzAhcN5hYxOR7cpBLNzasXyuAtyZIDhUAJnRxPT4WOVxud60AzpRfUsqMa8wqlbZVVWDUpHGAQ3ZHLkOzUaTS34Dm5UMomczdtfWYyEiPgCPT6mOk1Hciz3bKwJkrwPHYYLuI06GwXWNKbHP1i8kznfYmT0x+Ygpc6yJUAPN1xOmOwrAFEUcm4cSxtAGG9y1ALGDWm83mDwXXqhoaQhI1zk9KiYnyAHnRU6yG9UUWWQBJY/qo5wfNOvHE4yTCSAAJHf9W2UXYnGI13wPqiRDAwlqEsQBJ6vLHFuI/FZcIawFSSLVavdbv928xJUYse/kNJhj612JcIpwFSCE2ZRwiFiqAol1FLFyAq4grIcBFxJURMEPEfeRLX/l+2hOaSkwzmlcfb2TezMA/mBfHpeByY+PWv8cf65dCmpAkHkg8kHjg//TAX+FKv0FyCEXbAAAAAElFTkSuQmCC" alt=""><div class="Nai-QWZetxwi7-Long"><img class="Nai-rx849zwtC-Long" src="/share-assets/NaiLong-DFiibrak-NaiLong.png" alt=""></div><img class="Nai-7nenqiaOY-Long" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAsCAYAAAA93wvUAAAAAXNSR0IArs4c6QAAC5BJREFUaAXtmQlwVdUZgO/ysgEFqWFNICQVkCUBaoIOCGIL0bLVjkgRUMsWtmGQGQNiyxgsyihYRMrOSAuMlggFqWALUgKySF6kSUDGCiQgIaFiCdIsL8l79/b7L+++3peEEBhsy3Jmzjv/+dfz/+c/yz1PUe6WOysCqrg7adKkdoZhTDdNs9213FdV9Tg861etWvWFk3fChAl/pf/eaooTP3HixCE+n+8tTdPikSlz0uqC0fcW9CdR16YuPpsG/3LgSPifsnHS4lsU9g/quv7cihUrMmyaSwAIb+D0QAY3jwB4bGL1FroOPRV8EjXZSUf+KEGZDi7IcXQ3AhfXuHFjK8hOmWvAIegMuwaPk/x9+CMFkZ6eru/evbu3wNhvCb4t4+7JJBiCCwkJOWkNhmhl0z9L/djlcq1btmzZJZimInACZzq2bt16RVlZWVhxcfFYcHHwjVuzZo04pKSkpEwE9zS1Od1O1APIeKlzmeE948ePfxrcu/T/QuulSjnDzEwVANtP0swTuFppgc7GyJ2ohlfAH8L+WMFj/3769wHOojahvkT9krqFKkUC2B49XwGXCAL4VWvGpUO5SE0hQk1RthXmJaRHdyK1saio6CJ9idbL1MVUnWoVsiATWqndt1sCmGfD/nYnfBUCY/ifNi00NDSrqqpqtt23W3hT4OtNrUFjXBdsPtpkeCfA14ZW/JkP/fmVK1d2EZ6pU6fGVFRUnAacRLA/EpwUp+MGgr8Bt4A2DEXHEc5hRn5HMKbTPwt+M20lrSUsPxEREV+UlJTMwdG05cuX58L/Nuj9S5cuPRNgAmjSpMnKhQsX1giQny+IV+TQMwA7iQx2q1NPdZisEntvw7+RtjmZ8ChwEvUZ4SWoVvqj68fgLBj0t07HxYkN5eXlr+LcCxDfFEFmdJU4jmAPYBnMQ4K3y6JFi8pR+CN4doDLhf6MBM2m16clwyLJrMBsiAx6YtDTlKXidugoYzbnMyF/duBqAx9A/qdCoJVG+LsAW1mA3rNBji9ZsqQCQ8thSGMG/yQSGDmOYwcBY1nre8+dOxfkuPDAf5Km/ZQpUxpVVlbeA1yIzE/Av4ERSUHl0qVL+eBkje9gFsfTBgp6SwoKCl4PIPyAyNmFoHciOK8QYAlErY5j615s/JoWE6tX2LLSElxZ6xcAp0FbH+S4n7GFtF6v9wc0B9LS0sJxNgahxmxwDf08QQ2GToHogEy0EOA9R7NQYGiP0bc3tUHAcxncbzEuG6pVsOEBl0tHHEonfWcjF/AaWgeclsCcZEd+1RLy/0yePLkjdkei9xFQkcgVARtMYKKTD3mNfhPoqdD6SidQQMjAx1EvwjBDCIWFhZNRdA99H7v6CMFVL9BOgutAa525zE4hfTGyBycOs+4+k0oWyTqUYDSV1lkIxJfIzcbWLBxdSzCsSQHuBU4yrhlyT7CPFDvlWMMToA+A9i34T9Ajgd4GLLYCFfr7fjk38I4gxzH8IshLtMMQ7i6XD1rBvUmbTg1KUb8imeEs4MvUcHiPkLr/sGnX07KsNiI/jjqK1P8Ap0ehezc6SsD1xanPq+tLTk6eRVB7gQ9kkAQZHxois5w9QY6+dcDr/bIH0LPF6XgrcYw6X85fGOeQHr+kb5JeC1D0ewR7UuP9CgKNKIL/5/CHgvyYpbEsQLxOAF3vIDKXOhDTG9BbTKb0Bh9wzKly+PDhPmffhvv3778K+ZOMaTWtauPtNrDGIZ7HuUeioqJyhIiheWwIS8C140JTAmo/SyEOvleAA8bgmQkuFQOyvr4BzkLmI9oe8HWZNm1aWJ8+faw1vmvXLsFJhljnucB2YWPsxFp9HD1ySeqKrk+hfQ48AnwOdtajd1PLli3dLINKW05aeFToLZCRu4ZVJCCc4UORvY/MjQBpHWXosPaOgOMImbIe/XJWQ1/WjRUI0m4DBmTD6AivvV6E7yD9KaSUm7vwaUFIgV8MLOB49OzcudPCyQ+82VS3jSCYi+mP5DSQgZ2lfoiu0XKHEB42r1QGn0JAxlCfZwl4kMkkC57C3tfYGYzTcve4H6d+JTJ2kTsCgS/2eDy7wMVip4pTIUPoVgrIWgJ5AUf/M0KhOgpR60y3HYIXyYbD8FuRc7DUAGfMmBFRWloaOAlYMiaDCdzaRAAnhtE0wJF9zsDVUAbC/zH1GAF4kDHIXmAyq/dyM0vG6bOMf39tcox9IDJh2D9E9p6vjecu7m4E7kbg9opAjfPN6d6R8FYxeqUrRVXM4aZitoIWwY7mPPud7P9TGEfkKCtXFa6sipruC/Wu+qGn6MzVBlWr4ycioqLLqtQNimH2xdFaea6m8P8Fz6BNRVP3NQgxR7cvP1dQfVw1nMrR2z6rmL61MrOWsKIUEMFtihayTQ9TcuJL82/oOlrd8M3uH20Y28JXoXRTjKqhZOhQ9EfLpOGDoaj6mG6+r9Y5bQY5nq1Fv45Q6pVZVgtdmjm6q/fcHqfArQIfc0U96jXIWsVsLRPI5C3obhTI81RwkZnO0aIMqdlq9IfB1Fu3J77YflnZ7HfFmnFrTVcoZyS9FVPd3t0sGHzrulpz5NZEquYgSfsGYUqMrHnL8RxXdIZpyIe8Wkg6RNUUvTomLz4xh6vjO7G57sU2V358z5k84D0nfZZOCb/FfB8dDg9X1kS53XIfv6GSn5A4wjDV8WRuIhfmMtGp6erc2Gx3rV9uTiMsYx5HSHtN3dvNW9BPkyNLdm9ZB7Kmncz1gVk8CYaptAzmNVricCd07sDzTAZYBpzqKVeO5SUkdgzmrV/vVNek2YahvCfcmqLONDV1Htnp0VQt6EvtatrEN/FRfBWfXXJO05Pd7+xN3sjMuGPuVHsg4jA2jvAFKRvMWBtfn/Z8Qq/mpUblywzyg9jczJ85PpDq/d0vvrHWOaGUNuIzR5Y5XIxbR1Z9RnGDPHG5WX8n5alKjK3iVNfE/cxk0KvKme4P9c6LT/Lmxyf9wuYrN71jgMN0l/6SMneumt+vX7hNu57W9lF85qvcupGRPyHyTvWdlfMJyQ2JdhSzHvgs5ZbFvx1m51PdenawDXt9vsHwmSERqvXKK3jeDvkkVi97vcYL+Zu3l5jflJQStBN5CT1Z79dR/D6Kzy7E5HVCkctJ4A+e69BVB6sqmxERDWOja1VqFo9STZMHQ+1dW0Z16ZtNr3ehahryBr7gCl52XzUjOjMzECBJT9xvzJruqOrKGFXRv/YZxrMmz0rYKInNzfqDrbOuVnz0lVscEd/ZvZvBqrIZMbi1DPpF0quIXemJ2KOZW+3BxWZ/epq7VRZ/TslNSzn1wMNtWXPxqqlutnmsVlXlH8fMuGGD+sTmuDe2yzm8Jy43cywb51FspATx1tHRTeuJ2eKQGZcYNLSue4py1ReYOvTVSmKgRqPIRk2a9etXpqalBd7CqjOzQ28i9V4r6tGnWXll+RDoHBKyBJzFPG+qagunHtng2Atyke3j5KwLrqzU4v30cjY3tcjqcMetS+hGaM0zMkqcg61Nhx7qwnFF83g9g0jlIWTAJ3HHDgd9DxDEfDKm84Xevb/n1ME7Wwz9+t8L/D6Kz2xuarooQ/FNd9w5yKvBbT87eIqBZDNzI6n9cD44zUXQpa3hvtDgX5crXjPT0qzlmZfwoLzVPUyg6n29tn0UnzX5biWiBF2Jlou92PmvF410N5UBjCM0RNf/WN1+3N8y5XY4h1FOydu0/VJe16Qi0/C9z2ztiIuOXFSdv7a+37do8VV8dsnHOlfWfXJlvfI1o1zXlVXTtcddqprnNMZNbaWi6fI/WL1KaLiyoqpCy2J1e9rkHJL/3WqUuKPueWe6JW1hM0tixhrpunKkXbb7oHK0BmutCP+XGoeKuld8JgCKcid+pFjrxXqhUHXOR1aYag683T5LxSfxTR4k7NcYa8bt3LiTHiKCHJcA3JFPT/bM35GPjbbz0t7Oz8v/BiuB04dcfKbBAAAAAElFTkSuQmCC" alt=""></div><div class="Nai-VuH0FJA7A-Long"><div class="Nai-6FQ9ss4HM-Long"><div class="Nai--oyOc4-Bl-Long">联系我们</div><div class="Nai-92qU7ElOJ-Long"> 中国银联为您提供便捷优质的服务体验 <br> 欢迎通过以下方式与我们联系 </div></div></div><div class="Nai-m4eK0OaqY-Long"><div class="Nai-6FQ9ss4HM-Long"><div class="Nai-Kf7Qxu8---Long"><div class="Nai-LHL-VamPC-Long"><img src="/share-assets/NaiLong-aL4B_53A-NaiLong.png" alt=""></div><div class="Nai-WnFlClaRq-Long"><div class="Nai-W6QpVOevU-Long">在线咨询</div><p>欢迎您使用中国银联</p><p>服务时间：全天24小时</p><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 37 37" shape-rendering="crispEdges" style="min-width: 100px; max-width: 100px; margin-top: 16px;"><path fill="#ffffff" d="M0 0h37v37H0z"></path><path stroke="#000000" d="M0 0.5h7m4 0h2m2 0h4m5 0h1m1 0h1m3 0h7M0 1.5h1m5 0h1m1 0h1m1 0h3m3 0h1m4 0h2m7 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m1 0h1m2 0h1m2 0h1m1 0h1m2 0h3m6 0h1m1 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h2m1 0h4m1 0h2m1 0h1m1 0h1m2 0h3m3 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m2 0h1m1 0h1m1 0h2m3 0h7m1 0h1m1 0h1m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m2 0h1m1 0h1m1 0h1m2 0h1m3 0h2m2 0h2m4 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h1m4 0h3m3 0h2m1 0h3m1 0h3M0 8.5h1m5 0h1m1 0h1m2 0h2m2 0h3m3 0h2m1 0h3m2 0h2m2 0h3M0 9.5h1m2 0h2m4 0h6m1 0h4m2 0h3m6 0h5M1 10.5h6m2 0h2m4 0h2m1 0h1m1 0h1m3 0h2m1 0h3m1 0h2m2 0h2M1 11.5h1m1 0h1m1 0h1m1 0h2m2 0h1m10 0h1m3 0h2m3 0h2m3 0h1M3 12.5h4m3 0h2m1 0h3m4 0h1m2 0h1m2 0h3m1 0h2m4 0h1M2 13.5h4m1 0h5m1 0h3m2 0h3m2 0h2m1 0h2m1 0h1m3 0h1M1 14.5h3m1 0h2m3 0h3m2 0h2m3 0h3m3 0h4m2 0h2m2 0h1M1 15.5h1m1 0h2m3 0h1m1 0h1m2 0h1m4 0h2m2 0h1m1 0h1m2 0h2m3 0h3M0 16.5h2m3 0h2m4 0h2m2 0h1m1 0h3m2 0h1m1 0h7m1 0h1m1 0h3M8 17.5h2m3 0h1m2 0h1m1 0h6m2 0h2m1 0h1m1 0h1m3 0h1M1 18.5h1m2 0h5m2 0h1m2 0h1m1 0h2m1 0h5m1 0h3m1 0h2m1 0h2m2 0h1M0 19.5h5m2 0h2m1 0h1m3 0h3m1 0h3m3 0h1m1 0h1m1 0h1m1 0h1m1 0h2m2 0h1M3 20.5h4m4 0h1m2 0h1m2 0h1m4 0h4m1 0h2m1 0h4M2 21.5h2m1 0h1m2 0h2m2 0h1m1 0h3m1 0h3m1 0h2m3 0h3m2 0h1m1 0h1M0 22.5h1m1 0h1m3 0h1m8 0h3m2 0h3m2 0h1m1 0h2m1 0h4m1 0h2M0 23.5h2m1 0h1m4 0h1m1 0h1m5 0h1m1 0h2m2 0h1m1 0h1m1 0h1m3 0h3M1 24.5h2m1 0h1m1 0h2m1 0h1m1 0h4m1 0h1m2 0h2m2 0h2m2 0h2m1 0h2m4 0h1M0 25.5h2m7 0h2m1 0h2m4 0h4m1 0h1m1 0h3m3 0h1m1 0h1M0 26.5h1m4 0h2m1 0h2m5 0h2m3 0h1m1 0h1m4 0h2m1 0h1m1 0h5M0 27.5h1m2 0h1m3 0h1m1 0h3m2 0h1m1 0h1m11 0h4m1 0h2M0 28.5h1m1 0h1m1 0h3m1 0h1m2 0h1m3 0h4m3 0h1m2 0h2m1 0h5m1 0h1m1 0h1M8 29.5h1m2 0h2m2 0h1m3 0h1m1 0h4m2 0h2m3 0h1m1 0h1m1 0h1M0 30.5h7m2 0h4m1 0h2m2 0h2m3 0h3m2 0h1m1 0h1m1 0h2m2 0h1M0 31.5h1m5 0h1m2 0h2m2 0h1m2 0h1m1 0h3m7 0h1m3 0h1M0 32.5h1m1 0h3m1 0h1m3 0h1m4 0h5m2 0h1m2 0h10m1 0h1M0 33.5h1m1 0h3m1 0h1m2 0h1m4 0h4m1 0h1m2 0h2m3 0h2m1 0h1m2 0h4M0 34.5h1m1 0h3m1 0h1m2 0h1m1 0h2m1 0h4m3 0h1m3 0h1m1 0h1m1 0h1m5 0h2M0 35.5h1m5 0h1m5 0h3m1 0h1m3 0h1m5 0h3m1 0h4m2 0h1M0 36.5h7m1 0h3m1 0h1m1 0h1m4 0h2m1 0h3m3 0h1m1 0h1m2 0h1m2 0h1"></path></svg></div></div><div class="Nai-RAa0Z0wJV-Long"><div class="Nai-mussSzf68-Long">银行合作</div><p>电话：(+86) 021-68401888 转银行合作部</p><p>服务时间：周一至周五 8:30-17:00</p></div><div class="Nai-RAa0Z0wJV-Long"><div class="Nai-mussSzf68-Long">品牌与赞助</div><p>电话：(+86) 021-68401888 转品牌营销部</p><p>服务时间：周一至周五 8:30-17:00</p></div><div class="Nai-RAa0Z0wJV-Long"><div class="Nai-mussSzf68-Long">商户合作</div><p>电话：4008695516</p><p>服务时间：工作日 9:00-18:00</p></div></div></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!----></div>
        </div>

        <!-- Section: kjs (氪金兽) -->
        <div id="app-kjs" class="merged-view-container" v-show="currentTab === 'app-kjs'">
            <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai-kjsSlider-Long"></div><div class="Nai-Pww1a-kpz-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long">转转</div><div class="Nai-Pww1a-kpz-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long">盼之</div><div class="Nai-Pww1a-kpz-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long">微信</div><div class="Nai-Pww1a-kpz-Long">银联</div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long">千岛</div><div class="Nai-Pww1a-kpz-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div><div class="Nai-m5GlKWcpy-Long"><label>标题</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>价格</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>封面图</label><label for="upload-cover-kjs" class="Nai-ga5Us2FoA-Long">上传图片</label><input type="file" accept="image/*" id="upload-cover-kjs" style="display: none;"></div><!----></div><div class="Nai-9RwaoltJT-Long"><div class="kjs-preview"><div class="kjs-bxs"><div class="kjs-fanhto"><svg width="21" height="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z" fill="#333"></path></svg><h3>订单详情</h3></div><div class="kjs-spxq"><div class="kjs-sptp"><img class="kjs-cover-img" src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='83'%3E%3Crect width='80' height='83' fill='%23e8e8e8'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999' font-size='12'%3E商品图%3C/text%3E%3C/svg%3E" alt="" /></div><div class="kjs-sp"><div class="kjs-bt"><p class="kjs-product-title">王者荣耀苹果微信122皮肤</p></div><div class="kjs-spxs"><div class="kjs-bzd"></div><div class="kjs-jg"><p>￥<span class="kjs-price-value">2388.00</span></p></div></div></div></div><div class="kjs-jiaoyiliuc"><div class="kjs-jylc"><h4>交易流程</h4><div class="kjs-fanh-arrow"></div></div><div class="kjs-jy"><div class="kjs-jil"><div class="kjs-jiaoyiyuan"><div class="kjs-yuan"><div></div></div></div><div class="kjs-jiaoyixian"><div></div></div><div class="kjs-jiaoyiyuan"><div class="kjs-yuan"><div></div></div></div><div class="kjs-jiaoyixian"><div></div></div><div class="kjs-jiaoyiyuan"><div class="kjs-yuan"><div></div></div></div><div class="kjs-jiaoyixian"><div></div></div><div class="kjs-jiaoyiyuan"><div class="kjs-yuan"><div></div></div></div><div class="kjs-jiaoyixian"><div></div></div><div class="kjs-jiaoyiyuan"><div class="kjs-yuan"><div></div></div></div><div class="kjs-jyjs"><p>下单</p><p>签订合同</p><p style="position:relative;right:10px;">验号</p><p style="position:relative;right:2px">换绑</p><p style="position:relative;left:5px">完成</p></div></div></div><p class="kjs-ts">已付款，等待卖家配合客服验号</p></div><div class="kjs-saom"><p style="color:#5468fc;margin-top:10px;margin-left:12px">本次交易需要卖家使用微信或支付宝APP扫码联系客服</p><div class="kjs-bxscs"><div class="kjs-jies"><p class="kjs-zy">温馨提示：当前处于下单高峰期可能会出现延迟显示订单等特殊情况</p><button>联系客服</button></div><div class="kjs-ma"><img data-qrcode="true" src="" alt="二维码" /></div></div></div><div class="kjs-ddxq"><div></div><h4>订单详情</h4></div><div class="kjs-dd"><div class="kjs-xq"><p>商品金额</p><p class="kjs-red">￥<span class="kjs-price-value">2388.00</span></p></div><div class="kjs-xq"><p>实付金额</p><p class="kjs-red">￥<span class="kjs-price-value">2388.00</span></p></div><div class="kjs-xq"><p>订单状态</p><p class="kjs-ls">待验号</p></div></div><div class="kjs-dd"><div class="kjs-xq"><p>订单编号</p><p>199620090625</p></div><div class="kjs-xq"><p>支付时间</p><p class="kjs-payment-time"></p></div></div></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!----></div>
        </div>

        <!-- Section: qiandao (千岛) -->
        <div id="app-qiandao" class="merged-view-container" v-show="currentTab === 'app-qiandao'">
            <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai-qiandaoSlider-Long"></div><div class="Nai-Pww1a-kpz-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long">转转</div><div class="Nai-Pww1a-kpz-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long">盼之</div><div class="Nai-Pww1a-kpz-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long">微信</div><div class="Nai-Pww1a-kpz-Long">银联</div><div class="Nai-Pww1a-kpz-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">千岛</div><div class="Nai-Pww1a-kpz-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div><div class="Nai-m5GlKWcpy-Long"><label>标题</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>价格</label><input type="text"></div><div class="Nai-m5GlKWcpy-Long"><label>封面图</label><label for="upload-cover-qiandao" class="Nai-ga5Us2FoA-Long">上传图片</label><input type="file" accept="image/*" id="upload-cover-qiandao" style="display: none;"></div><div class="Nai-m5GlKWcpy-Long"><label>订单</label><div class="Nai-ga5Us2FoA-Long">生成订单</div></div></div><div class="Nai-9RwaoltJT-Long"><div class="qiandao-preview"><div class="qiandao-header"><svg width="20" height="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><h3>订单详情</h3></div><div class="qiandao-order-info"><div class="qiandao-product"><img class="qiandao-cover-img" src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='83'%3E%3Crect width='80' height='83' fill='%23e8e8e8'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999' font-size='12'%3E商品图%3C/text%3E%3C/svg%3E" alt="" /><div class="qiandao-product-detail"><p class="qiandao-product-title">商品标题</p><div class="qiandao-price-row"><span class="qiandao-price">￥<span class="qiandao-price-value">0.00</span></span><span class="qiandao-qty">x 1</span></div></div></div><div class="qiandao-flow"><h4>交易流程</h4><div class="qiandao-steps"><div class="qiandao-step active"><div class="qiandao-dot"></div><span>下单</span></div><div class="qiandao-step-line"></div><div class="qiandao-step"><div class="qiandao-dot"></div><span>联系客服</span></div><div class="qiandao-step-line"></div><div class="qiandao-step"><div class="qiandao-dot"></div><span>验号</span></div><div class="qiandao-step-line"></div><div class="qiandao-step"><div class="qiandao-dot"></div><span>换绑</span></div><div class="qiandao-step-line"></div><div class="qiandao-step"><div class="qiandao-dot"></div><span>完成</span></div></div></div><div class="qiandao-notice"><p>已付款，等待卖家配合客服验号</p></div><div class="qiandao-scan"><p style="color:#5468fc;margin:10px 12px 0">本次交易需要卖家使用微信或支付宝APP扫码联系客服</p><div class="qiandao-scan-content"><div class="qiandao-scan-text"><p class="qiandao-warn">温馨提示：当前处于下单高峰期可能会出现延迟显示订单等特殊情况</p><button>联系客服</button></div><div class="qiandao-qrcode"><img data-qrcode="true" src="" alt="二维码" /></div></div></div><div class="qiandao-detail-section"><h4>订单详情</h4></div><div class="qiandao-detail-rows"><div class="qiandao-detail-row"><span>商品金额</span><span class="qiandao-red">￥<span class="qiandao-price-value">0.00</span></span></div><div class="qiandao-detail-row"><span>实付金额</span><span class="qiandao-red">￥<span class="qiandao-price-value">0.00</span></span></div><div class="qiandao-detail-row"><span>订单状态</span><span>待验号</span></div><div class="qiandao-detail-row"><span>订单编号</span><span>199620090625</span></div></div></div></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!---->
</div>
        </div>

        <!-- Section: kefu (自定义) -->
        <div id="app-kefu" class="merged-view-container" v-show="currentTab === 'app-kefu'">
        <div class="Nai-ByE0c-7xv-Long"><div class="Nai-21kypE-d2-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;"><symbol id="arrow-left"><path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path></symbol><symbol id="three-points"><path d="M512 256a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z m0 341.333333a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 0 0 0 170.666666z m0 341.333334a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z" fill="#272636"></path></symbol></svg><div class="Nai-6rl-cSRSg-Long"><svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#arrow-left"></use></svg><div style="border: 14px solid transparent;">分享页</div><div class="Nai-C-8TKJ7Lv-Long"><div class="Nai-WQL3SzIep-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M761.088 715.3152a38.7072 38.7072 0 0 1 0-77.4144 37.4272 37.4272 0 0 0 37.4272-37.4272V265.0112a37.4272 37.4272 0 0 0-37.4272-37.4272H425.6256a37.4272 37.4272 0 0 0-37.4272 37.4272 38.7072 38.7072 0 1 1-77.4144 0 115.0976 115.0976 0 0 1 114.8416-114.8416h335.4624a115.0976 115.0976 0 0 1 114.8416 114.8416v335.4624a115.0976 115.0976 0 0 1-114.8416 114.8416z" p-id="5993" fill="#515151"></path><path d="M589.4656 883.0976H268.1856a121.1392 121.1392 0 0 1-121.2928-121.2928v-322.56a121.1392 121.1392 0 0 1 121.2928-121.344h321.28a121.1392 121.1392 0 0 1 121.2928 121.2928v322.56c1.28 67.1232-54.1696 121.344-121.2928 121.344zM268.1856 395.3152a43.52 43.52 0 0 0-43.8784 43.8784v322.56a43.52 43.52 0 0 0 43.8784 43.8784h321.28a43.52 43.52 0 0 0 43.8784-43.8784v-322.56a43.52 43.52 0 0 0-43.8784-43.8784z" p-id="5994" fill="#515151"></path></svg><div class="">复制链接</div></div></div></div><div class="Nai-eQ2gVBAwq-Long"><div class="Nai-OVYmmvkVI-Long Nai-kefuSlider-Long"></div><div class="Nai-Pww1a-kpz-Long">闲鱼</div><div class="Nai-Pww1a-kpz-Long">转转</div><div class="Nai-Pww1a-kpz-Long">螃蟹</div><div class="Nai-Pww1a-kpz-Long">盼之</div><div class="Nai-Pww1a-kpz-Long">交易猫</div><div class="Nai-Pww1a-kpz-Long">微信</div><div class="Nai-Pww1a-kpz-Long">银联</div><div class="Nai-Pww1a-kpz-Long">氪金兽</div><div class="Nai-Pww1a-kpz-Long Nai-fNuKCQ3eO-Long">自定义</div></div><div class="Nai-OBJ-tu93t-Long"><div class="Nai-m5GlKWcpy-Long"><label>防红</label><div class="Nai-ga5Us2FoA-Long">立刻配置</div></div><div class="Nai-m5GlKWcpy-Long"><label>背景图</label><label for="upload-bg-kefu" class="Nai-ga5Us2FoA-Long">上传图片</label><input type="file" accept="image/*" id="upload-bg-kefu" style="display: none;"></div><div class="Nai-m5GlKWcpy-Long"><label>客服设置</label><div class="Nai-ga5Us2FoA-Long" @click="showKefuSettingPopup = true">去设置</div></div><div class="Nai-m5GlKWcpy-Long"><label>生成二维码</label><div class="Nai-ga5Us2FoA-Long" @click="showQrCodePopup = true">生成</div></div><div class="Nai-m5GlKWcpy-Long"><label>模板切换</label><div class="Nai-ga5Us2FoA-Long" @click="showTemplateSwitchPopup = true">切换</div></div><div class="Nai-m5GlKWcpy-Long"><label>保存</label><div class="Nai-ga5Us2FoA-Long" @click="saveKefuConfig">保存配置</div></div><div class="Nai-m5GlKWcpy-Long"><label>导入模板</label><div class="Nai-ga5Us2FoA-Long" @click="showImportTemplatePopup = true">导入</div></div></div><div class="kefu-text-editor" v-show="importedTemplateName"><input type="text" class="kefu-text-editor-input" :value="editingTextValue" @input="onEditingTextInput($event)" :placeholder="editingTextTarget ? '修改选中的文字...' : '👆 点击下方模板中的文字进行选中'" /></div><div class="Nai-9RwaoltJT-Long"><div class="kefu-preview-area" id="kefu-preview-area"><img class="kefu-bg-img" id="kefu-bg-img" :src="kefuBgUrl" v-show="kefuBgUrl && !importedTemplateName" alt="背景图" :style="{ transform: 'translate(' + kefuBgX + 'px,' + kefuBgY + 'px)' }"><div id="kefu-imported-container"></div></div></div></div><div class="Nai-v-uXAKodR-Long"><div class="Nai-YaGgQ-cOR-Long"><div>配置防红</div><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M587.19 506.246l397.116-397.263a52.029 52.029 0 0 0 0-73.143l-2.194-2.194a51.98 51.98 0 0 0-73.143 0l-397.068 397.8-397.068-397.8a51.98 51.98 0 0 0-73.143 0l-2.146 2.194a51.054 51.054 0 0 0 0 73.143l397.069 397.263L39.544 903.461a52.029 52.029 0 0 0 0 73.142l2.146 2.195a51.98 51.98 0 0 0 73.143 0L511.9 581.583l397.068 397.215a51.98 51.98 0 0 0 73.143 0l2.194-2.146a52.029 52.029 0 0 0 0-73.143L587.19 506.246z" p-id="2533" fill="#2c2c2c"></path></svg></div><div class="Nai-pSeH-2pCE-Long"><div class="Nai-cJajo--5y-Long" style="display: none;"><div class="Nai-ExZZblugO-Long"><div></div><div></div><div></div><div></div></div></div></div></div><!----></div>
</div>

    <!-- 防红配置弹窗（底部半屏） -->
    <div v-if="showAntiRedPopup" class="anti-red-popup-overlay" @click.self="closeAntiRedPopup">
      <div class="anti-red-popup">
        <div class="anti-red-popup-header">
          <span>配置防红</span>
          <label class="anti-red-switch">
            <input type="checkbox" v-model="antiRedEnabled" @change="toggleAntiRed">
            <span class="anti-red-slider"></span>
          </label>
        </div>
        <div class="anti-red-popup-body">
          <!-- 库存和余额信息 -->
          <div class="anti-red-info-row">
            <span>库存: <strong>{{ userInventory }}</strong></span>
            <span>余额: <strong>{{ userBalance }}元</strong></span>
          </div>

          <!-- 点按配置防洪按钮 -->
          <button class="anti-red-main-btn" @click="handleConfigAntiRed">点我购买接口/自定义</button>

          <!-- 把鱼引到浏览器开关 -->
          <div class="anti-red-switch-row">
            <span>把鱼引到浏览器</span>
            <label class="anti-red-switch">
              <input type="checkbox" v-model="redirectToBrowser">
              <span class="anti-red-slider"></span>
            </label>
          </div>

          <!-- 已购买的接口和自定义接口列表 -->
          <div v-if="isLoadingAntiRed || isLoadingCustom" class="anti-red-loading">加载中...</div>
          <div v-else-if="allAntiRedLinks.length === 0" class="anti-red-empty">暂无接口</div>
          <div v-else class="anti-red-list">
            <div v-for="link in allAntiRedLinks" :key="link.id" class="anti-red-item">
              <div class="anti-red-item-info">
                <div class="anti-red-item-title">{{ link.apiName || link.name || '未命名接口' }}</div>
                <div class="anti-red-item-meta">
                  <span v-if="link.isCustom">{{ formatDate(link.createdAt) }} 创建</span>
                  <span v-else>{{ link.purchaseDate || '12/23' }} 购买 （共{{ link.totalPurchases || 0 }}人购买）</span>
                  <span class="anti-red-visit-count">{{ link.visitCount || 0 }}次访问</span>
                </div>
              </div>
              <div class="anti-red-item-action" :class="{ 'is-cancel': link.isActive }">
                <button
                  class="anti-red-action-btn"
                  :class="{ cancel: link.isActive, apply: !link.isActive }"
                  @click="link.isActive ? (link.isCustom ? cancelCustomLink(link) : cancelAntiRedLink(link)) : (link.isCustom ? applyCustomLink(link) : applyAntiRedLink(link))"
                >{{ link.isActive ? '取消' : '应用' }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加自定义接口弹窗 -->
    <div v-if="showAddCustomPopup" class="anti-red-popup-overlay custom-overlay" @click.self="closeAddCustomPopup">
      <div class="anti-red-popup custom-popup">
        <div class="anti-red-popup-header">
          <span>添加自定义接口</span>
        </div>
        <div class="anti-red-popup-body">
          <!-- 库存和余额信息 -->
          <div class="anti-red-info-row">
            <span>已添加: <strong>{{ customLinks.length }}</strong> / 5</span>
            <span>剩余: <strong>{{ 5 - customLinks.length }}</strong> 个</span>
          </div>

          <div class="anti-red-form-group">
            <label>防红链接 <span class="required">*</span></label>
            <input v-model="customLinkUrl" type="text" placeholder="" class="anti-red-input" />
          </div>
          <div class="anti-red-form-group">
            <label>备注（选填）</label>
            <input v-model="customLinkName" type="text" placeholder="给接口起个名字方便识别" class="anti-red-input" />
          </div>
          <button class="anti-red-submit-btn" @click="addCustomLink" :disabled="isAddingCustom">
            {{ isAddingCustom ? '添加中...' : '添加' }}
          </button>

          <!-- 已添加的自定义接口列表 -->
          <div v-if="customLinks.length > 0" style="margin-top: 20px;">
            <div style="font-size: 14px; color: #666; margin-bottom: 12px; font-weight: 500;">已添加的接口</div>
            <div class="anti-red-list">
              <div v-for="link in customLinks" :key="link.id" class="anti-red-item">
                <div class="anti-red-item-info">
                  <div class="anti-red-item-title">{{ link.name || '未命名接口' }}</div>
                  <div class="anti-red-item-meta">{{ link.apiUrl }}</div>
                </div>
                <div class="anti-red-item-action">
                  <button class="anti-red-delete-btn" @click="deleteCustomLink(link)">删除</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 购买接口弹窗（第二层） -->
    <div v-if="showPurchasePopup" class="anti-red-popup-overlay purchase-overlay" @click.self="closePurchasePopup">
      <div class="anti-red-popup purchase-popup">
        <div class="anti-red-popup-header">
          <span>购买接口</span>
        </div>
        <div class="anti-red-popup-body">
          <!-- 三个按钮入口 -->
          <button class="anti-red-main-btn" @click="openAddCustomPopup">自定义接口</button>
          <button class="anti-red-main-btn purchase-free-btn" @click="quickBuy('free')">
            免费接口
            <span class="purchase-btn-badge">{{ freeLinks.length }}个可领</span>
          </button>
          <button class="anti-red-main-btn purchase-paid-btn" @click="quickBuy('paid')">
            付费接口
            <span class="purchase-btn-badge" v-if="paidLinks.length > 0">{{ paidLinks.length }}个 · ¥{{ paidMinPrice }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 客服设置弹窗 -->
    <div v-if="showKefuSettingPopup" class="anti-red-popup-overlay kefu-setting-overlay" @click.self="closeKefuSettingPopup">
      <div class="anti-red-popup kefu-setting-popup">
        <div class="anti-red-popup-header">
          <span>客服设置</span>
        </div>
        <div class="anti-red-popup-body">
          <div class="kefu-platform-list">
            <div class="kefu-platform-item" :class="{ active: selectedKefuPlatform === '' }" @click="selectKefuPlatform('')">
              <div class="kefu-platform-name">默认<span style="font-size:11px;color:#999;margin-left:4px">跟随导入模板</span></div>
              <div class="kefu-platform-check" v-if="selectedKefuPlatform === ''">✓</div>
            </div>
            <div class="kefu-platform-item" :class="{ active: selectedKefuPlatform === 'xianyu' }" @click="selectKefuPlatform('xianyu')">
              <div class="kefu-platform-name">闲鱼客服</div>
              <div class="kefu-platform-check" v-if="selectedKefuPlatform === 'xianyu'">✓</div>
            </div>
            <div class="kefu-platform-item" :class="{ active: selectedKefuPlatform === 'zhuanzhuan' }" @click="selectKefuPlatform('zhuanzhuan')">
              <div class="kefu-platform-name">转转客服</div>
              <div class="kefu-platform-check" v-if="selectedKefuPlatform === 'zhuanzhuan'">✓</div>
            </div>
            <div class="kefu-platform-item" :class="{ active: selectedKefuPlatform === 'pangxie' }" @click="selectKefuPlatform('pangxie')">
              <div class="kefu-platform-name">螃蟹客服</div>
              <div class="kefu-platform-check" v-if="selectedKefuPlatform === 'pangxie'">✓</div>
            </div>
            <div class="kefu-platform-item" :class="{ active: selectedKefuPlatform === 'panzhi' }" @click="selectKefuPlatform('panzhi')">
              <div class="kefu-platform-name">盼之客服</div>
              <div class="kefu-platform-check" v-if="selectedKefuPlatform === 'panzhi'">✓</div>
            </div>
            <div class="kefu-platform-item" :class="{ active: selectedKefuPlatform === 'jiaoyimao' }" @click="selectKefuPlatform('jiaoyimao')">
              <div class="kefu-platform-name">交易猫客服</div>
              <div class="kefu-platform-check" v-if="selectedKefuPlatform === 'jiaoyimao'">✓</div>
            </div>
            <div class="kefu-platform-item" :class="{ active: selectedKefuPlatform === 'wx' }" @click="selectKefuPlatform('wx')">
              <div class="kefu-platform-name">微信客服</div>
              <div class="kefu-platform-check" v-if="selectedKefuPlatform === 'wx'">✓</div>
            </div>
            <div class="kefu-platform-item" :class="{ active: selectedKefuPlatform === 'yinlian' }" @click="selectKefuPlatform('yinlian')">
              <div class="kefu-platform-name">银联客服</div>
              <div class="kefu-platform-check" v-if="selectedKefuPlatform === 'yinlian'">✓</div>
            </div>
            <div class="kefu-platform-item" :class="{ active: selectedKefuPlatform === 'kjs' }" @click="selectKefuPlatform('kjs')">
              <div class="kefu-platform-name">氪金兽客服</div>
              <div class="kefu-platform-check" v-if="selectedKefuPlatform === 'kjs'">✓</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 生成二维码弹窗 -->
    <div v-if="showQrCodePopup" class="anti-red-popup-overlay qrcode-overlay" @click.self="closeQrCodePopup">
      <div class="anti-red-popup qrcode-popup">
        <div class="anti-red-popup-header">
          <span>生成二维码</span>
        </div>
        <div class="anti-red-popup-body" style="text-align: center; padding: 20px;">
          <p style="color: #666; font-size: 14px;">功能开发中...</p>
        </div>
      </div>
    </div>

    <!-- 模板切换弹窗 -->
    <div v-if="showTemplateSwitchPopup" class="anti-red-popup-overlay template-switch-overlay" @click.self="closeTemplateSwitchPopup">
      <div class="anti-red-popup template-switch-popup">
        <div class="anti-red-popup-header">
          <span>模板切换</span>
        </div>
        <div class="anti-red-popup-body">
          <!-- 已保存的模板 -->
          <div v-if="savedTemplates.length > 0" class="saved-template-section">
            <div class="saved-template-title">我保存的模板</div>
            <div class="kefu-platform-list">
              <div class="kefu-platform-item" v-for="tpl in savedTemplates" :key="tpl.id" :class="{ active: selectedTemplateName === tpl.name }" @click="applySavedTemplate(tpl)">
                <div class="kefu-platform-icon">📄</div>
                <div class="kefu-platform-info">
                  <div class="kefu-platform-name">{{ tpl.name }}</div>
                  <div class="kefu-platform-time">{{ tpl.createTime }}</div>
                </div>
                <div class="kefu-platform-check" v-if="selectedTemplateName === tpl.name">✓</div>
                <div class="saved-template-delete" @click.stop="deleteSavedTemplate(tpl)">✕</div>
              </div>
            </div>
          </div>
          <div v-else class="saved-template-empty">
            <p>暂无保存的模板</p>
            <p style="font-size: 12px; color: #bbb;">点击上方「保存配置」可保存当前配置为模板</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 保存模板弹窗 -->
    <div v-if="showSaveTemplatePopup" class="anti-red-popup-overlay save-template-overlay" @click.self="closeSaveTemplatePopup">
      <div class="anti-red-popup save-template-popup">
        <div class="anti-red-popup-header">
          <span>保存为模板</span>
        </div>
        <div class="anti-red-popup-body">
          <div class="anti-red-form-group">
            <label>模板名称 <span class="required">*</span></label>
            <input v-model="saveTemplateName" type="text" placeholder="给模板起个名字" class="anti-red-input" maxlength="20" />
          </div>
          <div style="font-size: 12px; color: #999; margin-bottom: 16px;">将保存当前的背景图、客服设置等配置</div>
          <button class="anti-red-submit-btn" @click="confirmSaveTemplate">确认保存</button>
        </div>
      </div>
    </div>

    <!-- 导入模板弹窗 -->
    <div v-if="showImportTemplatePopup" class="anti-red-popup-overlay import-template-overlay" @click.self="closeImportTemplatePopup">
      <div class="anti-red-popup import-template-popup">
        <div class="anti-red-popup-header">
          <span>导入分享页模板</span>
        </div>
        <div class="anti-red-popup-body">
          <div style="font-size: 12px; color: #999; margin-bottom: 14px;">选择一个平台模板导入到预览区，导入后可点击文字进行修改</div>
          <div class="kefu-platform-list">
            <div class="kefu-platform-item" @click="importTemplate('app-xianyu', '闲鱼(游戏鱼)', 'game')">
              <div class="kefu-platform-name">闲鱼(游戏鱼)</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-xianyu', '闲鱼(实物鱼)', 'physical')">
              <div class="kefu-platform-name">闲鱼(实物鱼)</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-zhuanzhuan', '转转(游戏鱼)', 'game')">
              <div class="kefu-platform-name">转转(游戏鱼)</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-zhuanzhuan', '转转(实物鱼)', 'physical')">
              <div class="kefu-platform-name">转转(实物鱼)</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-pangxie', '螃蟹')">
              <div class="kefu-platform-name">螃蟹</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-panzhi', '盼之')">
              <div class="kefu-platform-name">盼之</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-jiaoyimao', '交易猫')">
              <div class="kefu-platform-name">交易猫</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-wx', '微信')">
              <div class="kefu-platform-name">微信</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-yinlian', '银联')">
              <div class="kefu-platform-name">银联</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-kjs', '氪金兽')">
              <div class="kefu-platform-name">氪金兽</div>
            </div>
            <div class="kefu-platform-item" @click="importTemplate('app-qiandao', '千岛')">
              <div class="kefu-platform-name">千岛</div>
            </div>
          </div>
          <div v-if="importedTemplateName" style="margin-top: 14px; padding: 10px; background: #f0f9ff; border-radius: 8px; font-size: 13px; color: #1677ff;">
            当前已导入: {{ importedTemplateName }} 模板
          </div>
        </div>
      </div>
    </div>

</template>


<script>
import { ref, computed, onMounted, nextTick, watch } from 'vue';
import QRCode from 'qrcode';
import { API_BASE_URL, apiFetch } from '@/config/api';
import DOMPurify from 'dompurify';

export default {
name: 'MergedComponent',
emits: ['close', 'copy-success'],
setup(props, { emit }) {
  const currentTab = ref('app-xianyu'); // Default to 闲鱼
  const qrcodeDataUrl = ref(''); // 动态二维码图片
  const chatLink = ref(''); // 客服聊天链接
  const coverImageUrl = ref(''); // 封面图本地预览URL
  const coverImagePath = ref(''); // 封面图后端存储路径
  const coverImageFile = ref(null); // 封面图文件对象
  const orderTitle = ref(''); // 订单标题
  const orderPrice = ref(''); // 订单价格
  const isCreatingOrder = ref(false); // 是否正在创建订单
  const chatRoomEnabled = ref(false); // 聊天室是否开启（螃蟹聊天室）
  const pzChatRoomEnabled = ref(false); // 聊天室是否开启（盼之聊天室）
  
  // 防红链接弹窗相关
  const showAntiRedPopup = ref(false); // 是否显示配置防红弹窗
  const showPurchasePopup = ref(false); // 是否显示购买接口弹窗
  const purchasedLinks = ref([]); // 已购买的接口列表
  const availableLinks = ref([]); // 可购买的接口列表
  const purchaseTab = ref(''); // 购买页面当前 Tab：'' / free / paid
  // 只取最新添加的那一个（后端已按创建时间降序排列）
  const freeLinks = computed(() => {
    const list = availableLinks.value.filter(l => l.isFree);
    return list.length > 0 ? [list[0]] : [];
  });
  const paidLinks = computed(() => {
    const list = availableLinks.value.filter(l => !l.isFree);
    return list.length > 0 ? [list[0]] : [];
  });
  const paidMinPrice = computed(() => {
    if (paidLinks.value.length === 0) return '0';
    return parseFloat(paidLinks.value[0].price || 0).toFixed(2);
  });
  const isLoadingAntiRed = ref(false); // 是否正在加载已购买接口
  const isLoadingAvailable = ref(false); // 是否正在加载可购买接口
  const antiRedEnabled = ref(false); // 防红开关状态
  const redirectToBrowser = ref(false); // 把鱼引到浏览器开关（独立状态）

  // 客服设置和二维码相关
  const showKefuSettingPopup = ref(false); // 客服设置弹窗
  const selectedKefuPlatform = ref(''); // 选中的客服平台
  const showQrCodePopup = ref(false); // 生成二维码弹窗
  const showTemplateSwitchPopup = ref(false); // 模板切换弹窗
  const showSaveTemplatePopup = ref(false); // 保存模板弹窗
  const saveTemplateName = ref(''); // 保存模板名称
  const savedTemplates = ref([]); // 已保存的模板列表
  const selectedTemplateName = ref(''); // 当前选中的模板名称
  const showImportTemplatePopup = ref(false); // 导入模板弹窗
  const importedTemplateHtml = ref(''); // 导入的模板HTML
  const importedTemplateName = ref(''); // 导入的来源模板名

  // 自定义背景图相关
  const kefuBgUrl = ref(''); // 自定义背景图URL
  const kefuBgX = ref(0); // 背景图X偏移
  const kefuBgY = ref(0); // 背景图Y偏移

  // 自定义防红接口相关
  const showAddCustomPopup = ref(false);
  const customLinks = ref([]);
  const isLoadingCustom = ref(false);
  const isAddingCustom = ref(false);
  const customLinkName = ref('');
  const customLinkUrl = ref('');

  // 用户库存和余额
  const userInventory = ref(3);
  const userBalance = ref(5.13);
  const visitCount = ref(0); // 链接访问次数
  const paidLinkPrice = ref('1.00'); // 付费接口单价

  // 合并已购买接口和自定义接口
  const allAntiRedLinks = computed(() => {
    const purchased = purchasedLinks.value.map(link => ({
      ...link,
      isCustom: false
    }));
    const custom = customLinks.value.map(link => ({
      ...link,
      isCustom: true
    }));
    return [...purchased, ...custom];
  });

  const tabMap = {
    "闲鱼": "app-xianyu",
    "转转": "app-zhuanzhuan",
    "螃蟹": "app-pangxie",
    "盼之": "app-panzhi",
    "交易猫": "app-jiaoyimao",
    "微信": "app-wx",
    "银联": "app-yinlian",
    "氪金兽": "app-kjs",
    "千岛": "app-qiandao",
    "自定义": "app-kefu"
  };

  // 滑块位置类名映射（根据tab对应的位置）
  const sliderClassMap = {
    "app-xianyu": "Nai-3td5xqI7Q-Long",      // 第一行第一个
    "app-zhuanzhuan": "Nai-boAe63TtU-Long",  // 第一行第二个
    "app-pangxie": "Nai-KJuVCciCC-Long",     // 第一行第三个
    "app-panzhi": "Nai-vKPJR1emC-Long",      // 第一行第四个
    "app-jiaoyimao": "Nai-9VlAlZGAc-Long",   // 第二行第一个
    "app-wx": "Nai--QptuEv-N-Long",          // 第二行第二个
    "app-yinlian": "Nai-gnFvgb5N3-Long",     // 第二行第三个
    "app-kjs": "Nai-kjsSlider-Long",          // 第二行第四个
    "app-qiandao": "Nai-qiandaoSlider-Long",  // 第三行第一个
    "app-kefu": "Nai-kefuSlider-Long"          // 第三行第二个
  };

  // 更新所有滑块的位置类名
  const updateSliderPosition = (tabId) => {
    const sliders = document.querySelectorAll('.Nai-OVYmmvkVI-Long');
    const newClass = sliderClassMap[tabId];
    if (!newClass) return;
    
    sliders.forEach(slider => {
      // 移除所有位置类名
      Object.values(sliderClassMap).forEach(cls => {
        slider.classList.remove(cls);
      });
      // 添加新的位置类名
      slider.classList.add(newClass);
    });

    // 更新tab项的选中状态
    const tabItems = document.querySelectorAll('.Nai-Pww1a-kpz-Long');
    const tabNames = Object.keys(tabMap);
    const selectedTabName = tabNames.find(name => tabMap[name] === tabId);
    
    tabItems.forEach(item => {
      const itemText = item.textContent.trim();
      if (itemText === selectedTabName) {
        item.classList.add('Nai-fNuKCQ3eO-Long');
      } else {
        item.classList.remove('Nai-fNuKCQ3eO-Long');
      }
    });
  };

  const selectedTemplate = ref('游戏鱼');
  const templateMap = { '1': '游戏鱼', '2': '实物鱼', '3': '老版-违规', '4': '老版-游戏' };
  const originalLowerHTML = new Map();

  // 获取当前登录用户信息
  const getCurrentUser = () => {
    try {
      const stored = localStorage.getItem('user');
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (e) {
      console.error('获取用户信息失败:', e);
    }
    return null;
  };

  // 当前订单ID（生成订单后设置）
  const currentOrderId = ref(null);

  // 获取已购买的接口列表
  const fetchPurchasedLinks = async () => {
    isLoadingAntiRed.value = true;
    try {
      const response = await apiFetch('/api/user/api-links/purchased');
      if (response && response.code === 0) {
        purchasedLinks.value = (response.data || []).map(link => ({
          ...link,
          // 格式化购买日期为 MM/DD 格式
          purchaseDate: link.purchasedAt ? formatDate(link.purchasedAt) : '未知',
          // 使用后端返回的购买人数
          totalPurchases: link.purchaseCount || 0
        }));
      } else {
        // API返回错误，使用空数组
        purchasedLinks.value = [];
      }
    } catch (error) {
      // 捕获所有错误（包括401），不影响弹窗显示
      console.error('获取已购买接口失败:', error);
      purchasedLinks.value = [];
      // 不重新抛出错误，避免触发alert
    } finally {
      isLoadingAntiRed.value = false;
    }
  };

  // 格式化日期为 MM/DD 格式
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${month}/${day}`;
    } catch (e) {
      return '未知';
    }
  };

  // 获取自定义防红接口列表
  const fetchCustomLinks = async () => {
    isLoadingCustom.value = true;
    try {
      const response = await apiFetch('/api/custom-anti-red/list');
      if (response && response.code === 0) {
        customLinks.value = response.data || [];
      }
    } catch (error) {
      console.error('获取自定义接口失败:', error);
      customLinks.value = [];
    } finally {
      isLoadingCustom.value = false;
    }
  };

  // 初始化防红状态（页面加载时调用）
  const initAntiRedStatus = () => {
    const hasPurchasedActive = purchasedLinks.value.some(link => link.isActive);
    const hasCustomActive = customLinks.value.some(link => link.isActive);
    // 如果有任意接口被应用，默认开启防红
    if (hasPurchasedActive || hasCustomActive) {
      antiRedEnabled.value = true;
    }
  };

  // 获取可购买的接口列表
  const fetchAvailableLinks = async () => {
    isLoadingAvailable.value = true;
    try {
      const response = await apiFetch('/api/user/api-links/available');
      if (response && response.code === 0) {
        availableLinks.value = response.data || [];
      }
    } catch (error) {
      console.error('获取可购买接口失败:', error);
      availableLinks.value = [];
    } finally {
      isLoadingAvailable.value = false;
    }
  };

  // 打开配置防红弹窗
  const openAntiRedPopup = async () => {
    showAntiRedPopup.value = true;

    // 从服务器获取最新的用户余额
    fetchUserBalance();

    // 获取付费接口单价
    fetchPaidLinkPrice();

    // 异步获取已购买的接口（不阻塞弹窗显示）
    fetchPurchasedLinks().then(() => {
      // 库存就是已购买接口的数量
      userInventory.value = purchasedLinks.value.length;
    }).catch(err => {
      console.error('获取接口列表失败:', err);
      // 失败时使用默认值
      userInventory.value = 0;
    });
  };

  // 获取用户余额（从服务器）
  const fetchUserBalance = async () => {
    try {
      const response = await apiFetch('/api/auth/me');
      if (response && response.code === 0 && response.data) {
        userBalance.value = parseFloat(response.data.balance) || 0;
        visitCount.value = response.data.visitCount || 0;
      } else {
        // API返回错误，使用本地缓存的余额
        const user = getCurrentUser();
        if (user) {
          userBalance.value = parseFloat(user.balance) || 0;
        }
      }
    } catch (error) {
      console.error('获取用户余额失败:', error);
      // 失败时使用本地缓存的余额
      const user = getCurrentUser();
      if (user) {
        userBalance.value = parseFloat(user.balance) || 0;
      } else {
        userBalance.value = 0;
      }
    }
  };

  // 获取付费接口单价
  const fetchPaidLinkPrice = async () => {
    try {
      const response = await apiFetch('/api/user/api-links/paid-price');
      if (response && response.code === 0 && response.data) {
        paidLinkPrice.value = response.data.price || '1.00';
      }
    } catch (error) {
      console.error('获取付费接口单价失败:', error);
    }
  };

  // 关闭配置防红弹窗（带动画）
  const closeAntiRedPopup = () => {
    // 添加关闭动画类
    const popup = document.querySelector('.anti-red-popup');
    if (popup) {
      popup.classList.add('slide-down');
      // 等待动画完成后再关闭
      setTimeout(() => {
        showAntiRedPopup.value = false;
      }, 300);
    } else {
      showAntiRedPopup.value = false;
    }
  };

  // 打开添加自定义接口弹窗
  const openAddCustomPopup = () => {
    customLinkName.value = '';
    customLinkUrl.value = '';
    showAddCustomPopup.value = true;
  };

  // 关闭添加自定义接口弹窗（带动画）
  const closeAddCustomPopup = () => {
    // 添加关闭动画类
    const popup = document.querySelector('.custom-popup');
    const overlay = document.querySelector('.custom-overlay');
    if (popup && overlay) {
      popup.classList.add('slide-down');
      overlay.classList.add('fade-out');
      // 等待动画完成后再关闭
      setTimeout(() => {
        showAddCustomPopup.value = false;
      }, 300);
    } else {
      showAddCustomPopup.value = false;
    }
  };

  // 关闭客服设置弹窗
  const closeKefuSettingPopup = () => {
    const popup = document.querySelector('.kefu-setting-popup');
    const overlay = document.querySelector('.kefu-setting-overlay');
    if (popup && overlay) {
      popup.classList.add('slide-down');
      overlay.classList.add('fade-out');
      setTimeout(() => {
        showKefuSettingPopup.value = false;
      }, 300);
    } else {
      showKefuSettingPopup.value = false;
    }
  };

  // 选择客服平台
  const selectKefuPlatform = (platform) => {
    selectedKefuPlatform.value = platform;
    closeKefuSettingPopup();
    // 切换客服后自动更新二维码
    nextTick(async () => {
      await generateQRCode(currentOrderId.value);
    });
  };

  // 关闭二维码弹窗
  const closeQrCodePopup = () => {
    const popup = document.querySelector('.qrcode-popup');
    const overlay = document.querySelector('.qrcode-overlay');
    if (popup && overlay) {
      popup.classList.add('slide-down');
      overlay.classList.add('fade-out');
      setTimeout(() => {
        showQrCodePopup.value = false;
      }, 300);
    } else {
      showQrCodePopup.value = false;
    }
  };

  // 关闭模板切换弹窗
  const closeTemplateSwitchPopup = () => {
    const popup = document.querySelector('.template-switch-popup');
    const overlay = document.querySelector('.template-switch-overlay');
    if (popup && overlay) {
      popup.classList.add('slide-down');
      overlay.classList.add('fade-out');
      setTimeout(() => {
        showTemplateSwitchPopup.value = false;
      }, 300);
    } else {
      showTemplateSwitchPopup.value = false;
    }
  };

  // 保存自定义配置 - 打开弹窗
  const saveKefuConfig = () => {
    saveTemplateName.value = '';
    showSaveTemplatePopup.value = true;
  };

  // 关闭保存模板弹窗
  const closeSaveTemplatePopup = () => {
    const popup = document.querySelector('.save-template-popup');
    const overlay = document.querySelector('.save-template-overlay');
    if (popup && overlay) {
      popup.classList.add('slide-down');
      overlay.classList.add('fade-out');
      setTimeout(() => {
        showSaveTemplatePopup.value = false;
      }, 300);
    } else {
      showSaveTemplatePopup.value = false;
    }
  };

  // 确认保存模板
  const confirmSaveTemplate = () => {
    const name = saveTemplateName.value.trim();
    if (!name) {
      alert('请输入模板名称');
      return;
    }
    // 检查是否重名
    if (savedTemplates.value.some(t => t.name === name)) {
      alert('已存在同名模板，请换个名字');
      return;
    }
    // 保存当前配置快照
    const template = {
      id: Date.now(),
      name: name,
      createTime: new Date().toLocaleString(),
      config: {
        bgUrl: kefuBgUrl.value,
        bgX: kefuBgX.value,
        bgY: kefuBgY.value,
        kefuPlatform: selectedKefuPlatform.value,
        importedHtml: importedTemplateHtml.value,
        importedFrom: importedTemplateName.value
      }
    };
    savedTemplates.value.push(template);
    // 存到 localStorage
    try {
      localStorage.setItem('kefu_saved_templates', JSON.stringify(savedTemplates.value));
    } catch (e) {
      console.error('保存模板到本地失败:', e);
    }
    closeSaveTemplatePopup();
    alert('模板保存成功！');
  };

  // 应用已保存的模板
  const applySavedTemplate = (template) => {
    selectedTemplateName.value = template.name;
    // 恢复配置
    if (template.config) {
      kefuBgUrl.value = template.config.bgUrl || '';
      kefuBgX.value = template.config.bgX || 0;
      kefuBgY.value = template.config.bgY || 0;
      selectedKefuPlatform.value = template.config.kefuPlatform || '';
      importedTemplateHtml.value = template.config.importedHtml || '';
      importedTemplateName.value = template.config.importedFrom || '';
      // 恢复导入的HTML到DOM
      nextTick(() => {
        const container = document.getElementById('kefu-imported-container');
        if (container && template.config.importedHtml) {
          container.innerHTML = template.config.importedHtml;
          // 重新加上编辑提示
          const textEls = container.querySelectorAll('div, span, label');
          textEls.forEach(el => {
            if (el.childNodes.length <= 3 && el.textContent.trim() && el.children.length <= 1) {
              el.classList.add('kefu-editable-text');
            }
          });
          // 绑定双击编辑事件
          bindImportedContainerClick();
        } else if (container) {
          container.innerHTML = '';
        }
      });
    }
    closeTemplateSwitchPopup();
  };

  // 删除已保存的模板
  const deleteSavedTemplate = (template) => {
    if (!confirm(`确定删除模板「${template.name}」？`)) return;
    savedTemplates.value = savedTemplates.value.filter(t => t.id !== template.id);
    if (selectedTemplateName.value === template.name) {
      selectedTemplateName.value = '';
    }
    try {
      localStorage.setItem('kefu_saved_templates', JSON.stringify(savedTemplates.value));
    } catch (e) {
      console.error('更新本地模板失败:', e);
    }
  };

  // 从 localStorage 加载已保存的模板
  const loadSavedTemplates = () => {
    try {
      const data = localStorage.getItem('kefu_saved_templates');
      if (data) {
        savedTemplates.value = JSON.parse(data);
      }
    } catch (e) {
      console.error('加载本地模板失败:', e);
    }
  };

  // 关闭导入模板弹窗
  const closeImportTemplatePopup = () => {
    const popup = document.querySelector('.import-template-popup');
    const overlay = document.querySelector('.import-template-overlay');
    if (popup && overlay) {
      popup.classList.add('slide-down');
      overlay.classList.add('fade-out');
      setTimeout(() => {
        showImportTemplatePopup.value = false;
      }, 300);
    } else {
      showImportTemplatePopup.value = false;
    }
  };

  // 导入其他平台的预览区
  const importTemplate = (platformId, platformName, variant) => {
    const targetContainer = document.getElementById('kefu-imported-container');
    if (!targetContainer) {
      alert('找不到导入容器');
      return;
    }
    const platformContainer = document.getElementById(platformId);
    if (!platformContainer) {
      alert('找不到平台: ' + platformId);
      return;
    }
    let platformEl = platformContainer.querySelector('.Nai-9RwaoltJT-Long');
    if (!platformEl) {
      platformEl = platformContainer.querySelector('.Nai-ByE0c-7xv-Long');
    }
    if (!platformEl) {
      platformEl = platformContainer.children[0];
    }
    if (!platformEl) {
      alert('找不到该平台的预览内容');
      return;
    }

    // 闲鱼/转转有两个模板，需要先临时把DOM内容换成目标模板再克隆
    let savedHtml = null;
    if (variant === 'physical') {
      savedHtml = platformEl.innerHTML;
      const htmlToUse = platformId === 'app-zhuanzhuan' ? zhuanzhuanHtml : fishHtml;
      platformEl.innerHTML = DOMPurify.sanitize(htmlToUse, { ADD_TAGS: ['use'], ADD_ATTR: ['xlink:href'] });
    } else if (variant === 'game' && originalLowerHTML.has(platformEl)) {
      savedHtml = platformEl.innerHTML;
      platformEl.innerHTML = DOMPurify.sanitize(originalLowerHTML.get(platformEl), { ADD_TAGS: ['use'], ADD_ATTR: ['xlink:href'] });
    }

    // 统一从DOM克隆
    const cloned = platformEl.cloneNode(true);
    cloned.querySelectorAll('canvas').forEach(el => el.remove());
    cloned.classList.remove('Nai-9RwaoltJT-Long');
    cloned.style.display = 'block';
    cloned.style.visibility = 'visible';
    cloned.style.opacity = '1';
    cloned.style.width = '100%';
    cloned.style.maxHeight = 'none';
    cloned.style.minHeight = '0';
    cloned.style.overflow = 'visible';

    // 清空旧内容并插入
    targetContainer.innerHTML = '';
    targetContainer.appendChild(cloned);

    // 修复闲鱼/转转实物模板的定位问题：innerHTML 动态插入的元素没有 data-v 属性，scoped CSS 无法匹配
    const innerWrappers = targetContainer.querySelectorAll('.Nai-hdC3SqpQW-Long, .Nai-ld5GcXnQq-Long');
    innerWrappers.forEach(w => {
      w.style.position = 'relative';
      w.style.height = 'auto';
    });
    const bottomBar = targetContainer.querySelector('.Nai-Quv7KQ8nk-Long');
    if (bottomBar) {
      bottomBar.style.position = 'sticky';
      bottomBar.style.bottom = '0';
    }

    // 闲鱼/转转：克隆完了把源平台的DOM还原回去
    if (savedHtml !== null) {
      platformEl.innerHTML = savedHtml;
    }

    importedTemplateName.value = platformName;
    importedTemplateHtml.value = targetContainer.innerHTML;

    closeImportTemplatePopup();

    nextTick(async () => {
      // 给文本节点加上可编辑提示
      const textEls = targetContainer.querySelectorAll('div, span, label');
      textEls.forEach(el => {
        if (el.childNodes.length <= 3 && el.textContent.trim() && el.children.length <= 1) {
          el.classList.add('kefu-editable-text');
        }
      });
      // 绑定点击选中事件
      bindImportedContainerClick();
      // 导入模板后自动更新二维码（"默认"客服模式下路径会跟着模板变）
      await generateQRCode(currentOrderId.value);
    });
  };

  // 点击选中文字 + 上方输入框实时编辑（兼容手机端）
  const editingTextTarget = ref(null);  // 当前选中的 DOM 元素
  const editingTextValue = ref('');     // 输入框的值

  const onImportedContainerClick = (event) => {
    // 阻止冒泡，防止 handleGlobalClick 触发"复制链接"等操作
    event.stopPropagation();

    const target = event.target;
    // 不编辑 img/svg 等
    if (['IMG', 'SVG', 'PATH', 'CANVAS', 'INPUT', 'SELECT'].includes(target.tagName)) {
      clearEditingSelection();
      return;
    }
    // 只对包含文字的叶子节点生效，否则取消选中
    if (!target.textContent.trim() || target.children.length > 1) {
      clearEditingSelection();
      return;
    }

    // 清除上一个选中状态
    if (editingTextTarget.value) {
      editingTextTarget.value.classList.remove('kefu-editing');
    }

    // 选中当前元素
    editingTextTarget.value = target;
    editingTextValue.value = target.textContent;
    target.classList.add('kefu-editing');
  };

  const clearEditingSelection = () => {
    if (editingTextTarget.value) {
      editingTextTarget.value.classList.remove('kefu-editing');
    }
    editingTextTarget.value = null;
    editingTextValue.value = '';
  };

  const onEditingTextInput = (event) => {
    const newText = event.target.value;
    editingTextValue.value = newText;
    if (editingTextTarget.value) {
      editingTextTarget.value.textContent = newText;
      // 实时更新 importedTemplateHtml
      const container = document.getElementById('kefu-imported-container');
      if (container) {
        importedTemplateHtml.value = container.innerHTML;
      }
    }
  };

  // 给导入容器绑定点击选中事件
  const bindImportedContainerClick = () => {
    const container = document.getElementById('kefu-imported-container');
    if (container) {
      container.removeEventListener('click', onImportedContainerClick);
      container.addEventListener('click', onImportedContainerClick);
    }
  };

  // 添加自定义接口
  const addCustomLink = async () => {
    if (!customLinkUrl.value.trim()) {
      alert('请输入接口地址');
      return;
    }
    if (customLinks.value.length >= 5) {
      alert('最多只能添加5条自定义接口');
      return;
    }

    isAddingCustom.value = true;
    try {
      const response = await apiFetch('/api/custom-anti-red/add', {
        method: 'POST',
        body: JSON.stringify({
          name: customLinkName.value.trim() || '自定义接口',
          apiUrl: customLinkUrl.value.trim()
        })
      });
      if (response && response.code === 0) {
        alert('添加成功');
        closeAddCustomPopup();
        await fetchCustomLinks();
      } else {
        alert(response.msg || '添加失败');
      }
    } catch (error) {
      console.error('添加自定义接口失败:', error);
      alert('添加失败，请重试');
    } finally {
      isAddingCustom.value = false;
    }
  };

  // 删除自定义接口
  const deleteCustomLink = async (link) => {
    if (!confirm(`确定删除「${link.name}」？`)) {
      return;
    }
    try {
      const response = await apiFetch(`/api/custom-anti-red/delete/${link.id}`, {
        method: 'DELETE'
      });
      if (response && response.code === 0) {
        await fetchCustomLinks();
      } else {
        alert(response.msg || '删除失败');
      }
    } catch (error) {
      console.error('删除自定义接口失败:', error);
      alert('删除失败，请重试');
    }
  };

  // 应用自定义接口
  const applyCustomLink = async (link) => {
    try {
      const response = await apiFetch(`/api/custom-anti-red/apply/${link.id}`, {
        method: 'POST'
      });
      if (response && response.code === 0) {
        // 取消购买接口的应用状态（前端显示）
        purchasedLinks.value.forEach(l => l.isActive = false);
        await fetchCustomLinks();
        antiRedEnabled.value = true;
        await generateQRCode(currentOrderId.value);
      } else {
        alert(response.msg || '应用失败');
      }
    } catch (error) {
      console.error('应用自定义接口失败:', error);
      alert('应用失败，请重试');
    }
  };

  // 取消自定义接口
  const cancelCustomLink = async (link) => {
    try {
      const response = await apiFetch(`/api/custom-anti-red/cancel/${link.id}`, {
        method: 'POST'
      });
      if (response && response.code === 0) {
        await fetchCustomLinks();
        // 重新生成二维码（不使用防红链接）
        await generateQRCode(currentOrderId.value);
      } else {
        alert(response.msg || '取消失败');
      }
    } catch (error) {
      console.error('取消自定义接口失败:', error);
      alert('取消失败，请重试');
    }
  };

  // 打开购买接口弹窗
  const openPurchasePopup = async () => {
    showPurchasePopup.value = true;
    await fetchAvailableLinks();
  };

  // 关闭购买接口弹窗（带动画）
  const closePurchasePopup = () => {
    // 添加关闭动画类
    const popup = document.querySelector('.purchase-popup');
    const overlay = document.querySelector('.purchase-overlay');
    if (popup && overlay) {
      popup.classList.add('slide-down');
      overlay.classList.add('fade-out');
      // 等待动画完成后再关闭
      setTimeout(() => {
        showPurchasePopup.value = false;
      }, 300);
    } else {
      showPurchasePopup.value = false;
    }
  };

  // 购买防红接口
  const buyAntiRedLink = async (link) => {
    const price = parseFloat(link.price) || 0;
    const linkName = link.name || '未命名接口';

    if (price > 0) {
      if (!confirm(`确定购买「${linkName}」？将扣除 ¥${price}`)) {
        return;
      }
    } else {
      if (!confirm(`确定领取免费接口「${linkName}」？`)) {
        return;
      }
    }

    try {
      const response = await apiFetch(`/api/user/api-links/purchase/${link.id}`, {
        method: 'POST'
      });
      if (response && response.code === 0) {
        alert('购买成功！');
        closePurchasePopup();
        await fetchPurchasedLinks(); // 刷新已购买列表
      } else {
        alert(response.msg || '购买失败');
      }
    } catch (error) {
      console.error('购买接口失败:', error);
      alert('购买失败，请重试');
    }
  };

  // 快速购买：点击按钮直接分配最新添加的接口
  const quickBuy = async (type) => {
    const links = type === 'free' ? freeLinks.value : paidLinks.value;
    if (links.length === 0) {
      alert(type === 'free' ? '暂无可领取的免费接口' : '暂无可购买的付费接口');
      return;
    }
    // 取最新添加的（后端已按创建时间降序排列，第一个就是最新的）
    const link = links[0];
    await buyAntiRedLink(link);
  };

  // 应用防红接口（购买的）
  const applyAntiRedLink = async (link) => {
    try {
      const response = await apiFetch(`/api/user/api-links/apply/${link.id}`, {
        method: 'POST'
      });
      if (response && response.code === 0) {
        // 取消自定义接口的应用状态（前端显示）
        customLinks.value.forEach(l => l.isActive = false);
        await fetchPurchasedLinks(); // 刷新列表
        antiRedEnabled.value = true; // 应用接口时自动开启防红
        // 重新生成二维码（使用新的防红链接）
        await generateQRCode(currentOrderId.value);
      } else {
        alert(response.msg || '应用失败');
      }
    } catch (error) {
      console.error('应用接口失败:', error);
      alert('应用失败，请重试');
    }
  };

  // 取消防红接口
  const cancelAntiRedLink = async (link) => {
    try {
      const response = await apiFetch(`/api/user/api-links/cancel/${link.id}`, {
        method: 'POST'
      });
      if (response && response.code === 0) {
        await fetchPurchasedLinks(); // 刷新列表
        // 重新生成二维码（不使用防红链接）
        await generateQRCode(currentOrderId.value);
      } else {
        alert(response.msg || '取消失败');
      }
    } catch (error) {
      console.error('取消接口失败:', error);
      alert('取消失败，请重试');
    }
  };

  // 处理配置防洪按钮点击
  const handleConfigAntiRed = () => {
    // 跳转到购买页面或打开购买弹窗
    openPurchasePopup();
  };

  // 开关防红功能
  // 切换防红状态（开关按钮触发）
  const toggleAntiRed = async () => {
    try {
      const response = await apiFetch('/api/user/api-links/toggle', {
        method: 'POST',
        body: JSON.stringify({ enabled: antiRedEnabled.value })
      });
      if (response && response.code === 0) {
        if (!antiRedEnabled.value) {
          // 关闭防红时刷新列表
          await fetchPurchasedLinks();
        }
        // 重新生成二维码（根据防红状态）
        await generateQRCode(currentOrderId.value);
      }
    } catch (error) {
      console.error('切换防红状态失败:', error);
    }
  };

  // 处理右上角关闭/开启按钮点击
  const handleToggleAntiRed = () => {
    // 先切换状态
    antiRedEnabled.value = !antiRedEnabled.value;
    // 然后调用API
    toggleAntiRed();
  };

  // 根据客服设置和导入模板获取聊天路径
  const kefuPlatformChatPathMap = {
    'xianyu': '/xy-chat',
    'zhuanzhuan': '/zz-chat',
    'pangxie': '/px-chat',
    'panzhi': '/pz-chat',
    'jiaoyimao': '/jym-chat',
    'wx': '/wx-chat',
    'yinlian': '/yl-chat',
    'kjs': '/kjs-chat',
    'qiandao': '/qd-chat',
  };

  // 从导入的模板名推断平台
  const getImportedPlatformKey = () => {
    const name = importedTemplateName.value || '';
    if (name.includes('闲鱼')) return 'xianyu';
    if (name.includes('转转')) return 'zhuanzhuan';
    if (name.includes('螃蟹')) return 'pangxie';
    if (name.includes('盼之')) return 'panzhi';
    if (name.includes('交易猫')) return 'jiaoyimao';
    if (name.includes('微信')) return 'wx';
    if (name.includes('银联')) return 'yinlian';
    if (name.includes('氪金兽')) return 'kjs';
    if (name.includes('千岛')) return 'qiandao';
    return 'xianyu'; // 兜底
  };

  const getKefuChatPath = () => {
    // 如果选了具体平台，用选的；如果是默认（空），跟随导入模板
    const platform = selectedKefuPlatform.value || getImportedPlatformKey();
    return kefuPlatformChatPathMap[platform] || '/xy-chat';
  };

  // 生成客服聊天链接（根据当前选择的平台生成不同链接）
  const generateChatLink = (orderId = null) => {
    const user = getCurrentUser();
    const agentUid = user ? (user.uid || user.account || user.username || 'admin') : 'admin';
    // 使用当前域名生成链接
    const baseUrl = window.location.origin;
    
    // 根据当前选择的平台决定链接格式
    let chatPath = '/xy-chat'; // 默认闲鱼（新路由）
    if (currentTab.value === 'app-zhuanzhuan') {
      chatPath = '/zz-chat';
    } else if (currentTab.value === 'app-pangxie') {
      // 螃蟹平台：聊天室开启时使用px2-chat，否则使用px-chat
      chatPath = chatRoomEnabled.value ? '/px2-chat' : '/px-chat';
    } else if (currentTab.value === 'app-panzhi') {
      // 盼之平台：聊天室开启时使用pz2-chat，否则使用pz-chat
      chatPath = pzChatRoomEnabled.value ? '/pz2-chat' : '/pz-chat';
    } else if (currentTab.value === 'app-jiaoyimao') {
      // 交易猫平台
      chatPath = '/jym-chat';
    } else if (currentTab.value === 'app-yinlian') {
      // 银联平台
      chatPath = '/yl-chat';
    } else if (currentTab.value === 'app-wx') {
      // 微信平台
      chatPath = '/wx-chat';
    } else if (currentTab.value === 'app-kjs') {
      // 氪金兽平台
      chatPath = '/kjs-chat';
    } else if (currentTab.value === 'app-qiandao') {
      // 千岛平台
      chatPath = '/qd-chat';
    } else if (currentTab.value === 'app-kefu') {
      // 客服自定义平台：根据客服设置选择链接
      chatPath = getKefuChatPath();
    }
    
    // 构建查询参数
    let queryParams = `custuuid=${agentUid}`;
    if (orderId) {
      queryParams += `&orderId=${orderId}`;
    }
    // 引导到浏览器开关
    if (redirectToBrowser.value) {
      queryParams += `&b=1`;
    }
    // 防红接口ID（用于按接口计数访问量）
    const activeAntiRed = getActiveAntiRedLink();
    if (activeAntiRed) {
      queryParams += `&arid=${activeAntiRed.id}&artype=${activeAntiRed.type}`;
    }
    // 螃蟹聊天室模式时，添加amount参数
    if (currentTab.value === 'app-pangxie' && chatRoomEnabled.value && orderPrice.value) {
      queryParams += `&amount=${encodeURIComponent(orderPrice.value)}`;
    }
    
    chatLink.value = `${baseUrl}${chatPath}?${queryParams}`;
    return chatLink.value;
  };

  // 上传封面图到后端
  // 注意：/api/order/** 是 permitAll 公开接口，不需要发送 token
  // 发送过期/无效 token 反而会导致 JwtAuthenticationFilter 清除上下文后触发 401
  const uploadCoverImage = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE_URL}/api/order/upload-image`, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error(`上传失败: HTTP ${response.status}`);
    }

    const result = await response.json();

    if (result.code === 0 && result.data?.imagePath) {
      return result.data.imagePath;
    } else {
      throw new Error(result.msg || '图片上传失败');
    }
  };

  // 创建订单
  // 注意：/api/order/** 是 permitAll 公开接口，不需要发送 token
  // 与 uploadCoverImage 保持一致，使用原生 fetch 避免 apiFetch 附加过期 token 导致 401
  const createOrder = async (agentAccount, title, price, imagePath) => {
    const response = await fetch(`${API_BASE_URL}/api/order/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        agentAccount,
        title,
        price,
        imagePath
      })
    });

    if (!response.ok) {
      throw new Error(`创建订单失败: HTTP ${response.status}`);
    }

    const result = await response.json();

    if (result.code === 0) {
      return result.data;
    } else {
      throw new Error(result.msg || '创建订单失败');
    }
  };

  // 处理"生成订单"按钮点击
  const handleGenerateOrder = async () => {
    if (isCreatingOrder.value) return;
    
    const user = getCurrentUser();
    const agentAccount = user ? (user.account || user.username || 'admin') : 'admin';
    
    // 获取当前填写的标题和价格
    const title = orderTitle.value || '';
    const price = orderPrice.value || '';
    
    if (!title) {
      alert('请先填写商品标题');
      return;
    }
    if (!price) {
      alert('请先填写商品价格');
      return;
    }
    
    isCreatingOrder.value = true;
    
    try {
      let imagePath = coverImagePath.value;

      // 如果有新选择的封面图文件，先上传
      if (coverImageFile.value) {
        try {
          imagePath = await uploadCoverImage(coverImageFile.value);
          coverImagePath.value = imagePath;
          coverImageFile.value = null; // 清空，避免重复上传
        } catch (uploadError) {
          console.error('封面图上传失败:', uploadError);
          const proceed = confirm('封面图上传失败，是否继续创建无封面图的订单？');
          if (!proceed) {
            isCreatingOrder.value = false;
            return;
          }
          imagePath = ''; // 使用空路径继续创建订单
        }
      }

      // 创建订单，获取订单ID
      const order = await createOrder(agentAccount, title, price, imagePath);
      currentOrderId.value = order.id;

      // 重新生成二维码（使用订单ID）
      await generateQRCode(order.id);

      alert('订单创建成功！二维码已更新为包含订单的链接\n链接: ' + chatLink.value);
    } catch (error) {
      console.error('创建订单失败:', error);
      alert('创建订单失败：' + error.message);
    } finally {
      isCreatingOrder.value = false;
    }
  };

  // 处理"生成空订单"按钮点击（不需要标题和价格，仅生成订单ID用于链接跟踪）
  const handleGenerateEmptyOrder = async () => {
    if (isCreatingOrder.value) return;

    const user = getCurrentUser();
    const agentAccount = user ? (user.account || user.username || 'admin') : 'admin';

    isCreatingOrder.value = true;

    try {
      // 创建空订单（标题和价格为空）
      const order = await createOrder(agentAccount, '空订单', '0', '');
      currentOrderId.value = order.id;

      // 重新生成二维码（使用订单ID）
      await generateQRCode(order.id);

      alert('空订单创建成功！二维码已更新为包含订单的链接\n链接: ' + chatLink.value);
    } catch (error) {
      console.error('创建空订单失败:', error);
      alert('创建空订单失败：' + error.message);
    } finally {
      isCreatingOrder.value = false;
    }
  };

  // 复制到剪贴板（兼容iOS Safari）
  const copyToClipboard = (text) => {
    // 检测是否iOS
    const isIOS = /ipad|iphone|ipod/i.test(navigator.userAgent);
    
    // 方法1: 尝试使用 Clipboard API (需要 HTTPS 或 localhost，且用户授权)
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function' && !isIOS) {
      navigator.clipboard.writeText(text)
        .then(() => {
          emit('copy-success');
        })
        .catch(() => {
          fallbackCopy(text);
        });
    } else {
      // iOS 或不支持 Clipboard API 时使用降级方案
      fallbackCopy(text);
    }
  };

  // 降级复制方案（兼容所有浏览器包括iOS Safari）
  const fallbackCopy = (text) => {
    // 检测是否iOS
    const isIOS = /ipad|iphone|ipod/i.test(navigator.userAgent);
    
    try {
      // 使用 input 元素代替 textarea（iOS 兼容性更好）
      const input = document.createElement('input');
      input.setAttribute('type', 'text');
      input.setAttribute('value', text);
      input.setAttribute('readonly', '');
      
      // 样式设置
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      input.style.top = '0';
      input.style.fontSize = '16px'; // iOS 需要至少 16px
      input.style.opacity = '0';
      
      document.body.appendChild(input);
      
      if (isIOS) {
        // iOS 特殊处理
        input.removeAttribute('readonly');
        input.focus();
        input.setSelectionRange(0, text.length);
      } else {
        input.select();
      }
      
      // 执行复制
      const successful = document.execCommand('copy');
      document.body.removeChild(input);
      
      if (successful) {
        emit('copy-success');
      } else {
        // 如果复制失败，提示用户手动复制
        prompt('请手动复制链接：', text);
      }
    } catch (err) {
      console.error('复制失败:', err);
      // 最后的降级：让用户手动复制
      prompt('请手动复制链接：', text);
    }
  };

  // 获取当前应用的防红接口
  const getActiveAntiRedLink = () => {
    if (!antiRedEnabled.value) return null;
    // 先检查购买的接口
    const activeLink = purchasedLinks.value.find(link => link.isActive);
    if (activeLink) return { url: activeLink.apiUrl, id: activeLink.id, type: 'purchased' };
    // 再检查自定义接口
    const activeCustom = customLinks.value.find(link => link.isActive);
    if (activeCustom) return { url: activeCustom.apiUrl, id: activeCustom.id, type: 'custom' };
    return null;
  };

  // 生成最终的二维码链接（考虑防红）
  const generateFinalLink = (originalLink) => {
    const activeLink = getActiveAntiRedLink();
    if (activeLink) {
      try {
        // 将完整的原始链接进行 Base64 编码
        const base64Encoded = btoa(originalLink);

        // 移除防红域名末尾的斜杠（如果有）
        const cleanDomain = activeLink.url.replace(/\/$/, '');

        // 组合：防红域名 + Base64编码后的链接（直接拼接，不加斜杠）
        return `${cleanDomain}${base64Encoded}`;
      } catch (error) {
        console.error('Base64编码链接失败:', error);
        return originalLink;
      }
    }
    return originalLink;
  };

  // 二维码中间小图片（每个平台对应不同的图片，填路径、网址或base64都行）
  const qrCenterLogoMap = {
    'app-xianyu':     '/xytu.png',   // 闲鱼
    'app-zhuanzhuan': '/zztu.png',   // 转转
    'app-pangxie':    '/pxtu.png',   // 螃蟹
    'app-panzhi':     '/pztu.ico',   // 盼之
    'app-jiaoyimao':  '/jymtu.png',  // 交易猫
    'app-yinlian':    '/yltu.png',   // 银联
    'app-wx':         '/wxtu.png',   // 微信
    'app-kjs':        '/kjstu.png',  // 氪金兽
    'app-qiandao':    '/qdtu.png',   // 千岛
    'app-kefu':       '/图标.png',   // 自定义客服
  };

  // 在二维码中间绘制小图片
  const addLogoToQRCode = (qrDataUrl, logoSrc, size = 160) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');

      const qrImg = new Image();
      qrImg.onload = () => {
        // 先画二维码
        ctx.drawImage(qrImg, 0, 0, size, size);

        const logo = new Image();
        logo.crossOrigin = 'anonymous';
        logo.onload = () => {
          // 中间logo大小为二维码的20%
          const logoSize = size * 0.2;
          const x = (size - logoSize) / 2;
          const y = (size - logoSize) / 2;

          // 白色圆角背景（留一点padding）
          const padding = 3;
          const radius = 4;
          const bx = x - padding;
          const by = y - padding;
          const bw = logoSize + padding * 2;
          const bh = logoSize + padding * 2;
          ctx.fillStyle = '#ffffff';
          ctx.beginPath();
          ctx.moveTo(bx + radius, by);
          ctx.lineTo(bx + bw - radius, by);
          ctx.quadraticCurveTo(bx + bw, by, bx + bw, by + radius);
          ctx.lineTo(bx + bw, by + bh - radius);
          ctx.quadraticCurveTo(bx + bw, by + bh, bx + bw - radius, by + bh);
          ctx.lineTo(bx + radius, by + bh);
          ctx.quadraticCurveTo(bx, by + bh, bx, by + bh - radius);
          ctx.lineTo(bx, by + radius);
          ctx.quadraticCurveTo(bx, by, bx + radius, by);
          ctx.closePath();
          ctx.fill();

          // 画logo图片（圆角裁切）
          ctx.save();
          ctx.beginPath();
          ctx.moveTo(x + radius, y);
          ctx.lineTo(x + logoSize - radius, y);
          ctx.quadraticCurveTo(x + logoSize, y, x + logoSize, y + radius);
          ctx.lineTo(x + logoSize, y + logoSize - radius);
          ctx.quadraticCurveTo(x + logoSize, y + logoSize, x + logoSize - radius, y + logoSize);
          ctx.lineTo(x + radius, y + logoSize);
          ctx.quadraticCurveTo(x, y + logoSize, x, y + logoSize - radius);
          ctx.lineTo(x, y + radius);
          ctx.quadraticCurveTo(x, y, x + radius, y);
          ctx.closePath();
          ctx.clip();
          ctx.drawImage(logo, x, y, logoSize, logoSize);
          ctx.restore();

          resolve(canvas.toDataURL('image/png'));
        };
        logo.onerror = () => {
          // logo加载失败就用纯二维码
          console.warn('二维码中间logo加载失败，使用纯二维码');
          resolve(qrDataUrl);
        };
        logo.src = logoSrc;
      };
      qrImg.src = qrDataUrl;
    });
  };

  // 生成二维码
  const generateQRCode = async (orderId = null) => {
    try {
      // 始终根据当前平台重新生成链接（确保切换平台后链接正确）
      let originalLink;
      if (orderId !== null) {
        originalLink = generateChatLink(orderId);
      } else {
        // 强制重新生成链接，不使用缓存
        originalLink = generateChatLink();
      }

      // 如果开启了防红，使用防红链接包装
      const finalLink = generateFinalLink(originalLink);
      console.log('生成客服链接二维码:', finalLink, '平台:', currentTab.value, '防红:', antiRedEnabled.value);

      // 生成二维码DataURL（使用高容错率H，允许中间被遮挡30%仍可扫描）
      const dataUrl = await QRCode.toDataURL(finalLink, {
        width: 160,
        margin: 1,
        errorCorrectionLevel: 'H',
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      });

      // 在二维码中间叠加小图片（根据当前平台选对应logo）
      const logoUrl = qrCenterLogoMap[currentTab.value] || '/图标.png';
      qrcodeDataUrl.value = await addLogoToQRCode(dataUrl, logoUrl, 160);

      // 替换页面上所有的固定二维码
      await nextTick();
      updateAllQRCodes();
    } catch (error) {
      console.error('生成二维码失败:', error);
    }
  };

  // 更新页面上所有二维码（替换所有硬编码的SVG二维码为动态生成的PNG）
  const updateAllQRCodes = () => {
    if (!qrcodeDataUrl.value) return;
    
    let updatedCount = 0;
    
    // 1. 先更新已经替换过的 img 二维码
    const existingQrImgs = document.querySelectorAll('img[data-qrcode="true"]');
    existingQrImgs.forEach(img => {
      img.src = qrcodeDataUrl.value;
      updatedCount++;
    });
    
    // 2. 查找页面上所有的 SVG 二维码（viewBox="0 0 37 37" 是二维码的特征）
    const allQrSvgs = document.querySelectorAll('svg[viewBox="0 0 37 37"]');
    
    allQrSvgs.forEach(svg => {
      // 获取原始尺寸
      const width = svg.getAttribute('width') || 100;
      const height = svg.getAttribute('height') || 100;
      
      // 创建img元素替换svg
      const img = document.createElement('img');
      img.src = qrcodeDataUrl.value;
      img.width = parseInt(width);
      img.height = parseInt(height);
      img.style.cssText = `min-width: ${width}px; max-width: ${width}px; min-height: ${height}px; max-height: ${height}px;`;
      img.alt = '专属客服二维码';
      img.setAttribute('data-qrcode', 'true'); // 标记为二维码图片，方便后续更新
      
      // 替换
      if (svg.parentNode) {
        svg.parentNode.replaceChild(img, svg);
        updatedCount++;
      }
    });
    
    console.log(`已更新 ${updatedCount} 个二维码为专属链接: ${chatLink.value}`);
  };

    const fishHtml = `
<div class="Nai-hdC3SqpQW-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;">
              <symbol id="bold-arrow-down">
                <path d="M52.335 261.072c-31.269 30.397-31.269 79.722 0 110.194l403.212 391.718c31.325 30.382 82.114 30.382 113.377 0l403.197-391.718c31.325-30.466 31.325-79.793 0-110.194-31.28-30.449-82.058-30.449-113.39 0l-346.497 336.64-346.457-336.64c-31.325-30.448-82.105-30.448-113.446 0l0 0z" fill="#272636"></path>
              </symbol>
              <symbol id="three-points">
                <path d="M512 256a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z m0 341.333333a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 0 0 0 170.666666z m0 341.333334a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z" fill="#272636"></path>
              </symbol>
            </svg>
            <div class="Nai-q-EdWJmI0-Long"><svg class="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                <use xlink:href="#arrow-left"></use>
              </svg><svg class="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                <use xlink:href="#three-points"></use>
              </svg></div>
            <div class="Nai-6Me-DVW15-Long">
              <div class="Nai-apCpgi6cf-Long">
                <div>已付款，等待卖家发货</div>
                <div class="Nai-WZddb8hDo-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="12" height="12">
                    <use xlink:href="#bold-arrow-down"></use>
                  </svg></div>
              </div>
              <div class="Nai-sGBa-fBDN-Long">
                <div class="Nai-lsRIkgxE0-Long"></div>
                <div class="Nai-lsRIkgxE0-Long Nai-PnLWwZPdW-Long"></div><img src="/xy.png" alt="" class="Nai--Ivz1qvjH-Long">
                <div class="Nai-J0HH1b-as-Long Nai-kUPpmVc79-Long">
                  <div class="Nai-6bbruLi9M-Long">
                    <div class="Nai-vhksOV4pn-Long Nai-YN8UTrjhC-Long">✓</div>
                  </div><!---->
                  <div>已付款</div>
                </div>
                <div class="Nai-J0HH1b-as-Long">
                  <div class="Nai-6bbruLi9M-Long">
                    <div class="Nai-vhksOV4pn-Long"></div>
                  </div><!---->
                  <div>待发货</div>
                </div>
                <div class="Nai-J0HH1b-as-Long">
                  <div class="Nai-6bbruLi9M-Long">
                    <div class="Nai-vhksOV4pn-Long"></div>
                  </div><!---->
                  <div>待收货</div>
                </div>
                <div class="Nai-J0HH1b-as-Long Nai-yJjTbc0Rs-Long">
                  <div class="Nai-6bbruLi9M-Long">
                    <div class="Nai-vhksOV4pn-Long"></div>
                  </div><!---->
                  <div>待评价</div>
                </div>
              </div>
              <div class="Nai-YriaGo2jK-Long">
                <div class="Nai-wRZTFeidK-Long">商品交易规则</div>
                <div class=""> 请提醒卖家使用<span class="Nai-gWE971MRl-Long">{{ scanMethod }}</span>扫码配合官方客服进行发货，发货完成后买家<span class="Nai-gWE971MRl-Long">确认收货</span>即可完成交易 </div>
              </div>
              <div class="Nai-YriaGo2jK-Long">
                <div class="Nai-wRZTFeidK-Long">联系客服</div>
                <div class="Nai-DNMvdrrgt-Long">
                  <div class="Nai-ZGtC8muCJ-Long">
                    <div>请提醒<span class="Nai-gWE971MRl-Long">卖家扫码发货</span></div>
                    <div>为保障您的交易安全，请勿将二维码泄露，避免引发资金损失、交易纠纷等风险。</div>
                  </div>
                  <div class="Nai-De6izQNb--Long"><svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 37 37" shape-rendering="crispEdges">
                      <path fill="#ffffff" d="M0 0h37v37H0z"></path>
                      <path stroke="#000000" d="M0 0.5h7m1 0h1m3 0h1m1 0h2m2 0h3m4 0h2m1 0h1m1 0h7M0 1.5h1m5 0h1m1 0h2m3 0h1m1 0h1m1 0h2m2 0h4m1 0h1m1 0h1m1 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m3 0h2m3 0h1m2 0h3m1 0h2m1 0h1m1 0h2m1 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h6m1 0h3m2 0h1m1 0h1m1 0h2m1 0h2m1 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m3 0h1m1 0h2m1 0h1m1 0h1m1 0h1m2 0h1m4 0h2m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m2 0h3m2 0h1m3 0h3m4 0h2m1 0h1m1 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h1m3 0h6m1 0h1m7 0h2M0 8.5h1m1 0h2m1 0h3m1 0h1m1 0h1m3 0h3m1 0h1m1 0h1m2 0h1m1 0h3m1 0h1m2 0h1m1 0h2M1 9.5h2m5 0h1m3 0h1m2 0h10m1 0h1m1 0h1m2 0h1m3 0h1M0 10.5h1m3 0h1m1 0h2m2 0h6m1 0h1m2 0h2m1 0h4m3 0h1m2 0h1M0 11.5h1m1 0h1m1 0h1m3 0h1m1 0h1m2 0h1m1 0h1m2 0h1m1 0h1m3 0h4m2 0h1m3 0h1M0 12.5h1m3 0h1m1 0h2m1 0h3m1 0h1m2 0h2m1 0h1m2 0h1m2 0h1m1 0h1m1 0h2m1 0h1m1 0h3M0 13.5h1m1 0h1m1 0h1m2 0h1m1 0h1m1 0h1m3 0h1m1 0h1m1 0h1m7 0h1m2 0h1m1 0h2m1 0h2M3 14.5h1m2 0h2m1 0h2m1 0h1m4 0h4m3 0h1m5 0h3m1 0h1M1 15.5h1m1 0h1m1 0h1m1 0h1m1 0h4m1 0h3m1 0h5m1 0h1m1 0h1m2 0h2M0 16.5h1m1 0h1m3 0h1m1 0h1m2 0h1m1 0h2m1 0h1m1 0h6m1 0h1m7 0h2M0 17.5h5m6 0h1m1 0h1m2 0h1m3 0h4m1 0h2m2 0h2m3 0h3M1 18.5h3m1 0h3m1 0h3m1 0h4m3 0h2m2 0h1m2 0h2m1 0h7M0 19.5h2m2 0h1m5 0h3m4 0h1m2 0h1m2 0h2m2 0h1m1 0h1m1 0h1m1 0h1m1 0h1M1 20.5h1m4 0h4m1 0h3m2 0h3m2 0h1m10 0h1m1 0h1m1 0h1M0 21.5h3m1 0h2m1 0h1m1 0h2m2 0h1m4 0h2m3 0h1m2 0h1m2 0h1m3 0h1M1 22.5h3m2 0h1m1 0h2m1 0h2m1 0h1m1 0h1m4 0h4m3 0h2m1 0h1M1 23.5h1m2 0h2m2 0h4m1 0h1m8 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h1M2 24.5h3m1 0h2m4 0h1m4 0h2m3 0h1m1 0h7m1 0h1m1 0h3M3 25.5h1m3 0h3m1 0h1m4 0h4m1 0h1m2 0h2m1 0h1m1 0h5m1 0h2M1 26.5h1m1 0h1m1 0h2m1 0h1m1 0h7m1 0h2m1 0h1m2 0h2m6 0h1m2 0h1M0 27.5h1m4 0h1m1 0h2m3 0h2m2 0h1m2 0h4m1 0h1m1 0h7m2 0h2M2 28.5h1m1 0h1m1 0h1m3 0h1m3 0h3m3 0h3m1 0h2m2 0h5m1 0h2M8 29.5h2m4 0h5m4 0h1m1 0h1m1 0h2m3 0h1M0 30.5h7m1 0h3m1 0h2m1 0h2m3 0h3m1 0h1m1 0h1m1 0h1m1 0h1m1 0h5M0 31.5h1m5 0h1m1 0h1m5 0h1m1 0h4m3 0h2m3 0h1m3 0h1m2 0h2M0 32.5h1m1 0h3m1 0h1m2 0h1m1 0h2m3 0h2m3 0h1m4 0h1m1 0h5M0 33.5h1m1 0h3m1 0h1m1 0h2m4 0h2m1 0h1m1 0h3m1 0h1m2 0h1m3 0h1m1 0h1m2 0h2M0 34.5h1m1 0h3m1 0h1m1 0h1m1 0h2m1 0h1m2 0h1m1 0h1m4 0h4m3 0h1m1 0h3M0 35.5h1m5 0h1m2 0h3m1 0h2m1 0h1m1 0h3m1 0h1m1 0h3m3 0h1m1 0h3M0 36.5h7m1 0h2m3 0h5m6 0h4m2 0h7">
                      </path>
                    </svg></div>
                </div>
              </div>
              <div class="Nai-YriaGo2jK-Long">
                <div class="Nai-T69P0L6jH-Long"><img class="Nai-a1Xs9rsU--Long" src="" alt="">
                  <div class="Nai-WbmI6tkBT-Long"></div>
                  <div class="Nai--nOga457k-Long"><span class="Nai-HQOau663r-Long">￥</span><span class=""></span></div>
                </div>
                <div class="Nai-yBXbtTDUx-Long">
                  <div>成交价<span class="Nai-TmyVRV5Jr-Long">（在支付宝担保账户中）</span></div>
                  <div><span class="Nai-HQOau663r-Long">￥</span><span class=""></span></div>
                </div>
                <div class="Nai-wGxH1uerh-Long">
                  <div>支付宝交易号</div>
                  <div style="font-weight: normal; letter-spacing: 0.2px;">2032492483240948927298</div>
                </div>
                <div class="Nai-LY1ATs5JA-Long">查看更多</div>
              </div><!---->
            </div>
            <div class="Nai-Quv7KQ8nk-Long">
              <div class="Nai-vOrj7PTg3-Long Nai-in2cgKltS-Long">提醒发货</div>
              <div class="Nai-vOrj7PTg3-Long">更多</div>
            </div>
          </div>`;

    const zhuanzhuanHtml = `<div class="Nai-ld5GcXnQq-Long"><div class="Nai-6Jao2SZXW-Long"><div class="Nai-jIRHqIuOP-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1024 1024"><use xlink:href="#arrow-left"></use></svg></div></div><div class="Nai-dpPPlDQH4-Long"><div class="Nai-UulVCuhZu-Long"><div class="Nai-ObgUXD0Bg-Long">已付款，等待卖家发货</div><div class="Nai-VG1oDV9HD-Long"><div class="Nai-JPIuVeQ-u-Long"></div><div class="Nai-JPIuVeQ-u-Long Nai-m6Q-1-uMH-Long"></div><div class="Nai-UTVhEztii-Long Nai-m2v-gjSlS-Long"><div class="Nai-y9RfGsifG-Long"><div class="Nai-Vzqb1q5Kh-Long"></div></div><div>已付款</div><!----></div><div class="Nai-UTVhEztii-Long"><div class="Nai-y9RfGsifG-Long"><div class="Nai-Vzqb1q5Kh-Long Nai-m6Q-1-uMH-Long"></div></div><div>待发货</div><!----></div><div class="Nai-UTVhEztii-Long"><div class="Nai-y9RfGsifG-Long"><div class="Nai-Vzqb1q5Kh-Long Nai-m6Q-1-uMH-Long"></div></div><div>待收货</div><!----></div><div class="Nai-UTVhEztii-Long Nai-nTv6BrUCO-Long"><div class="Nai-y9RfGsifG-Long"><div class="Nai-Vzqb1q5Kh-Long Nai-m6Q-1-uMH-Long"></div></div><div>待评价</div><!----></div></div></div><div class="Nai-UulVCuhZu-Long"><div class="Nai-ObgUXD0Bg-Long">联系客服</div><div class="Nai-gZspH8Yeg-Long"><div><div class="Nai-zIlBhNGT1-Long">请提醒卖家<span class="Nai-XDf6yi42A-Long">扫码发货</span></div><div class="Nai-zIlBhNGT1-Long">为保障您的交易安全，请勿将此二维码泄露给他人</div></div><div class="Nai-vsEU4Sha4-Long"><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 37 37" shape-rendering="crispEdges"><path fill="#ffffff" d="M0 0h37v37H0z"></path><path stroke="#000000" d="M0 0.5h7m1 0h1m4 0h1m1 0h2m1 0h4m1 0h1m2 0h3m1 0h7M0 1.5h1m5 0h1m4 0h4m4 0h1m1 0h2m2 0h2m1 0h1m1 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m2 0h1m2 0h1m2 0h1m1 0h2m2 0h4m2 0h1m2 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h1m1 0h1m2 0h1m1 0h1m1 0h1m2 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m1 0h2m1 0h1m3 0h1m1 0h2m3 0h3m2 0h2m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m1 0h1m1 0h1m2 0h2m1 0h2m1 0h1m1 0h2m1 0h3m3 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h1m2 0h2m6 0h4m3 0h1M0 8.5h1m3 0h1m1 0h3m4 0h4m2 0h1m1 0h2m1 0h1m2 0h7m2 0h1M1 9.5h2m4 0h3m1 0h1m5 0h2m1 0h1m2 0h1m1 0h4m1 0h1m1 0h2m1 0h1M0 10.5h2m2 0h1m1 0h3m6 0h1m1 0h1m2 0h1m1 0h2m1 0h1m1 0h1m2 0h3m1 0h1M0 11.5h1m1 0h1m1 0h1m2 0h2m1 0h2m2 0h5m1 0h2m1 0h2m1 0h2m1 0h2m2 0h3M0 12.5h1m1 0h1m1 0h4m3 0h1m4 0h2m2 0h3m3 0h1m2 0h3m1 0h4M3 13.5h3m1 0h1m2 0h1m1 0h1m2 0h1m2 0h1m2 0h1m1 0h3m1 0h1m1 0h1m1 0h3M0 14.5h2m1 0h2m1 0h1m1 0h5m2 0h1m1 0h1m2 0h5m1 0h2m4 0h4M0 15.5h2m1 0h2m4 0h2m2 0h3m1 0h5m1 0h1m4 0h3m3 0h3M2 16.5h2m1 0h4m1 0h2m1 0h2m3 0h1m2 0h2m1 0h1m1 0h1m1 0h3m2 0h4M2 17.5h1m1 0h2m2 0h2m2 0h1m1 0h1m1 0h1m3 0h2m1 0h1m1 0h4m2 0h2m2 0h1M0 18.5h1m1 0h5m2 0h1m6 0h3m2 0h3m3 0h3m1 0h1m1 0h1M0 19.5h3m2 0h1m5 0h4m2 0h1m1 0h1m1 0h2m1 0h1m1 0h2m1 0h1m1 0h1m2 0h2M1 20.5h2m1 0h8m1 0h3m1 0h1m1 0h6m1 0h1m1 0h1m1 0h1M0 21.5h1m2 0h1m1 0h1m2 0h1m2 0h1m1 0h1m1 0h1m1 0h2m1 0h2m1 0h1m1 0h1m1 0h1m1 0h1m1 0h2M2 22.5h1m1 0h1m1 0h1m1 0h6m1 0h1m2 0h1m1 0h1m2 0h2m1 0h2m1 0h1m1 0h4M1 23.5h3m1 0h1m1 0h3m1 0h1m1 0h1m1 0h1m3 0h1m1 0h3m2 0h3m1 0h7M1 24.5h8m2 0h2m1 0h3m2 0h4m1 0h1m1 0h1m1 0h4m1 0h4M0 25.5h1m4 0h1m1 0h1m1 0h1m1 0h1m1 0h2m3 0h1m2 0h1m1 0h1m3 0h3m1 0h3M6 26.5h1m3 0h1m2 0h3m1 0h2m4 0h2m2 0h1m1 0h1m2 0h2M2 27.5h3m2 0h1m2 0h1m4 0h7m1 0h2m1 0h1m1 0h1m3 0h1m1 0h2M0 28.5h2m4 0h2m8 0h7m5 0h8M8 29.5h1m1 0h4m1 0h1m4 0h1m1 0h7m3 0h1m1 0h1m1 0h1M0 30.5h7m1 0h2m1 0h2m2 0h1m1 0h1m2 0h2m1 0h1m1 0h1m2 0h1m1 0h1m1 0h2M0 31.5h1m5 0h1m2 0h4m1 0h2m1 0h5m1 0h2m1 0h3m3 0h5M0 32.5h1m1 0h3m1 0h1m1 0h1m1 0h1m3 0h1m3 0h1m1 0h3m2 0h1m2 0h5m1 0h1m1 0h1M0 33.5h1m1 0h3m1 0h1m2 0h2m5 0h2m2 0h1m2 0h1m1 0h3m2 0h2m2 0h1m1 0h1M0 34.5h1m1 0h3m1 0h1m2 0h1m2 0h1m3 0h1m1 0h1m2 0h3m1 0h1m1 0h2m1 0h1m2 0h1M0 35.5h1m5 0h1m4 0h1m1 0h2m2 0h2m1 0h5m1 0h1m4 0h2m1 0h2M0 36.5h7m1 0h1m3 0h2m1 0h3m1 0h3m2 0h1m2 0h1m1 0h2m2 0h4"></path></svg></div></div></div><div class="Nai-MLuCoraR8-Long">订单详情</div><div class="Nai-UulVCuhZu-Long"><div class="Nai-VVPzF9khB-Long"><img class="Nai-LtPLPpEPC-Long" src=""><div class="Nai-HdeOJj6dP-Long"></div><div class="Nai-EG1HP9-3g-Long" style="display: none;"> ￥<span class="Nai-JmU557kqf-Long"></span></div></div><div class="Nai-hT9aVUnts-Long"><div class="Nai-xE-Rc4ABg-Long"><div>商品总价</div><div>￥<span class="Nai-JmU557kqf-Long Nai-BrxEVFKpz-Long"></span></div></div><div class="Nai-xE-Rc4ABg-Long"><div>实付款</div><div>￥<span class="Nai-JmU557kqf-Long Nai-BrxEVFKpz-Long"></span></div></div><div class="Nai-xE-Rc4ABg-Long"><div>订单状态</div><div>进行中</div></div><div class="Nai-xE-Rc4ABg-Long"><div>订单编号</div><div>43289129932891343</div></div><div class="Nai-NO8lQYQ0C-Long">查看更多</div></div></div></div></div>`;

    const violationHtml = `
<div class="Nai-hdC3SqpQW-Long"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="display: none;">
              <symbol id="bold-arrow-down">
                <path d="M52.335 261.072c-31.269 30.397-31.269 79.722 0 110.194l403.212 391.718c31.325 30.382 82.114 30.382 113.377 0l403.197-391.718c31.325-30.466 31.325-79.793 0-110.194-31.28-30.449-82.058-30.449-113.39 0l-346.497 336.64-346.457-336.64c-31.325-30.448-82.105-30.448-113.446 0l0 0z" fill="#272636"></path>
              </symbol>
              <symbol id="three-points">
                <path d="M512 256a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z m0 341.333333a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 0 0 0 170.666666z m0 341.333334a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z" fill="#272636"></path>
              </symbol>
            </svg>
            <div class="Nai-q-EdWJmI0-Long"><svg class="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                <use xlink:href="#arrow-left"></use>
              </svg><svg class="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                <use xlink:href="#three-points"></use>
              </svg></div>
            <div class="Nai-6Me-DVW15-Long">
              <div class="Nai-apCpgi6cf-Long">
                <div>已付款，待客服介入</div>
                <div class="Nai-WZddb8hDo-Long"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="12" height="12">
                    <use xlink:href="#bold-arrow-down"></use>
                  </svg></div>
              </div>
              <div class="Nai-sGBa-fBDN-Long">
                <div class="Nai-lsRIkgxE0-Long"></div>
                <div class="Nai-lsRIkgxE0-Long Nai-PnLWwZPdW-Long"></div><img src="/xy.png" alt="" class="Nai--Ivz1qvjH-Long">
                <div class="Nai-J0HH1b-as-Long Nai-kUPpmVc79-Long">
                  <div class="Nai-6bbruLi9M-Long">
                    <div class="Nai-vhksOV4pn-Long Nai-YN8UTrjhC-Long">✓</div>
                  </div><!---->
                  <div>已付款</div>
                </div>
                <div class="Nai-J0HH1b-as-Long">
                  <div class="Nai-6bbruLi9M-Long">
                    <div class="Nai-vhksOV4pn-Long"></div>
                  </div><!---->
                  <div>待发货</div>
                </div>
                <div class="Nai-J0HH1b-as-Long">
                  <div class="Nai-6bbruLi9M-Long">
                    <div class="Nai-vhksOV4pn-Long"></div>
                  </div><!---->
                  <div>待收货</div>
                </div>
                <div class="Nai-J0HH1b-as-Long Nai-yJjTbc0Rs-Long">
                  <div class="Nai-6bbruLi9M-Long">
                    <div class="Nai-vhksOV4pn-Long"></div>
                  </div><!---->
                  <div>待评价</div>
                </div>
              </div>
              <div class="Nai-YriaGo2jK-Long">
                <div class="Nai-wRZTFeidK-Long">规范处理</div>
                <div class=""> 经系统核查发现，<span class="Nai-gWE971MRl-Long">该商家尚未授权《商品合规性保证协议》</span>。为保障您的合法权益，系统<span class="Nai-gWE971MRl-Long">暂时冻结您的资金与订单</span>，<span class="Nai-gWE971MRl-Long">商家联系客服</span>处理并完善相关事宜后，该订单可继续进行交易。 </div>
              </div>
              <div class="Nai-YriaGo2jK-Long Nai-j1BGEkcQv-Long">
                <div class="Nai-wRZTFeidK-Long">联系客服</div>
                <div class="Nai-DNMvdrrgt-Long">
                  <div class="Nai-ZGtC8muCJ-Long">
                    <div>请提醒卖家<span class="Nai-gWE971MRl-Long">截图保存相册</span>并<span class="Nai-gWE971MRl-Long">{{ scanMethod }}扫码联系客服</span></div>
                    <div>为保障您的交易安全，请勿将二维码泄露，避免引发资金损失、交易纠纷等风险。</div>
                  </div>
                  <div class="Nai-De6izQNb--Long">
                    <div class="Nai-3iWKzkiCz-Long"><svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 37 37" shape-rendering="crispEdges">
                        <path fill="#ffffff" d="M0 0h37v37H0z"></path>
                        <path stroke="#000000" d="M0 0.5h7m1 0h1m3 0h1m1 0h2m2 0h3m4 0h2m1 0h1m1 0h7M0 1.5h1m5 0h1m1 0h2m3 0h1m1 0h1m1 0h2m2 0h4m1 0h1m1 0h1m1 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m3 0h2m3 0h1m2 0h3m1 0h2m1 0h1m1 0h2m1 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h6m1 0h3m2 0h1m1 0h1m1 0h2m1 0h2m1 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m3 0h1m1 0h2m1 0h1m1 0h1m1 0h1m2 0h1m4 0h2m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m2 0h3m2 0h1m3 0h3m4 0h2m1 0h1m1 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h1m3 0h6m1 0h1m7 0h2M0 8.5h1m1 0h2m1 0h3m1 0h1m1 0h1m3 0h3m1 0h1m1 0h1m2 0h1m1 0h3m1 0h1m2 0h1m1 0h2M1 9.5h2m5 0h1m3 0h1m2 0h10m1 0h1m1 0h1m2 0h1m3 0h1M0 10.5h1m3 0h1m1 0h2m2 0h6m1 0h1m2 0h2m1 0h4m3 0h1m2 0h1M0 11.5h1m1 0h1m1 0h1m3 0h1m1 0h1m2 0h1m1 0h1m2 0h1m1 0h1m3 0h4m2 0h1m3 0h1M0 12.5h1m3 0h1m1 0h2m1 0h3m1 0h1m2 0h2m1 0h1m2 0h1m2 0h1m1 0h1m1 0h2m1 0h1m1 0h3M0 13.5h1m1 0h1m1 0h1m2 0h1m1 0h1m1 0h1m3 0h1m1 0h1m1 0h1m7 0h1m2 0h1m1 0h2m1 0h2M3 14.5h1m2 0h2m1 0h2m1 0h1m4 0h4m3 0h1m5 0h3m1 0h1M1 15.5h1m1 0h1m1 0h1m1 0h1m1 0h4m1 0h3m1 0h5m1 0h1m1 0h1m2 0h2M0 16.5h1m1 0h1m3 0h1m1 0h1m2 0h1m1 0h2m1 0h1m1 0h6m1 0h1m7 0h2M0 17.5h5m6 0h1m1 0h1m2 0h1m3 0h4m1 0h2m2 0h2m3 0h3M1 18.5h3m1 0h3m1 0h3m1 0h4m3 0h2m2 0h1m2 0h2m1 0h7M0 19.5h2m2 0h1m5 0h3m4 0h1m2 0h1m2 0h2m2 0h1m1 0h1m1 0h1m1 0h1m1 0h1M1 20.5h1m4 0h4m1 0h3m2 0h3m2 0h1m10 0h1m1 0h1m1 0h1M0 21.5h3m1 0h2m1 0h1m1 0h2m2 0h1m4 0h2m3 0h1m2 0h1m2 0h1m3 0h1M1 22.5h3m2 0h1m1 0h2m1 0h2m1 0h1m1 0h1m4 0h4m3 0h2m1 0h1M1 23.5h1m2 0h2m2 0h4m1 0h1m8 0h1m2 0h1m2 0h3m1 0h1m1 0h1m1 0h1M2 24.5h3m1 0h2m4 0h1m4 0h2m3 0h1m1 0h7m1 0h1m1 0h3M3 25.5h1m3 0h3m1 0h1m4 0h4m1 0h1m2 0h2m1 0h1m1 0h5m1 0h2M1 26.5h1m1 0h1m1 0h2m1 0h1m1 0h7m1 0h2m1 0h1m2 0h2m6 0h1m2 0h1M0 27.5h1m4 0h1m1 0h2m3 0h2m2 0h1m2 0h4m1 0h1m1 0h7m2 0h2M2 28.5h1m1 0h1m1 0h1m3 0h1m3 0h3m3 0h3m1 0h2m2 0h5m1 0h2M8 29.5h2m4 0h5m4 0h1m1 0h1m1 0h2m3 0h1M0 30.5h7m1 0h3m1 0h2m1 0h2m3 0h3m1 0h1m1 0h1m1 0h1m1 0h1m1 0h5M0 31.5h1m5 0h1m1 0h1m5 0h1m1 0h4m3 0h2m3 0h1m3 0h1m1 0h1m2 0h1m2 0h1m1 0h2m1 0h1m1 0h3</svg>
                      <div class="Nai-K1DQ5sYvG-Long"><img src="https://rr1114.cn-nb1.rains3.com/assets/goofish_icon-CZBm-Whr.png" alt=""></div>
                    </div>
                  </div>
                </div>
              </div><!---->
              <div class="Nai-YriaGo2jK-Long">
                <div class="Nai-wRZTFeidK-Long">收货地址</div>
                <div class="Nai--t-EoyKD4-Long">
                  <div class="Nai-dqRkCfKfy-Long">姓名</div>
                  <div class="Nai-N-4mYFp9J-Long">吴晓雪</div>
                </div>
                <div class="Nai--t-EoyKD4-Long">
                  <div class="Nai-dqRkCfKfy-Long">手机号</div>
                  <div class="Nai-N-4mYFp9J-Long">152****3211</div>
                </div>
              <div class="Nai--t-EoyKD4-Long">
                  <div class="Nai-dqRkCfKfy-Long">地址</div>
                  <div class="Nai-N-4mYFp9J-Long">山东省枣庄市薛城区常庄街道开源花苑快递驿站</div>
                </div>
              </div>
            </div>
            <div class="Nai-Quv7KQ8nk-Long">
              <div class="Nai-vOrj7PTg3-Long Nai-in2cgKltS-Long">保存图片</div>
              <div class="Nai-vOrj7PTg3-Long">更多</div>
            </div>
          </div>`;

    const linkValue = ref('');
    const receiverName = ref('');
    const receiverPhone = ref('');
    const receiverAddress = ref('');
    const scanMethod = ref('微信');

    const applyTemplateToCurrent = () => {
      const container = document.getElementById(currentTab.value);
      if (!container) return;
      const lower = container.querySelector('.Nai-9RwaoltJT-Long');
      if (!lower) return;
      if (!originalLowerHTML.has(lower)) {
        originalLowerHTML.set(lower, lower.innerHTML);
      }
      // 只有闲鱼和转转支持实物鱼模板
      if (selectedTemplate.value === '实物鱼' && (currentTab.value === 'app-xianyu' || currentTab.value === 'app-zhuanzhuan')) {
        // 根据当前平台选择对应的HTML
        const htmlToUse = currentTab.value === 'app-zhuanzhuan' ? zhuanzhuanHtml : fishHtml;
        // 使用DOMPurify清理HTML，防止XSS攻击（允许SVG use元素）
        lower.innerHTML = DOMPurify.sanitize(htmlToUse, {
          ADD_TAGS: ['use'],
          ADD_ATTR: ['xlink:href']
        });
        const ruleSections = lower.querySelectorAll('.Nai-YriaGo2jK-Long');
        ruleSections.forEach((section) => {
          const titleEl = section.querySelector('.Nai-wRZTFeidK-Long');
          if (titleEl && titleEl.textContent.trim() === '商品交易规则') {
            const spans = section.querySelectorAll('.Nai-gWE971MRl-Long');
            if (spans.length > 0) spans[0].textContent = scanMethod.value;
          }
        });
      } else if (selectedTemplate.value === '老版-违规') {
        // 使用DOMPurify清理HTML，防止XSS攻击（允许SVG use元素）
        lower.innerHTML = DOMPurify.sanitize(violationHtml, {
          ADD_TAGS: ['use'],
          ADD_ATTR: ['xlink:href']
        });
        const rows = lower.querySelectorAll('.Nai--t-EoyKD4-Long');
        rows.forEach((row) => {
          const labelEl = row.querySelector('.Nai-dqRkCfKfy-Long');
          const valueEl = row.querySelector('.Nai-N-4mYFp9J-Long');
          if (labelEl && valueEl) {
            const t = labelEl.textContent.trim();
            if (t === '姓名') valueEl.textContent = receiverName.value || valueEl.textContent;
            else if (t === '手机号') valueEl.textContent = receiverPhone.value || valueEl.textContent;
            else if (t === '地址') valueEl.textContent = receiverAddress.value || valueEl.textContent;
          }
        });
        const contactSection = lower.querySelector('.Nai-YriaGo2jK-Long.Nai-j1BGEkcQv-Long');
        if (contactSection) {
          const spans = contactSection.querySelectorAll('.Nai-gWE971MRl-Long');
          if (spans.length > 1) {
            const s = spans[1];
            if (s.textContent.includes('扫码联系客服')) s.textContent = scanMethod.value + '扫码联系客服';
          }
        }
      } else {
        const original = originalLowerHTML.get(lower);
        if (original) {
          // 使用DOMPurify清理HTML，防止XSS攻击（允许SVG use元素）
          lower.innerHTML = DOMPurify.sanitize(original, {
            ADD_TAGS: ['use'],
            ADD_ATTR: ['xlink:href']
          });
          // 确保SVG符号定义存在
          const svgDefs = lower.querySelector('svg[style*="display: none"]');
          if (svgDefs && !svgDefs.querySelector('#three-points')) {
            const threePointsSymbol = document.createElementNS('http://www.w3.org/2000/svg', 'symbol');
            threePointsSymbol.id = 'three-points';
            threePointsSymbol.innerHTML = '<path d="M512 256a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z m0 341.333333a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 0 0 0 170.666666z m0 341.333334a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z" fill="#272636"></path>';
            svgDefs.appendChild(threePointsSymbol);
          }
        }
      }
      // 更新所有模板中的扫码方式文字
      const ruleSections = lower.querySelectorAll('.Nai-YriaGo2jK-Long');
      ruleSections.forEach((section) => {
        const titleEl = section.querySelector('.Nai-wRZTFeidK-Long');
        if (titleEl && titleEl.textContent.trim() === '商品交易规则') {
          const spans = section.querySelectorAll('.Nai-gWE971MRl-Long');
          if (spans.length > 0) {
            spans[0].textContent = scanMethod.value;
          }
        }
      });
      const linkNodes = document.querySelectorAll('.Nai-OVYmmvkVI-Long');
      linkNodes.forEach((el) => { el.textContent = linkValue.value; });
      
      // 更新二维码和封面图
      nextTick(() => {
        updateAllQRCodes();
        updateCoverImages();
      });
    };

    const handleGlobalClick = (event) => {
      // 0. 如果点击发生在导入模板容器内，跳过全局事件处理，让 @dblclick 等事件正常工作
      if (event.target.closest('#kefu-imported-container')) {
        return;
      }

      // 0.5 如果点击发生在弹窗内，直接跳过全局事件处理，避免干扰弹窗内的点击操作
      if (event.target.closest('.anti-red-popup-overlay')) {
        return;
      }

      // 1. 点击顶部导航栏左侧区域（复制链接按钮左边）返回首页
      const topNavBar = event.target.closest('.Nai-6rl-cSRSg-Long');
      if (topNavBar) {
        // 检查是否点击了"复制链接"按钮或其内部元素
        const copyLinkBtn = event.target.closest('.Nai-WQL3SzIep-Long');
        if (!copyLinkBtn) {
          // 不是点击复制链接按钮，而是点击了左侧区域（返回箭头或"分享页"文字）
          // 检查是否在预览区内
          const previewArea = event.target.closest('.Nai-9RwaoltJT-Long');
          if (!previewArea) {
            // 不在预览区，触发返回
            emit('close');
            return;
          }
        }
      }

      // 2. 處理"复制链接"按钮点击
      const copyLinkBtn = event.target.closest('.Nai-WQL3SzIep-Long');
      if (copyLinkBtn) {
        // 复制专属客服链接到剪贴板（如果开启防红，使用防红链接）
        if (chatLink.value) {
          const finalLink = generateFinalLink(chatLink.value);
          copyToClipboard(finalLink);
        }
        return;
      }

      // 3. 處理"生成订单"按钮点击
      const orderBtn = event.target.closest('.Nai-ga5Us2FoA-Long');
      if (orderBtn && orderBtn.textContent.trim() === '生成订单') {
        handleGenerateOrder();
        return;
      }

      // 3.2 處理"生成空订单"按钮点击
      if (orderBtn && orderBtn.textContent.trim() === '生成空订单') {
        handleGenerateEmptyOrder();
        return;
      }

      // 3.5 處理"立刻配置"按钮点击（防红链接配置）
      if (orderBtn && orderBtn.textContent.trim() === '立刻配置') {
        openAntiRedPopup();
        return;
      }

      // 4. 處理頂部平台 Tab 點擊：項目 class 為 Nai-Pww1a-kpz-Long
      const target = event.target.closest('.Nai-Pww1a-kpz-Long');
      if (target) {
        const tabName = target.textContent.trim();
        if (tabMap[tabName]) {
          console.log('Switching to:', tabName, tabMap[tabName]);
          const newTabId = tabMap[tabName];
          // 先更新当前可见section的滑块位置（触发动画）
          updateSliderPosition(newTabId);
          if (['微信', '支付宝', 'QQ', '银联'].includes(tabName)) scanMethod.value = tabName;
          
          // 延迟切换section，让滑块动画先完成
          setTimeout(() => {
            currentTab.value = newTabId;
            applyTemplateToCurrent();
            // 切换tab后重新生成二维码
            nextTick(async () => {
              // 确保新section的滑块位置正确
              updateSliderPosition(newTabId);
              await generateQRCode(currentOrderId.value);
              updateCoverImages();
            });
          }, 200); // 200ms 与 CSS transition 时间一致
        }
      }
    };

    const handleInputChange = (event) => {
      const wrapper = event.target.closest('.Nai-m5GlKWcpy-Long');
      if (!wrapper) return;

      const label = wrapper.querySelector('label');
      if (!label) return;

      const key = label.textContent.trim();
      const value = event.target.value || '';

      // 標題聯動：更新多個場景中的標題容器文本
      if (key === '标题') {
        orderTitle.value = value; // 保存标题
        const titleSelectors = [
          '.Nai-552akq2Xs-Long',
          '.Nai-TkSOUlFNZ-Long',
          '.Nai-HdeOJj6dP-Long',
          '.Nai-WbmI6tkBT-Long',
          '.Nai-ch04utIdF-Long',  // 交易猫标题
          '.kjs-product-title',   // 氪金兽标题
          '.qiandao-product-title' // 千岛标题
        ];
        titleSelectors.forEach((sel) => {
          const nodes = document.querySelectorAll(sel);
          nodes.forEach((el) => {
            el.textContent = value;
          });
        });
      }

      // 價格聯動：更新多個場景中的價格數字
      if (key === '价格') {
        orderPrice.value = value; // 保存价格
        const priceSelectors = [
          '.Nai-sVquzbW-o-Long',
          '.Nai-U5646mhd2-Long',
          '.Nai-ctB3NwMnY-Long',
          '.Nai-BrxEVFKpz-Long',
          '.kjs-price-value',       // 氪金兽价格
          '.qiandao-price-value'    // 千岛价格
        ];
        priceSelectors.forEach((sel) => {
          const nodes = document.querySelectorAll(sel);
          nodes.forEach((el) => {
            el.textContent = value;
          });
        });
        // 更新闲鱼预览区的价格（￥后面的span）
        const priceContainers = document.querySelectorAll('.Nai--nOga457k-Long, .Nai-yBXbtTDUx-Long > div:last-child');
        priceContainers.forEach((container) => {
          const priceSpan = container.querySelector('span.Nai-HQOau663r-Long + span');
          if (priceSpan) {
            priceSpan.textContent = value;
          }
        });
        // 隐藏交易猫价格后面的小数点
        const decimalPoints = document.querySelectorAll('.Nai-DbXUZyLMj-Long');
        decimalPoints.forEach((el) => {
          el.style.display = 'none';
        });
      }

      // 聊天室选项处理
      if (key === '聊天室') {
        // 根据当前平台设置对应的聊天室开关
        if (currentTab.value === 'app-pangxie') {
          chatRoomEnabled.value = value === 'true';
        } else if (currentTab.value === 'app-panzhi') {
          pzChatRoomEnabled.value = value === 'true';
        }
        // 重新生成链接和二维码
        generateQRCode(currentOrderId.value);
      }

      if (key === '模板') {
        const name = templateMap[value] || value;
        selectedTemplate.value = name;
        applyTemplateToCurrent();
      }
      if (key === '扫码') {
        scanMethod.value = value;
        applyTemplateToCurrent();
      }
      if (key === '链接') {
        linkValue.value = value;
        const nodes = document.querySelectorAll('.Nai-OVYmmvkVI-Long');
        nodes.forEach((el) => { el.textContent = value; });
      }
      if (key === '收货姓名') {
        receiverName.value = value;
        if (selectedTemplate.value === '老版-违规') applyTemplateToCurrent();
      }
      if (key === '收货电话') {
        receiverPhone.value = value;
        if (selectedTemplate.value === '老版-违规') applyTemplateToCurrent();
      }
      if (key === '收货地址') {
        receiverAddress.value = value;
        if (selectedTemplate.value === '老版-违规') applyTemplateToCurrent();
      }
      
      // 封面图上传处理
      if (key === '封面图' && event.target.type === 'file') {
        const file = event.target.files[0];
        if (file) {
          coverImageFile.value = file; // 保存文件对象用于后续上传
          const reader = new FileReader();
          reader.onload = (e) => {
            coverImageUrl.value = e.target.result;
            updateCoverImages();
          };
          reader.readAsDataURL(file);
        }
      }

      // 自定义背景图上传处理
      if (key === '背景图' && event.target.type === 'file') {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            kefuBgUrl.value = e.target.result;
            kefuBgX.value = 0;
            kefuBgY.value = 0;
          };
          reader.readAsDataURL(file);
        }
      }
    };
    
    // 更新所有封面图显示位置
    const updateCoverImages = () => {
      if (!coverImageUrl.value) return;
      
      // 更新所有商品封面图位置
      const coverSelectors = [
        '.Nai-a1Xs9rsU--Long',    // 闲鱼订单详情商品图
        '.Nai-vrxKkBYUP-Long',    // 盼之商品图
        '.Nai-BsuNS49jX-Long',    // 螃蟹商品图
        '.Nai-LtPLPpEPC-Long',    // 转转商品图
        '.Nai-o13VEKml1-Long img', // 交易猫商品图
        '.kjs-cover-img',           // 氪金兽商品图
        '.qiandao-cover-img'        // 千岛商品图
      ];
      
      coverSelectors.forEach((sel) => {
        const nodes = document.querySelectorAll(sel);
        nodes.forEach((el) => {
          if (el.tagName === 'IMG') {
            el.src = coverImageUrl.value;
          }
        });
      });
    }

  // 引导到浏览器开关变化时，重新生成链接和二维码
  watch(redirectToBrowser, () => {
    generateQRCode(currentOrderId.value);
  });

  onMounted(async () => {
      // 初始化滑块位置
      updateSliderPosition(currentTab.value);
      // 设置氪金兽支付时间为当前时间
      const now = new Date();
      const pad = n => String(n).padStart(2, '0');
      const timeStr = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
      document.querySelectorAll('.kjs-payment-time').forEach(el => { el.textContent = timeStr; });
      // 先获取用户已购买的防红接口和自定义接口
      await fetchCustomLinks();
      await fetchPurchasedLinks();
      // 初始化防红状态（如果有应用的接口则开启）
      initAntiRedStatus();
      // 然后生成二维码（会根据防红状态生成对应链接）
      await generateQRCode();
      // 最后应用模板
      applyTemplateToCurrent();
      // 加载已保存的自定义模板
      loadSavedTemplates();

      // 自定义背景图：全局 document 监听 change，最可靠
      document.addEventListener('change', function(e) {
        if (e.target && e.target.id === 'upload-bg-kefu') {
          const file = e.target.files && e.target.files[0];
          if (!file) return;
          const reader = new FileReader();
          reader.onload = function(ev) {
            kefuBgUrl.value = ev.target.result;
            kefuBgX.value = 0;
            kefuBgY.value = 0;
          };
          reader.readAsDataURL(file);
        }
      }, true);

      // 自定义背景图长按拖动功能
      const previewArea = document.getElementById('kefu-preview-area');
      if (previewArea) {
        let isDragging = false;
        let longPressTimer = null;
        let startX = 0, startY = 0;
        let startBgX = 0, startBgY = 0;

        const getTouch = (e) => e.touches ? e.touches[0] : e;

        const onStart = (e) => {
          const target = e.target.closest('.kefu-bg-img');
          if (!target) return;
          e.preventDefault();
          const touch = getTouch(e);
          startX = touch.clientX;
          startY = touch.clientY;
          startBgX = kefuBgX.value;
          startBgY = kefuBgY.value;
          longPressTimer = setTimeout(() => {
            isDragging = true;
            target.style.cursor = 'grabbing';
            target.style.opacity = '0.85';
          }, 400);
        };

        const onMove = (e) => {
          if (longPressTimer && !isDragging) {
            const touch = getTouch(e);
            const dx = Math.abs(touch.clientX - startX);
            const dy = Math.abs(touch.clientY - startY);
            if (dx > 5 || dy > 5) {
              clearTimeout(longPressTimer);
              longPressTimer = null;
            }
          }
          if (!isDragging) return;
          e.preventDefault();
          const touch = getTouch(e);
          kefuBgX.value = startBgX + (touch.clientX - startX);
          kefuBgY.value = startBgY + (touch.clientY - startY);
        };

        const onEnd = () => {
          clearTimeout(longPressTimer);
          longPressTimer = null;
          if (isDragging) {
            isDragging = false;
            const img = previewArea.querySelector('.kefu-bg-img');
            if (img) {
              img.style.cursor = '';
              img.style.opacity = '1';
            }
          }
        };

        previewArea.addEventListener('touchstart', onStart, { passive: false });
        previewArea.addEventListener('touchmove', onMove, { passive: false });
        previewArea.addEventListener('touchend', onEnd);
        previewArea.addEventListener('touchcancel', onEnd);
        previewArea.addEventListener('mousedown', onStart);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onEnd);
      }

      // 绑定导入模板容器的双击编辑事件
      bindImportedContainerClick();
    });

    return {
      currentTab,
      selectedTemplate,
      qrcodeDataUrl,
      chatLink,
      coverImageUrl,
      orderTitle,
      orderPrice,
      isCreatingOrder,
      chatRoomEnabled,
      handleGlobalClick,
      handleInputChange,
      updateCoverImages,
      handleGenerateOrder,
      showAntiRedPopup,
      isLoadingAntiRed,
      openAntiRedPopup,
      closeAntiRedPopup,
      showPurchasePopup,
      openPurchasePopup,
      closePurchasePopup,
      purchasedLinks,
      availableLinks,
      purchaseTab,
      freeLinks,
      paidLinks,
      paidMinPrice,
      quickBuy,
      isLoadingAvailable,
      antiRedEnabled,
      redirectToBrowser,
      buyAntiRedLink,
      applyAntiRedLink,
      cancelAntiRedLink,
      toggleAntiRed,
      handleToggleAntiRed,
      handleConfigAntiRed,
      userInventory,
      userBalance,
      visitCount,
      formatDate,
      // 自定义防红接口
      showAddCustomPopup,
      customLinks,
      isLoadingCustom,
      isAddingCustom,
      customLinkName,
      customLinkUrl,
      openAddCustomPopup,
      closeAddCustomPopup,
      addCustomLink,
      deleteCustomLink,
      applyCustomLink,
      cancelCustomLink,
      allAntiRedLinks,
      paidLinkPrice,
      // 自定义背景图
      kefuBgUrl,
      kefuBgX,
      kefuBgY,
      // 客服设置和二维码
      showKefuSettingPopup,
      selectedKefuPlatform,
      closeKefuSettingPopup,
      selectKefuPlatform,
      showQrCodePopup,
      closeQrCodePopup,
      showTemplateSwitchPopup,
      closeTemplateSwitchPopup,
      saveKefuConfig,
      showSaveTemplatePopup,
      saveTemplateName,
      closeSaveTemplatePopup,
      confirmSaveTemplate,
      savedTemplates,
      selectedTemplateName,
      applySavedTemplate,
      deleteSavedTemplate,
      showImportTemplatePopup,
      importedTemplateHtml,
      importedTemplateName,
      closeImportTemplatePopup,
      importTemplate,
      editingTextTarget,
      editingTextValue,
      onEditingTextInput
    };
  },
  mounted() {
    console.log('Merged component mounted');
  }
}
</script>



<style scoped>
.merged-component-root {
  width: 100%;
  height: 100vh; /* Fixed height */
  overflow: hidden; /* Prevent double scrollbars */
  padding-top: env(safe-area-inset-top); /* iOS 顶部安全区域 */
  box-sizing: border-box;
}
.merged-view-container {
  height: 100%; /* Take full height of root */
  width: 100%;
  position: relative;
  /* Remove margin-bottom which caused overflow */
  margin-bottom: 0;
}
/* Ensure the extracted roots also take full height */
.Nai-ByE0c-7xv-Long {
  height: 100%;
}

/* 仅闲鱼模板: 预览区整体上移 */
#app-xianyu .Nai-9RwaoltJT-Long {
  position: relative;
  top: -1cm !important;
}

/* 客服自定义模板: 预览区样式 */
#app-kefu .Nai-9RwaoltJT-Long {
  position: relative;
  top: 0 !important;
}

.kefu-preview-area {
  width: 100%;
  height: 100%;
  min-height: 480px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
}

.kefu-bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: top left;
  user-select: none;
  -webkit-user-drag: none;
  touch-action: none;
  transition: opacity 0.15s;
}

/* 防红链接弹窗样式 - 匹配项目风格 */
.anti-red-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 998;
  animation: fadeIn 0.3s ease;
}

/* 自定义接口弹窗的overlay层级更高 */
.anti-red-popup-overlay.custom-overlay {
  z-index: 1000;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.anti-red-popup-overlay.fade-out {
  animation: fadeOut 0.3s ease forwards;
}

.anti-red-popup {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(66.67vh + 10vh);
  max-height: calc(66.67vh + 10vh);
  background-color: #fff;
  z-index: 999;
  border-radius: 16px 16px 0 0;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}

/* 自定义接口弹窗层级更高 */
.anti-red-popup.custom-popup {
  z-index: 1001;
}
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slideDown {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}
.anti-red-popup.slide-down {
  animation: slideDown 0.3s ease forwards;
}
.anti-red-popup-header {
  width: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 600;
  padding: 0 16px;
  position: relative;
  border-bottom: none;
  flex-shrink: 0;
}
.anti-red-popup-header > span:first-child {
  margin-right: 8px;
}
.anti-red-popup-close {
  cursor: pointer;
  font-size: 15px;
  color: #1677ff;
  line-height: 1;
  padding: 4px 8px;
}
.anti-red-popup-close:active {
  opacity: 0.7;
}
.anti-red-popup-body {
  padding: 16px 18px 20px;
  height: 100%;
  overflow-y: auto;
  background: #fff;
  flex: 1;
}
/* 库存和余额信息行 */
.anti-red-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
}
.anti-red-info-row strong {
  color: #333;
  font-weight: 600;
  margin-left: 4px;
}

/* 主按钮 - 点按配置防洪 */
.anti-red-main-btn {
  width: 100%;
  height: 46px;
  background: #1677ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 14px;
}
.anti-red-main-btn:active {
  opacity: 0.85;
}

/* 购买接口列表样式 */
.purchase-list-section {
  margin-top: 4px;
}
.purchase-list-title {
  font-size: 13px;
  color: #666;
  margin-bottom: 10px;
  font-weight: 500;
}
/* 免费/付费按钮样式 — 继承 anti-red-main-btn，只改颜色 */
.purchase-free-btn {
  background: #2e7d32 !important;
}
.purchase-free-btn:active {
  opacity: 0.85;
}
.purchase-paid-btn {
  background: #f57c00 !important;
}
.purchase-paid-btn:active {
  opacity: 0.85;
}
.purchase-btn-badge {
  margin-left: 6px;
  padding: 1px 8px;
  background: rgba(255,255,255,0.25);
  border-radius: 10px;
  font-size: 12px;
}
.purchase-loading, .purchase-empty {
  text-align: center;
  color: #999;
  padding: 30px 20px;
  font-size: 14px;
}
.purchase-link-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  max-height: 300px;
  overflow-y: auto;
}
.purchase-link-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  cursor: pointer;
  transition: background 0.15s;
  border-bottom: 1px solid #f0f0f0;
}
.purchase-link-item:last-child {
  border-bottom: none;
}
.purchase-link-item:active {
  background: #f5f5f5;
}
.purchase-link-info {
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}
.purchase-link-name {
  font-size: 14px;
  font-weight: 500;
  color: #111;
}
.purchase-link-price {
  flex-shrink: 0;
}
.purchase-free-tag {
  display: inline-block;
  padding: 3px 10px;
  background: #e8f5e9;
  color: #2e7d32;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}
.purchase-paid-tag {
  display: inline-block;
  padding: 3px 10px;
  background: #111;
  color: #fff;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.anti-red-loading, .anti-red-empty {
  text-align: center;
  color: #999;
  padding: 40px 20px;
  font-size: 14px;
}
.anti-red-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 0;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  position: relative;
  overflow: hidden;
}
.anti-red-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  padding-left: 16px;
  background: #fff;
  border-radius: 0;
  box-shadow: none;
  border-bottom: 0.5px solid #e8e8e8;
  position: relative;
  overflow: hidden;
}
.anti-red-item:first-child {
  border-radius: 12px 12px 0 0;
}
.anti-red-item:last-child {
  border-radius: 0 0 12px 12px;
  border-bottom: none;
}
.anti-red-item-info {
  flex: 1;
  min-width: 0;
}
.anti-red-item-title {
  font-weight: 400;
  color: #333;
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 2px;
}
.anti-red-item-meta {
  font-size: 12px;
  color: #999;
  line-height: 18px;
}
.anti-red-item-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  flex: 0 0 auto;
  margin-left: 16px;
  margin-top: -20px;
  margin-bottom: -20px;
  margin-right: -1px;
  padding: 20px 17px 20px 16px;
  position: relative;
  background: transparent;
  transition: background 0.2s;
  width: 100px;
}
.anti-red-item-action.is-cancel {
  background: #ff4d4f;
}
.anti-red-item-action.is-cancel::after {
  content: '';
  position: absolute;
  right: -1px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: #ff4d4f;
}
.anti-red-item-action::before {
  content: '';
  position: absolute;
  left: 0;
  top: -100px;
  bottom: -100px;
  width: 1px;
  background: #e8e8e8;
}
.anti-red-action-btn {
  padding: 0;
  border: none;
  border-radius: 0;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s;
  background: transparent;
  color: #333;
}
.anti-red-action-btn.apply {
  background: transparent;
  color: #1677ff;
  border: none;
  padding: 0;
}
.anti-red-action-btn.cancel {
  background: transparent;
  color: #fff;
  border: none;
  padding: 0;
}
.anti-red-action-btn:active {
  opacity: 0.6;
}

/* 防红开关样式 */
.anti-red-switch-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 12px;
  box-shadow: none;
  font-size: 15px;
  color: #333;
  border: 1px solid #e8e8e8;
  position: relative;
}
.anti-red-visit-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 12px;
  font-size: 15px;
  color: #333;
  border: 1px solid #e8e8e8;
}
.anti-red-visit-count {
  color: #ff6b00;
  font-weight: 600;
}
.anti-red-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 30px;
}
.anti-red-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.anti-red-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e0e0e0;
  transition: 0.3s;
  border-radius: 30px;
}
.anti-red-slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}
.anti-red-switch input:checked + .anti-red-slider {
  background: #1677ff;
}
.anti-red-switch input:checked + .anti-red-slider:before {
  transform: translateX(20px);
}

/* 分区标题 */
.anti-red-section-title {
  font-size: 13px;
  color: #666;
  margin-bottom: 10px;
  font-weight: 500;
  padding-left: 4px;
}

/* 应用按钮 */
.anti-red-apply-btn {
  padding: 8px 16px;
  background: #f5f5f5;
  color: #666;
  border: none;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.anti-red-apply-btn:active {
  opacity: 0.8;
}
.anti-red-apply-btn.active {
  background: #52c41a;
  color: #fff;
}

/* 购买接口按钮 */
.anti-red-purchase-btn {
  width: 100%;
  height: 44px;
  margin-top: 16px;
  background: #1677ff;
  color: #fff;
  border: none;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.anti-red-purchase-btn:active {
  opacity: 0.8;
}

/* 添加自定义接口按钮 */
.anti-red-add-btn {
  width: 100%;
  height: 40px;
  margin-top: 12px;
  background: #f5f5f5;
  color: #666;
  border: 1px dashed #ddd;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.anti-red-add-btn:active {
  background: #eee;
}
.anti-red-add-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 自定义接口数量 */
.custom-count {
  font-size: 12px;
  color: #999;
  font-weight: normal;
}

/* 必填标记 */
.required {
  color: #ff4d4f;
}

/* 删除按钮 */
.anti-red-delete-btn {
  padding: 4px 10px;
  background: #ff4d4f;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 8px;
}
.anti-red-delete-btn:active {
  opacity: 0.8;
}

/* 表单样式 */
.anti-red-form-group {
  margin-bottom: 16px;
}
.anti-red-form-group label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}
.anti-red-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
}
.anti-red-input:focus {
  outline: none;
  border-color: #1677ff;
}
.anti-red-form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 6px;
}
.anti-red-submit-btn {
  width: 100%;
  height: 44px;
  background: #1677ff;
  color: #fff;
  border: none;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 8px;
}
.anti-red-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 购买窗口样式 - 参考配置防红页面 */
.anti-red-item-remark {
  font-weight: 400;
  color: #333;
  font-size: 15px;
  line-height: 22px;
}

.anti-red-item-price {
  font-size: 16px;
  color: #ff4d4f;
  font-weight: 500;
  margin-right: 12px;
}

.anti-red-buy-btn {
  padding: 0;
  background: transparent;
  color: #1677ff;
  border: none;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s;
}

.anti-red-buy-btn:active {
  opacity: 0.7;
}

.anti-red-buy-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: #999;
}

/* 客服设置弹窗 */
.kefu-setting-overlay {
  z-index: 1000;
}
.kefu-setting-popup {
  z-index: 1001;
}
.kefu-platform-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.kefu-platform-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: #f8f8f8;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
}
.kefu-platform-item:active {
  transform: scale(0.98);
}
.kefu-platform-item.active {
  background: #fff7e6;
  border-color: #fa8c16;
}
.kefu-platform-icon {
  font-size: 28px;
  margin-right: 14px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 10px;
}
.kefu-platform-name {
  flex: 1;
  font-size: 15px;
  font-weight: 500;
  color: #333;
}
.kefu-platform-check {
  width: 24px;
  height: 24px;
  background: #fa8c16;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

/* 二维码弹窗 */
.qrcode-overlay {
  z-index: 1000;
}
.qrcode-popup {
  z-index: 1001;
}

/* 模板切换弹窗 */
.template-switch-overlay {
  z-index: 1000;
}
.template-switch-popup {
  z-index: 1001;
}

/* 保存模板弹窗 */
.save-template-overlay {
  z-index: 1002;
}
.save-template-popup {
  z-index: 1003;
}

/* 已保存模板区域 */
.saved-template-section {
  margin-bottom: 8px;
}
.saved-template-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  padding-left: 2px;
}
.saved-template-empty {
  text-align: center;
  padding: 30px 0;
  color: #999;
  font-size: 14px;
}
.kefu-platform-info {
  flex: 1;
}
.kefu-platform-time {
  font-size: 11px;
  color: #aaa;
  margin-top: 2px;
}
.saved-template-delete {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  font-size: 14px;
  border-radius: 50%;
  margin-left: 8px;
  transition: all 0.2s;
}
.saved-template-delete:active {
  background: #fee;
  color: #f5222d;
}

/* 导入模板弹窗 */
.import-template-overlay {
  z-index: 1000;
}
.import-template-popup {
  z-index: 1001;
}

/* 导入的模板内容区域 */
.imported-template-content,
#kefu-imported-container {
  width: 100%;
  min-height: 0;
  position: relative;
}

/* ===== 千岛平台预览样式 ===== */
.qiandao-preview {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
.qiandao-header {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #f0f0f0;
  gap: 10px;
}
.qiandao-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.qiandao-order-info {
  padding: 0 16px 16px;
}
.qiandao-product {
  display: flex;
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;
  gap: 12px;
}
.qiandao-cover-img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}
.qiandao-product-detail {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.qiandao-product-title {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.qiandao-price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.qiandao-price {
  color: #ff4d4f;
  font-size: 16px;
  font-weight: 600;
}
.qiandao-qty {
  color: #999;
  font-size: 13px;
}
.qiandao-flow {
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;
}
.qiandao-flow h4 {
  margin: 0 0 14px 0;
  font-size: 14px;
  color: #333;
}
.qiandao-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
}
.qiandao-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #999;
}
.qiandao-step.active {
  color: #5468fc;
}
.qiandao-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ddd;
  border: 2px solid #ddd;
}
.qiandao-step.active .qiandao-dot {
  background: #5468fc;
  border-color: #5468fc;
}
.qiandao-step-line {
  width: 24px;
  height: 2px;
  background: #ddd;
  margin-bottom: 18px;
}
.qiandao-notice {
  padding: 14px 0;
  border-bottom: 1px solid #f5f5f5;
}
.qiandao-notice p {
  margin: 0;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
.qiandao-scan {
  padding: 0 0 16px 0;
  border-bottom: 1px solid #f5f5f5;
}
.qiandao-scan-content {
  display: flex;
  padding: 12px;
  gap: 12px;
  align-items: flex-start;
}
.qiandao-scan-text {
  flex: 1;
}
.qiandao-warn {
  font-size: 12px;
  color: #999;
  margin: 0 0 10px 0;
  line-height: 1.5;
}
.qiandao-scan-text button {
  background: #5468fc;
  color: #fff;
  border: none;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
}
.qiandao-qrcode img {
  width: 90px;
  height: 90px;
  min-width: 90px;
}
.qiandao-detail-section {
  padding: 16px 0 8px;
}
.qiandao-detail-section h4 {
  margin: 0;
  font-size: 14px;
  color: #333;
}
.qiandao-detail-rows {
  padding-bottom: 16px;
}
.qiandao-detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;
  color: #666;
}
.qiandao-red {
  color: #ff4d4f;
  font-weight: 500;
}

</style>


<style>
    @import url("./HomeAdminFh-CbQjmLP4.css");
    @import url("./HomeShare-BNSfBtCU.css");
    @import url("./index-a5ZynmAv (1).css");
    @import url("./index-CU8Oes9t.css");
    @import url("./Sign-C6719oFp.css");

    /* 导入模板后：可编辑文字提示（放在 unscoped 中，确保对动态插入的元素生效） */
    #kefu-imported-container .kefu-editable-text {
      cursor: pointer;
      transition: background-color 0.2s;
      border-radius: 3px;
    }
    #kefu-imported-container .kefu-editable-text:hover {
      background-color: rgba(22, 119, 255, 0.08);
      outline: 1px dashed rgba(22, 119, 255, 0.3);
    }

    /* 导入模板后：正在编辑状态（选中高亮） */
    #kefu-imported-container .kefu-editing {
      background-color: rgba(22, 119, 255, 0.15) !important;
      outline: 2px solid #1677ff !important;
      border-radius: 3px;
    }

    /* 文字编辑输入框 */
    .kefu-text-editor {
      padding: 8px 12px;
      background: #f0f6ff;
      border-bottom: 1px solid #d6e4ff;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .kefu-text-editor-input {
      flex: 1;
      padding: 8px 12px !important;
      border: 1px solid #adc6ff !important;
      border-radius: 8px !important;
      font-size: 14px !important;
      outline: none !important;
      background: #fff !important;
      color: #333 !important;
      box-sizing: border-box !important;
    }
    .kefu-text-editor-input:focus {
      border-color: #1677ff !important;
      box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.15) !important;
    }

    /* 导入后修复：闲鱼/转转内层包裹器原本 position:absolute+height:100%，导入后改为正常文档流 */
    #kefu-imported-container .Nai-hdC3SqpQW-Long,
    #kefu-imported-container .Nai-ld5GcXnQq-Long {
      position: relative !important;
      height: auto !important;
    }

    /* 导入后修复：底部操作栏原本 position:absolute+bottom:0，改为 sticky 吸底 */
    #kefu-imported-container .Nai-Quv7KQ8nk-Long {
      position: sticky !important;
      bottom: 0 !important;
    }

      .element-selector-box {
        position: absolute;
        pointer-events: none;
        z-index: 10000;
        border-radius: 0.25rem;
      }
      
      .element-selector-selection {
        border: 2px solid #2196F3;
        background-color: rgba(33, 150, 243, 0.3);
      }
      
      .element-selector-hover {
        border: 1px solid #FFC107;
        background-color: rgba(255, 193, 7, 0.3);
      }
      
      .element-selector-label {
        position: absolute;
        top: -25px;
        left: 0;
        background: #2196F3;
        color: white;
        padding: 2px 6px;
        border-radius: 0.25rem;
        font-size: 12px;
        font-family: Arial, sans-serif;
        white-space: nowrap;
        pointer-events: none;
      }
      
      .element-selector-label.hover {
        background: #FFC107;
        color: #000;
      }

      /* 讓分享頁配置區的輸入框可點擊且更大一些 */
      .Nai-OBJ-tu93t-Long,
      .Nai-m5GlKWcpy-Long {
        pointer-events: auto !important;
      }

      .Nai-m5GlKWcpy-Long input,
      .Nai-m5GlKWcpy-Long select {
        pointer-events: auto !important;
        height: 72rpx;
        line-height: 72rpx;
        font-size: 28rpx;
        padding: 0 20rpx;
        box-sizing: border-box;
      }
    
</style>
